/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/ (window.theme = window.theme || {}),
  (window.Shopify = window.Shopify || {}),
  (theme.config = {
    bpSmall: !1,
    hasSessionStorage: !0,
    hasLocalStorage: !0,
    mediaQuerySmall: "screen and (max-width: 769px)",
    youTubeReady: !1,
    vimeoReady: !1,
    vimeoLoading: !1,
    isTouch:
      !!(
        "ontouchstart" in window ||
        (window.DocumentTouch && window.document instanceof DocumentTouch)
      ) ||
      !!window.navigator.maxTouchPoints ||
      !!window.navigator.msMaxTouchPoints,
    stickyHeader: !1,
    rtl: "rtl" == document.documentElement.getAttribute("dir"),
  }),
  theme.config.isTouch &&
    (document.documentElement.className += " supports-touch"),
  console &&
    console.log &&
    console.log(
      "Impulse theme (" +
        theme.settings.themeVersion +
        ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
    ),
  (theme.recentlyViewed = { recent: {}, productInfo: {} }),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 4),
  (function () {
    "use strict";
    var e, t, i, n, r, o;
    if (
      ((theme.delegate = {
        on: function (e, t, i) {
          return (
            this.namespaces || (this.namespaces = {}),
            (this.namespaces[e] = t),
            (i = i || !1),
            this.addEventListener(e.split(".")[0], t, i),
            this
          );
        },
        off: function (e) {
          if (this.namespaces)
            return (
              this.removeEventListener(e.split(".")[0], this.namespaces[e]),
              delete this.namespaces[e],
              this
            );
        },
      }),
      (window.on = Element.prototype.on = theme.delegate.on),
      (window.off = Element.prototype.off = theme.delegate.off),
      (theme.utils = {
        defaultTo: function (e, t) {
          return null == e || e != e ? t : e;
        },
        wrap: function (e, t) {
          e.parentNode.insertBefore(t, e), t.appendChild(e);
        },
        debounce: function (e, t, i) {
          var n;
          return function () {
            var r = this,
              o = arguments,
              a = function () {
                (n = null), i || t.apply(r, o);
              },
              s = i && !n;
            clearTimeout(n), (n = setTimeout(a, e)), s && t.apply(r, o);
          };
        },
        throttle: function (e, t) {
          var i = !1;
          return function () {
            i ||
              (t.apply(this, arguments),
              (i = !0),
              setTimeout(function () {
                i = !1;
              }, e));
          };
        },
        prepareTransition: function (e, t) {
          function i(t) {
            e.classList.remove("is-transitioning"),
              e.removeEventListener("transitionend", i);
          }
          e.addEventListener("transitionend", i),
            e.classList.add("is-transitioning"),
            e.offsetWidth,
            "function" == typeof t && t();
        },
        compact: function (e) {
          for (
            var t = -1, i = null == e ? 0 : e.length, n = 0, r = [];
            ++t < i;

          ) {
            var o = e[t];
            o && (r[n++] = o);
          }
          return r;
        },
        serialize: function (e) {
          var t = [];
          return (
            Array.prototype.slice.call(e.elements).forEach(function (e) {
              if (
                !(
                  !e.name ||
                  e.disabled ||
                  ["file", "reset", "submit", "button"].indexOf(e.type) > -1
                )
              ) {
                if ("select-multiple" === e.type) {
                  Array.prototype.slice.call(e.options).forEach(function (i) {
                    i.selected &&
                      t.push(
                        encodeURIComponent(e.name) +
                          "=" +
                          encodeURIComponent(i.value)
                      );
                  });
                  return;
                }
                (!(["checkbox", "radio"].indexOf(e.type) > -1) || e.checked) &&
                  t.push(
                    encodeURIComponent(e.name) +
                      "=" +
                      encodeURIComponent(e.value)
                  );
              }
            }),
            t.join("&")
          );
        },
      }),
      (theme.a11y = {
        trapFocus: function (e) {
          var t = {
              focusin: e.namespace ? "focusin." + e.namespace : "focusin",
              focusout: e.namespace ? "focusout." + e.namespace : "focusout",
              keydown: e.namespace
                ? "keydown." + e.namespace
                : "keydown.handleFocus",
            },
            i = e.container.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ),
            n = [].slice.call(i).filter((e) => null !== e.offsetParent),
            r = n[0],
            o = n[n.length - 1];
          e.elementToFocus || (e.elementToFocus = e.container),
            e.container.setAttribute("tabindex", "-1"),
            e.elementToFocus.focus(),
            document.documentElement.off("focusin"),
            document.documentElement.on(t.focusout, function () {
              document.documentElement.off(t.keydown);
            }),
            document.documentElement.on(t.focusin, function (e) {
              (e.target === o || e.target === r) &&
                document.documentElement.on(t.keydown, function (e) {
                  var t;
                  (t = e),
                    9 === t.keyCode &&
                      t.target === r &&
                      t.shiftKey &&
                      (t.preventDefault(), o.focus());
                });
            });
        },
        removeTrapFocus: function (e) {
          var t = e.namespace ? "focusin." + e.namespace : "focusin";
          e.container && e.container.removeAttribute("tabindex"),
            document.documentElement.off(t);
        },
        lockMobileScrolling: function (e, t) {
          var i = t || document.documentElement;
          document.documentElement.classList.add("lock-scroll"),
            i.on("touchmove" + e, function () {
              return !0;
            });
        },
        unlockMobileScrolling: function (e, t) {
          document.documentElement.classList.remove("lock-scroll"),
            (t || document.documentElement).off("touchmove" + e);
        },
      }),
      document.documentElement.on("keyup.tab", function (e) {
        9 === e.keyCode &&
          (document.documentElement.classList.add("tab-outline"),
          document.documentElement.off("keyup.tab"));
      }),
      (theme.Currency =
        ((e = theme && theme.settings && theme.settings.superScriptPrice),
        {
          formatMoney: function t(i, n) {
            n || (n = theme.settings.moneyFormat),
              "string" == typeof i && (i = i.replace(".", ""));
            var r = "",
              o = /\{\{\s*(\w+)\s*\}\}/,
              a = n || "${{amount}}";
            function s(e, t, i, n) {
              if (
                ((t = theme.utils.defaultTo(t, 2)),
                (i = theme.utils.defaultTo(i, ",")),
                (n = theme.utils.defaultTo(n, ".")),
                isNaN(e) || null == e)
              )
                return 0;
              var r,
                o = (e = (e / 100).toFixed(t)).split(".");
              return (
                o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
                (o[1] ? n + o[1] : "")
              );
            }
            switch (a.match(o)[1]) {
              case "amount":
                (r = s(i, 2)),
                  e &&
                    r &&
                    r.includes(".") &&
                    (r = r.replace(".", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals":
                r = s(i, 0);
                break;
              case "amount_with_comma_separator":
                (r = s(i, 2, ".", ",")),
                  e &&
                    r &&
                    r.includes(".") &&
                    (r = r.replace(",", "<sup>") + "</sup>");
                break;
              case "amount_no_decimals_with_comma_separator":
                r = s(i, 0, ".", ",");
                break;
              case "amount_no_decimals_with_space_separator":
                r = s(i, 0, " ");
            }
            return a.replace(o, r);
          },
          getBaseUnit: function e(t) {
            if (
              t &&
              t.unit_price_measurement &&
              t.unit_price_measurement.reference_value
            )
              return 1 === t.unit_price_measurement.reference_value
                ? t.unit_price_measurement.reference_unit
                : t.unit_price_measurement.reference_value +
                    t.unit_price_measurement.reference_unit;
          },
        })),
      (theme.Images = {
        imageSize: function e(t) {
          if (!t) return "620x";
          var i = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== i ? i[1] : null;
        },
        getSizedImageUrl: function e(t, i) {
          if (!t || null == i) return t;
          if ("master" === i) return this.removeProtocol(t);
          var n = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != n) {
            var r = t.split(n[0]),
              o = n[0];
            return this.removeProtocol(r[0] + "_" + i + o);
          }
          return null;
        },
        removeProtocol: function e(t) {
          return t.replace(/http(s)?:/, "");
        },
        lazyloadImagePath: function e(t) {
          var i;
          return null !== t && (i = t.replace(/(\.[^.]*)$/, "_{width}x$1")), i;
        },
      }),
      (theme.loadImageSection = function (e) {
        function t() {
          e.classList.remove("loading", "loading--delayed"),
            e.classList.add("loaded");
        }
        function i() {
          return e.querySelector(".lazyloaded");
        }
        if (e.querySelector("svg") || i()) {
          t();
          return;
        }
        var n = setInterval(function () {
          i() && (clearInterval(n), t());
        }, 25);
      }),
      (theme.initWhenVisible = function (e) {
        var t = e.threshold ? e.threshold : 0;
        new IntersectionObserver(
          (t, i) => {
            t.forEach((t) => {
              t.isIntersecting &&
                "function" == typeof e.callback &&
                (e.callback(), i.unobserve(t.target));
            });
          },
          { rootMargin: "0px 0px " + t + "px 0px" }
        ).observe(e.element);
      }),
      (theme.LibraryLoader =
        ((i = { requested: "requested", loaded: "loaded" }),
        (n = "https://cdn.shopify.com/shopifycloud/"),
        (r = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: (t = { link: "link", script: "script" }).script,
          },
          vimeo: {
            tagId: "vimeo-api",
            src: "https://player.vimeo.com/api/player.js",
            type: t.script,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: n + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: t.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: t.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: n + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        }),
        {
          load: function e(n, o) {
            var a,
              s = r[n];
            if (s && s.status !== i.requested) {
              if (((o = o || function () {}), s.status === i.loaded)) {
                o();
                return;
              }
              switch (((s.status = i.requested), s.type)) {
                case t.script:
                  a =
                    ((c = s),
                    (l = o),
                    (d = document.createElement("script")),
                    (d.src = c.src),
                    d.addEventListener("load", function () {
                      (c.status = i.loaded), l();
                    }),
                    d);
                  break;
                case t.link:
                  a =
                    ((u = s),
                    (h = o),
                    (p = document.createElement("link")),
                    (p.href = u.src),
                    (p.rel = "stylesheet"),
                    (p.type = "text/css"),
                    p.addEventListener("load", function () {
                      (u.status = i.loaded), h();
                    }),
                    p);
              }
              (a.id = s.tagId), (s.element = a);
              var c,
                l,
                d,
                u,
                h,
                p,
                f = document.getElementsByTagName(s.type)[0];
              f.parentNode.insertBefore(a, f);
            }
          },
        })),
      (theme.rteInit = function () {
        function e(e) {
          e.src = e.src;
          var t = document.createElement("div");
          t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
        }
        document.querySelectorAll(".rte table").forEach((e) => {
          var t = document.createElement("div");
          t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
        }),
          document
            .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
            .forEach((t) => {
              e(t);
            }),
          document
            .querySelectorAll('.rte iframe[src*="player.vimeo"]')
            .forEach((t) => {
              e(t);
            }),
          document.querySelectorAll(".rte a img").forEach((e) => {
            e.parentNode.classList.add("rte__image");
          });
      }),
      (theme.Sections = function e() {
        (this.constructors = {}),
          (this.instances = []),
          document.addEventListener(
            "shopify:section:load",
            this._onSectionLoad.bind(this)
          ),
          document.addEventListener(
            "shopify:section:unload",
            this._onSectionUnload.bind(this)
          ),
          document.addEventListener(
            "shopify:section:select",
            this._onSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:section:deselect",
            this._onDeselect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:select",
            this._onBlockSelect.bind(this)
          ),
          document.addEventListener(
            "shopify:block:deselect",
            this._onBlockDeselect.bind(this)
          );
      }),
      (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function (e, t, i) {
          var n = e.getAttribute("data-section-id"),
            r = e.getAttribute("data-section-type");
          if (void 0 !== (t = t || this.constructors[r])) {
            i && this._findInstance(n) && this._removeInstance(n);
            var o = Object.assign(new t(e), { id: n, type: r, container: e });
            this.instances.push(o);
          }
        },
        _findInstance: function (e) {
          for (var t = 0; t < this.instances.length; t++)
            if (this.instances[t].id === e) return this.instances[t];
        },
        _removeInstance: function (e) {
          for (var t, i = this.instances.length; i--; )
            if (this.instances[i].id === e) {
              (t = this.instances[i]), this.instances.splice(i, 1);
              break;
            }
          return t;
        },
        _onSectionLoad: function (e, t, i) {
          window.AOS && AOS.refreshHard(),
            theme && theme.initGlobals && theme.initGlobals();
          var n = t || e.target,
            r = t || e.target.querySelector("[data-section-id]");
          if (r) {
            this._createInstance(r);
            var o = t ? i : this._findInstance(e.detail.sectionId);
            n.querySelectorAll("[data-subsection]").length &&
              this.loadSubSections(n),
              o && "function" == typeof o.onLoad && o.onLoad(e),
              setTimeout(function () {
                window.dispatchEvent(new Event("scroll"));
              }, 200);
          }
        },
        _onSectionUnload: function (e) {
          this.instances = this.instances.filter(function (t) {
            var i = t.id === e.detail.sectionId;
            return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
          });
        },
        loadSubSections: function (e) {
          e &&
            e.querySelectorAll("[data-section-id]").forEach((e) => {
              this._onSectionLoad(null, e, e.dataset.sectionId);
            });
        },
        _onSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
        },
        _onDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockSelect &&
            t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = this._findInstance(e.detail.sectionId);
          void 0 !== t &&
            "function" == typeof t.onBlockDeselect &&
            t.onBlockDeselect(e);
        },
        register: function (e, t, i) {
          this.constructors[e] = t;
          var n = document.querySelectorAll('[data-section-type="' + e + '"]');
          i && (n = i.querySelectorAll('[data-section-type="' + e + '"]')),
            n.forEach(
              function (e) {
                this._createInstance(e, t, i);
              }.bind(this)
            );
        },
        reinit: function (e) {
          for (var t = 0; t < this.instances.length; t++) {
            var i = this.instances[t];
            i.type === e &&
              "function" == typeof i.forceReload &&
              i.forceReload();
          }
        },
      })),
      (theme.Variants = (function () {
        function e(e) {
          (this.container = e.container),
            (this.variants = e.variants),
            (this.singleOptionSelector = e.singleOptionSelector),
            (this.originalSelectorId = e.originalSelectorId),
            (this.enableHistoryState = e.enableHistoryState),
            (this.currentVariant = this._getVariantFromOptions()),
            this.container
              .querySelectorAll(this.singleOptionSelector)
              .forEach((e) => {
                e.addEventListener("change", this._onSelectChange.bind(this));
              });
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            _getCurrentOptions: function () {
              var e = [];
              return (
                this.container
                  .querySelectorAll(this.singleOptionSelector)
                  .forEach((t) => {
                    var i = t.getAttribute("type");
                    "radio" === i || "checkbox" === i
                      ? t.checked &&
                        e.push({ value: t.value, index: t.dataset.index })
                      : e.push({ value: t.value, index: t.dataset.index });
                  }),
                (e = theme.utils.compact(e))
              );
            },
            _getVariantFromOptions: function () {
              var e = this._getCurrentOptions(),
                t = this.variants,
                i = !1;
              return (
                t.forEach(function (t) {
                  var n = !0;
                  t.options,
                    e.forEach(function (e) {
                      n && (n = t[e.index] === e.value);
                    }),
                    n && (i = t);
                }),
                i || null
              );
            },
            _onSelectChange: function () {
              var e = this._getVariantFromOptions();
              this.container.dispatchEvent(
                new CustomEvent("variantChange", { detail: { variant: e } })
              ),
                document.dispatchEvent(
                  new CustomEvent("variant:change", { detail: { variant: e } })
                ),
                e &&
                  (this._updateMasterSelect(e),
                  this._updateImages(e),
                  this._updatePrice(e),
                  this._updateUnitPrice(e),
                  this._updateSKU(e),
                  (this.currentVariant = e),
                  this.enableHistoryState && this._updateHistoryState(e));
            },
            _updateImages: function (e) {
              var t = e.featured_image || {},
                i = this.currentVariant.featured_image || {};
              e.featured_image &&
                t.src !== i.src &&
                this.container.dispatchEvent(
                  new CustomEvent("variantImageChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updatePrice: function (e) {
              (e.price !== this.currentVariant.price ||
                e.compare_at_price !== this.currentVariant.compare_at_price) &&
                this.container.dispatchEvent(
                  new CustomEvent("variantPriceChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateUnitPrice: function (e) {
              e.unit_price !== this.currentVariant.unit_price &&
                this.container.dispatchEvent(
                  new CustomEvent("variantUnitPriceChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateSKU: function (e) {
              e.sku !== this.currentVariant.sku &&
                this.container.dispatchEvent(
                  new CustomEvent("variantSKUChange", {
                    detail: { variant: e },
                  })
                );
            },
            _updateHistoryState: function (e) {
              if (history.replaceState && e) {
                var t =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  e.id;
                window.history.replaceState({ path: t }, "", t);
              }
            },
            _updateMasterSelect: function (e) {
              (this.container.querySelector(this.originalSelectorId).value =
                e.id),
                this.container
                  .querySelector(this.originalSelectorId)
                  .dispatchEvent(new Event("change", { bubbles: !0 }));
            },
          })),
          e
        );
      })()),
      (window.vimeoApiReady = function () {
        var e, t;
        (theme.config.vimeoLoading = !0),
          new Promise((i, n) => {
            (e = setInterval(function () {
              Vimeo && (clearInterval(e), clearTimeout(t), i());
            }, 500)),
              (t = setTimeout(function () {
                clearInterval(e), n();
              }, 4e3));
          }).then(function () {
            (theme.config.vimeoReady = !0),
              (theme.config.vimeoLoading = !1),
              document.dispatchEvent(new CustomEvent("vimeoReady"));
          });
      }),
      (theme.VimeoPlayer = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            background: !0,
            byline: !1,
            controls: !1,
            loop: !0,
            muted: !0,
            playsinline: !0,
            portrait: !1,
            title: !1,
          };
        function i(e, t, i) {
          (this.divId = e),
            (this.el = document.getElementById(e)),
            (this.videoId = t),
            (this.iframe = null),
            (this.options = i),
            this.options &&
              this.options.videoParent &&
              (this.parent = this.el.closest(this.options.videoParent)),
            this.setAsLoading(),
            theme.config.vimeoReady
              ? this.init()
              : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                document.addEventListener("vimeoReady", this.init.bind(this)));
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              var e = t;
              (e.id = this.videoId),
                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                this.videoPlayer.ready().then(this.playerReady.bind(this));
            },
            playerReady: function () {
              (this.iframe = this.el.querySelector("iframe")),
                this.iframe.setAttribute("tabindex", "-1"),
                this.videoPlayer.setMuted(!0),
                this.setAsLoaded(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.play &&
                this.videoPlayer.play();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pause &&
                this.videoPlayer.pause();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          i
        );
      })()),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0),
          document.dispatchEvent(new CustomEvent("youTubeReady"));
      }),
      (theme.YouTube = (function () {
        var e = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable",
          },
          t = {
            width: 1280,
            height: 720,
            playerVars: {
              autohide: 0,
              autoplay: 1,
              cc_load_policy: 0,
              controls: 0,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
            },
          };
        function i(e, i) {
          (this.divId = e),
            (this.iframe = null),
            (this.attemptedToPlay = !1),
            (t.events = {
              onReady: this.onVideoPlayerReady.bind(this),
              onStateChange: this.onVideoStateChange.bind(this),
            }),
            (this.options = Object.assign({}, t, i)),
            this.options &&
              (this.options.videoParent &&
                (this.parent = document
                  .getElementById(this.divId)
                  .closest(this.options.videoParent)),
              this.options.autoplay ||
                (this.options.playerVars.autoplay = this.options.autoplay),
              "sound" === this.options.style &&
                ((this.options.playerVars.controls = 1),
                (this.options.playerVars.autoplay = 0))),
            this.setAsLoading(),
            theme.config.youTubeReady
              ? this.init()
              : (theme.LibraryLoader.load("youtubeSdk"),
                document.addEventListener(
                  "youTubeReady",
                  this.init.bind(this)
                ));
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              this.videoPlayer = new YT.Player(this.divId, this.options);
            },
            onVideoPlayerReady: function (e) {
              (this.iframe = document.getElementById(this.divId)),
                this.iframe.setAttribute("tabindex", "-1"),
                "sound" !== this.options.style && e.target.mute(),
                new IntersectionObserver(
                  (e, t) => {
                    e.forEach((e) => {
                      e.isIntersecting ? this.play() : this.pause();
                    });
                  },
                  { rootMargin: "0px 0px 50px 0px" }
                ).observe(this.iframe);
            },
            onVideoStateChange: function (e) {
              switch (e.data) {
                case -1:
                  this.attemptedToPlay &&
                    (this.setAsLoaded(), this.enableInteraction());
                  break;
                case 0:
                  this.play(e);
                  break;
                case 1:
                  this.setAsLoaded();
                  break;
                case 3:
                  this.attemptedToPlay = !0;
              }
            },
            setAsLoading: function () {
              this.parent && this.parent.classList.add(e.loading);
            },
            setAsLoaded: function () {
              this.parent &&
                (this.parent.classList.remove(e.loading),
                this.parent.classList.add(e.loaded),
                Shopify &&
                  Shopify.designMode &&
                  window.AOS &&
                  AOS.refreshHard());
            },
            enableInteraction: function () {
              this.parent && this.parent.classList.add(e.interactable);
            },
            play: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.playVideo &&
                this.videoPlayer.playVideo();
            },
            pause: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.pauseVideo &&
                this.videoPlayer.pauseVideo();
            },
            destroy: function () {
              this.videoPlayer &&
                "function" == typeof this.videoPlayer.destroy &&
                this.videoPlayer.destroy();
            },
          })),
          i
        );
      })()),
      (theme.AjaxRenderer = (function () {
        function e({
          sections: e,
          preserveParams: t,
          onReplace: i,
          debug: n,
        } = {}) {
          (this.sections = e || []),
            (this.preserveParams = t || []),
            (this.cachedSections = []),
            (this.onReplace = i),
            (this.debug = Boolean(n));
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            renderPage: function (e, t, i = !0) {
              t && this.appendPreservedParams(t);
              let n = this.sections.map((i) => {
                let n = `${e}?section_id=${i.sectionId}&${t}`,
                  r = (e) => e.url === n;
                return this.cachedSections.some(r)
                  ? this.renderSectionFromCache(r, i)
                  : this.renderSectionFromFetch(n, i);
              });
              return i && this.updateURLHash(t), Promise.all(n);
            },
            renderSectionFromCache: function (e, t) {
              let i = this.cachedSections.find(e);
              return (
                this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`),
                this.renderSection(i.html, t),
                Promise.resolve(t)
              );
            },
            renderSectionFromFetch: function (e, t) {
              return (
                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                new Promise((i, n) => {
                  fetch(e)
                    .then((e) => e.text())
                    .then((n) => {
                      let r = n;
                      (this.cachedSections = [
                        ...this.cachedSections,
                        { html: r, url: e },
                      ]),
                        this.renderSection(r, t),
                        i(t);
                    })
                    .catch((e) => n(e));
                })
              );
            },
            renderSection: function (e, t) {
              this.log(
                `[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`
              );
              let i = new DOMParser().parseFromString(e, "text/html");
              return (
                this.onReplace
                  ? this.onReplace(i, t)
                  : "string" == typeof t.nodeId
                  ? (document.getElementById(t.nodeId).innerHTML =
                      i.getElementById(t.nodeId).innerHTML)
                  : t.nodeId.forEach((e) => {
                      document.getElementById(e).innerHTML =
                        i.getElementById(e).innerHTML;
                    }),
                t
              );
            },
            appendPreservedParams: function (e) {
              this.preserveParams.forEach((t) => {
                let i = new URLSearchParams(window.location.search).get(t);
                i &&
                  (this.log(`[AjaxRenderer] Preserving ${t} param`),
                  e.append(t, i));
              });
            },
            updateURLHash: function (e) {
              history.pushState(
                {},
                "",
                `${window.location.pathname}${e && "?".concat(e)}`
              );
            },
            log: function (...e) {
              this.debug && console.log(...e);
            },
          })),
          e
        );
      })()),
      (theme.cart = {
        getCart: function () {
          return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), {
            credentials: "same-origin",
            method: "GET",
          }).then((e) => e.json());
        },
        getCartProductMarkup: function () {
          var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
          return fetch(
            (e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"),
            { credentials: "same-origin", method: "GET" }
          ).then(function (e) {
            return e.text();
          });
        },
        changeItem: function (e, t) {
          return this._updateCart({
            url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
            data: JSON.stringify({ id: e, quantity: t }),
          });
        },
        _updateCart: function (e) {
          return fetch(e.url, {
            method: "POST",
            body: e.data,
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          })
            .then((e) => e.json())
            .then(function (e) {
              return e;
            });
        },
        updateAttribute: function (e, t) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({
              attributes: { [e]: theme.cart.attributeToString(t) },
            }),
          });
        },
        updateNote: function (e) {
          return this._updateCart({
            url: "/cart/update.js",
            data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
          });
        },
        attributeToString: function (e) {
          return (
            "string" != typeof e && "undefined" == (e += "") && (e = ""),
            e.trim()
          );
        },
      }),
      (theme.CartForm = (function () {
        var e = {
            products: "[data-products]",
            qtySelector: ".js-qty__wrapper",
            discounts: "[data-discounts]",
            savings: "[data-savings]",
            subTotal: "[data-subtotal]",
            cartBubble: ".cart-link__bubble",
            cartNote: '[name="note"]',
            termsCheckbox: ".cart__terms-checkbox",
            checkoutBtn: ".cart__checkout",
          },
          t = { btnLoading: "btn--loading" },
          i = { requiresTerms: !1 };
        function n(t) {
          t &&
            ((this.form = t),
            (this.wrapper = t.parentNode),
            (this.location = t.dataset.location),
            (this.namespace = ".cart-" + this.location),
            (this.products = t.querySelector(e.products)),
            (this.submitBtn = t.querySelector(e.checkoutBtn)),
            (this.discounts = t.querySelector(e.discounts)),
            (this.savings = t.querySelector(e.savings)),
            (this.subtotal = t.querySelector(e.subTotal)),
            (this.termsCheckbox = t.querySelector(e.termsCheckbox)),
            (this.noteInput = t.querySelector(e.cartNote)),
            this.termsCheckbox && (i.requiresTerms = !0),
            this.init());
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.initQtySelectors(),
                document.addEventListener(
                  "cart:quantity" + this.namespace,
                  this.quantityChanged.bind(this)
                ),
                this.form.on(
                  "submit" + this.namespace,
                  this.onSubmit.bind(this)
                ),
                this.noteInput &&
                  this.noteInput.addEventListener("change", function () {
                    var e = this.value;
                    theme.cart.updateNote(e);
                  }),
                document.addEventListener(
                  "cart:build",
                  function () {
                    this.buildCart();
                  }.bind(this)
                );
            },
            reInit: function () {
              this.initQtySelectors();
            },
            onSubmit: function (e) {
              if (
                (this.submitBtn.classList.add(t.btnLoading),
                i.requiresTerms && !this.termsCheckbox.checked)
              )
                return (
                  alert(theme.strings.cartTermsConfirmation),
                  this.submitBtn.classList.remove(t.btnLoading),
                  e.preventDefault(),
                  !1
                );
            },
            _parseProductHTML: function (e) {
              var t = new DOMParser().parseFromString(e, "text/html");
              return {
                items: t.querySelector(".cart__items"),
                discounts: t.querySelector(".cart__discounts"),
              };
            },
            buildCart: function () {
              theme.cart
                .getCartProductMarkup()
                .then(this.cartMarkup.bind(this));
            },
            cartMarkup: function (e) {
              var t = this._parseProductHTML(e),
                i = t.items,
                n = parseInt(i.dataset.count),
                r = i.dataset.cartSubtotal,
                o = i.dataset.cartSavings;
              this.updateCartDiscounts(t.discounts),
                this.updateSavings(o),
                n > 0
                  ? this.wrapper.classList.remove("is-empty")
                  : this.wrapper.classList.add("is-empty"),
                this.updateCount(n),
                (this.products.innerHTML = ""),
                this.products.append(i),
                (this.subtotal.innerHTML = theme.Currency.formatMoney(
                  r,
                  theme.settings.moneyFormat
                )),
                this.reInit(),
                window.AOS && AOS.refreshHard(),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize();
            },
            updateCartDiscounts: function (e) {
              this.discounts &&
                ((this.discounts.innerHTML = ""), this.discounts.append(e));
            },
            initQtySelectors: function () {
              this.form.querySelectorAll(e.qtySelector).forEach((e) => {
                new theme.QtySelector(e, {
                  namespace: this.namespace,
                  isCart: !0,
                });
              });
            },
            quantityChanged: function (e) {
              var t = e.detail[0],
                i = e.detail[1],
                n = e.detail[2];
              t &&
                i &&
                (n && n.classList.add("is-loading"),
                theme.cart
                  .changeItem(t, i)
                  .then(
                    function (e) {
                      e.item_count > 0
                        ? this.wrapper.classList.remove("is-empty")
                        : this.wrapper.classList.add("is-empty"),
                        this.buildCart(),
                        document.dispatchEvent(
                          new CustomEvent("cart:updated", {
                            detail: { cart: e },
                          })
                        );
                    }.bind(this)
                  )
                  .catch(function (e) {}));
            },
            updateSubtotal: function (t) {
              this.form.querySelector(e.subTotal).innerHTML =
                theme.Currency.formatMoney(t, theme.settings.moneyFormat);
            },
            updateSavings: function (e) {
              if (this.savings) {
                if (e > 0) {
                  var t = theme.Currency.formatMoney(
                    e,
                    theme.settings.moneyFormat
                  );
                  this.savings.classList.remove("hide"),
                    (this.savings.innerHTML = theme.strings.cartSavings.replace(
                      "[savings]",
                      t
                    ));
                } else this.savings.classList.add("hide");
              }
            },
            updateCount: function (t) {
              var i = document.querySelectorAll(".cart-link__bubble-num");
              i.length &&
                i.forEach((e) => {
                  e.innerText = t;
                });
              var n = document.querySelectorAll(e.cartBubble);
              n.length &&
                (t > 0
                  ? n.forEach((e) => {
                      e.classList.add("cart-link__bubble--visible");
                    })
                  : n.forEach((e) => {
                      e.classList.remove("cart-link__bubble--visible");
                    }));
            },
          })),
          n
        );
      })()),
      (theme.collapsibles = (function () {
        var e = {
            trigger: ".collapsible-trigger",
            module: ".collapsible-content",
            moduleInner: ".collapsible-content__inner",
            tabs: ".collapsible-trigger--tab",
          },
          t = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height",
            tabs: "collapsible-trigger--tab",
          },
          i = ".collapsible",
          n = !1;
        function r(r) {
          if (!n) {
            n = !0;
            var a,
              s = r.currentTarget,
              c = s.classList.contains(t.open),
              l = s.classList.contains(t.tabs),
              d = s.getAttribute("aria-controls"),
              u = document.getElementById(d);
            if ((d || (d = s.dataset.controls), d)) {
              if (
                (!u &&
                  document.querySelectorAll('[data-id="' + d + '"]').length >
                    0 &&
                  (u = s.parentNode.querySelector('[data-id="' + d + '"]')),
                !u)
              ) {
                n = !1;
                return;
              }
              var h = u.querySelector(e.moduleInner).offsetHeight,
                p = u.classList.contains(t.autoHeight),
                f = u.parentNode.closest(e.module),
                m = h;
              if (l) {
                if (c) {
                  n = !1;
                  return;
                }
                document
                  .querySelectorAll(e.tabs + '[data-id="' + s.dataset.id + '"]')
                  .forEach((e) => {
                    e.classList.remove(t.open),
                      o(
                        (a = document.querySelector(
                          "#" + e.getAttribute("aria-controls")
                        )),
                        0,
                        !0
                      );
                  });
              }
              if (
                (c &&
                  p &&
                  setTimeout(function () {
                    o(u, (h = 0), c, p);
                  }, 0),
                c && !p && (h = 0),
                s.setAttribute("aria-expanded", !c),
                c ? s.classList.remove(t.open) : s.classList.add(t.open),
                o(u, h, c, p),
                f)
              ) {
                var g = c ? f.offsetHeight - m : h + f.offsetHeight;
                o(f, g, !1, !1);
              }
              if (window.SPR) {
                var v = u.querySelector(".spr-summary-actions-newreview");
                if (!v) return;
                v.off("click" + i),
                  v.on("click" + i, function () {
                    (h = u.querySelector(e.moduleInner).offsetHeight),
                      o(u, h, c, p);
                  });
              }
            }
          }
        }
        function o(e, i, r, o) {
          if (
            (e.classList.remove(t.hide),
            theme.utils.prepareTransition(e, function () {
              (e.style.height = i + "px"),
                r ? e.classList.remove(t.open) : e.classList.add(t.open);
            }),
            !r && o)
          ) {
            var a = e;
            window.setTimeout(function () {
              a.css("height", "auto"), (n = !1);
            }, 500);
          } else n = !1;
        }
        return {
          init: function n(o) {
            (o || document).querySelectorAll(e.trigger).forEach((e) => {
              var n = e.classList.contains(t.open);
              e.setAttribute("aria-expanded", n),
                e.off("click" + i),
                e.on("click" + i, r);
            });
          },
        };
      })()),
      (theme.Disclosure = (function () {
        var e = {
            disclosureForm: "[data-disclosure-form]",
            disclosureList: "[data-disclosure-list]",
            disclosureToggle: "[data-disclosure-toggle]",
            disclosureInput: "[data-disclosure-input]",
            disclosureOptions: "[data-disclosure-option]",
          },
          t = { listVisible: "disclosure-list--visible" };
        function i(e) {
          (this.container = e), this._cacheSelectors(), this._setupListeners();
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                disclosureForm: this.container.closest(e.disclosureForm),
                disclosureList: this.container.querySelector(e.disclosureList),
                disclosureToggle: this.container.querySelector(
                  e.disclosureToggle
                ),
                disclosureInput: this.container.querySelector(
                  e.disclosureInput
                ),
                disclosureOptions: this.container.querySelectorAll(
                  e.disclosureOptions
                ),
              };
            },
            _setupListeners: function () {
              (this.eventHandlers = this._setupEventHandlers()),
                this.cache.disclosureToggle.addEventListener(
                  "click",
                  this.eventHandlers.toggleList
                ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.addEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.addEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.addEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.addEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
            _setupEventHandlers: function () {
              return {
                connectOptions: this._connectOptions.bind(this),
                toggleList: this._toggleList.bind(this),
                onBodyClick: this._onBodyClick.bind(this),
                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                onDisclosureListFocusOut:
                  this._onDisclosureListFocusOut.bind(this),
                onDisclosureToggleFocusOut:
                  this._onDisclosureToggleFocusOut.bind(this),
              };
            },
            _connectOptions: function (e) {
              e.preventDefault(),
                this._submitForm(e.currentTarget.dataset.value);
            },
            _onDisclosureToggleFocusOut: function (e) {
              !1 === this.container.contains(e.relatedTarget) &&
                this._hideList();
            },
            _onDisclosureListFocusOut: function (e) {
              var i = e.currentTarget.contains(e.relatedTarget);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !i &&
                this._hideList();
            },
            _onDisclosureKeyUp: function (e) {
              27 === e.which &&
                (this._hideList(), this.cache.disclosureToggle.focus());
            },
            _onBodyClick: function (e) {
              var i = this.container.contains(e.target);
              this.cache.disclosureList.classList.contains(t.listVisible) &&
                !i &&
                this._hideList();
            },
            _submitForm: function (e) {
              (this.cache.disclosureInput.value = e),
                this.cache.disclosureForm.submit();
            },
            _hideList: function () {
              this.cache.disclosureList.classList.remove(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
            },
            _toggleList: function () {
              var e =
                "true" ===
                this.cache.disclosureToggle.getAttribute("aria-expanded");
              this.cache.disclosureList.classList.toggle(t.listVisible),
                this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
            },
            destroy: function () {
              this.cache.disclosureToggle.removeEventListener(
                "click",
                this.eventHandlers.toggleList
              ),
                this.cache.disclosureOptions.forEach(function (e) {
                  e.removeEventListener(
                    "click",
                    this.eventHandlers.connectOptions
                  );
                }, this),
                this.container.removeEventListener(
                  "keyup",
                  this.eventHandlers.onDisclosureKeyUp
                ),
                this.cache.disclosureList.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureListFocusOut
                ),
                this.cache.disclosureToggle.removeEventListener(
                  "focusout",
                  this.eventHandlers.onDisclosureToggleFocusOut
                ),
                document.body.removeEventListener(
                  "click",
                  this.eventHandlers.onBodyClick
                );
            },
          })),
          i
        );
      })()),
      (theme.Drawers = (function () {
        function e(e, t) {
          (this.config = {
            id: e,
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            closingClass: "js-drawer-closing",
            activeDrawer: "drawer--is-open",
            namespace: ".drawer-" + t,
          }),
            (this.nodes = { page: document.querySelector("#MainContent") }),
            (this.drawer = document.querySelector("#" + e)),
            (this.isOpen = !1),
            this.drawer && this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              document.querySelectorAll(this.config.open).forEach((e) => {
                e.setAttribute("aria-expanded", "false"),
                  e.addEventListener("click", this.open.bind(this));
              }),
                this.drawer
                  .querySelector(this.config.close)
                  .addEventListener("click", this.close.bind(this)),
                document.addEventListener(
                  "modalOpen",
                  function () {
                    this.close();
                  }.bind(this)
                );
            },
            open: function (e, t) {
              e && e.preventDefault(),
                !this.isOpen &&
                  (e && e.stopPropagation
                    ? (e.stopPropagation(),
                      e.currentTarget.setAttribute("aria-expanded", "true"),
                      (this.activeSource = e.currentTarget))
                    : t &&
                      (t.setAttribute("aria-expanded", "true"),
                      (this.activeSource = t)),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.add(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.add(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  document.dispatchEvent(new CustomEvent("drawerOpen")),
                  document.dispatchEvent(
                    new CustomEvent("drawerOpen." + this.config.id)
                  ),
                  this.bindEvents());
            },
            close: function (e) {
              if (this.isOpen) {
                if (e) {
                  if (e.target.closest(".js-drawer-close"));
                  else if (e.target.closest(".drawer")) return;
                }
                document.activeElement.blur(),
                  theme.utils.prepareTransition(
                    this.drawer,
                    function () {
                      this.drawer.classList.remove(this.config.activeDrawer);
                    }.bind(this)
                  ),
                  document.documentElement.classList.remove(
                    this.config.openClass
                  ),
                  document.documentElement.classList.add(
                    this.config.closingClass
                  ),
                  window.setTimeout(
                    function () {
                      document.documentElement.classList.remove(
                        this.config.closingClass
                      ),
                        this.activeSource &&
                          this.activeSource.getAttribute("aria-expanded") &&
                          (this.activeSource.setAttribute(
                            "aria-expanded",
                            "false"
                          ),
                          this.activeSource.focus());
                    }.bind(this),
                    500
                  ),
                  (this.isOpen = !1),
                  theme.a11y.removeTrapFocus({
                    container: this.drawer,
                    namespace: "drawer_focus",
                  }),
                  this.unbindEvents();
              }
            },
            bindEvents: function () {
              window.on(
                "click" + this.config.namespace,
                function (e) {
                  this.close(e);
                }.bind(this)
              ),
                window.on(
                  "keyup" + this.config.namespace,
                  function (e) {
                    27 === e.keyCode && this.close();
                  }.bind(this)
                ),
                theme.a11y.lockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
            unbindEvents: function () {
              window.off("click" + this.config.namespace),
                window.off("keyup" + this.config.namespace),
                theme.a11y.unlockMobileScrolling(
                  this.config.namespace,
                  this.nodes.page
                );
            },
          })),
          e
        );
      })()),
      (theme.Modals = (function () {
        function e(e, t, i) {
          if (
            ((this.id = e),
            (this.modal = document.getElementById(e)),
            !this.modal)
          )
            return !1;
          (this.modalContent = this.modal.querySelector(".modal__inner")),
            (this.config = Object.assign(
              {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: "modal-open",
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: !0,
              },
              i
            )),
            (this.modalIsOpen = !1),
            (this.focusOnOpen = this.config.focusIdOnOpen
              ? document.getElementById(this.config.focusIdOnOpen)
              : this.modal),
            (this.isSolid = this.config.solid),
            this.init();
        }
        return (
          (e.prototype.init = function () {
            document.querySelectorAll(this.config.open).forEach((e) => {
              e.setAttribute("aria-expanded", "false"),
                e.addEventListener("click", this.open.bind(this));
            }),
              this.modal.querySelectorAll(this.config.close).forEach((e) => {
                e.addEventListener("click", this.close.bind(this));
              }),
              document.addEventListener(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (e.prototype.open = function (e) {
            var t = !1;
            !this.modalIsOpen &&
              (e ? e.preventDefault() : (t = !0),
              e &&
                e.stopPropagation &&
                (e.stopPropagation(),
                (this.activeSource = e.currentTarget.setAttribute(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !t && this.close(),
              this.modal.classList.add(this.config.openClass),
              document.documentElement.classList.add(this.config.bodyOpenClass),
              this.isSolid &&
                document.documentElement.classList.add(
                  this.config.bodyOpenSolidClass
                ),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                container: this.modal,
                elementToFocus: this.focusOnOpen,
                namespace: "modal_focus",
              }),
              document.dispatchEvent(new CustomEvent("modalOpen")),
              document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
              this.bindEvents());
          }),
          (e.prototype.close = function (e) {
            if (this.modalIsOpen) {
              if (e) {
                if (e.target.closest(".js-modal-close"));
                else if (e.target.closest(".modal__inner")) return;
              }
              document.activeElement.blur(),
                this.modal.classList.remove(this.config.openClass),
                this.modal.classList.add(this.config.closingClass),
                document.documentElement.classList.remove(
                  this.config.bodyOpenClass
                ),
                document.documentElement.classList.add(
                  this.config.bodyClosingClass
                ),
                window.setTimeout(
                  function () {
                    document.documentElement.classList.remove(
                      this.config.bodyClosingClass
                    ),
                      this.modal.classList.remove(this.config.closingClass),
                      this.activeSource &&
                        this.activeSource.getAttribute("aria-expanded") &&
                        this.activeSource
                          .setAttribute("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                this.isSolid &&
                  document.documentElement.classList.remove(
                    this.config.bodyOpenSolidClass
                  ),
                (this.modalIsOpen = !1),
                theme.a11y.removeTrapFocus({
                  container: this.modal,
                  namespace: "modal_focus",
                }),
                document.dispatchEvent(
                  new CustomEvent("modalClose." + this.id)
                ),
                this.unbindEvents();
            }
          }),
          (e.prototype.bindEvents = function () {
            window.on(
              "keyup.modal",
              function (e) {
                27 === e.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                this.modal.on("click.modal", this.close.bind(this));
          }),
          (e.prototype.unbindEvents = function () {
            document.documentElement.off(".modal"),
              this.config.closeOffContentClick && this.modal.off(".modal");
          }),
          e
        );
      })()),
      (theme.parallaxSections = {}),
      (theme.Parallax = (function () {
        var e = !1;
        function t(e, t) {
          (this.isInit = !1),
            (this.isVisible = !1),
            (this.container = e),
            (this.image = e.querySelector(".parallax-image")),
            (this.namespace = t.namespace),
            (this.desktopOnly = t.desktopOnly),
            this.container &&
              this.image &&
              (this.desktopOnly &&
                (document.addEventListener(
                  "matchSmall",
                  function () {
                    this.destroy();
                  }.bind(this)
                ),
                document.addEventListener(
                  "unmatchSmall",
                  function () {
                    this.init(!0);
                  }.bind(this)
                )),
              this.init(this.desktopOnly));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function (e) {
              this.isInit && this.destroy(),
                (this.isInit = !0),
                (!e || !theme.config.bpSmall) &&
                  (this.setSizes(),
                  this.scrollHandler(),
                  new IntersectionObserver(
                    (e, t) => {
                      e.forEach((e) => {
                        (this.isVisible = e.isIntersecting),
                          this.isVisible
                            ? window.on(
                                "scroll" + this.namespace,
                                this.onScroll.bind(this)
                              )
                            : window.off("scroll" + this.namespace);
                      });
                    },
                    { rootMargin: "200px 0px 200px 0px" }
                  ).observe(this.container),
                  window.on(
                    "resize" + this.namespace,
                    theme.utils.debounce(250, this.setSizes.bind(this))
                  ),
                  document.addEventListener(
                    "shopify:section:reorder",
                    theme.utils.debounce(250, this.onReorder.bind(this))
                  ));
            },
            onScroll: function () {
              this.isVisible &&
                (window.SPR && !e && (this.setSizes(), (e = !0)),
                requestAnimationFrame(this.scrollHandler.bind(this)));
            },
            scrollHandler: function () {
              var e = (window.scrollY - this.elTop) * 0.85;
              this.image.style.transform = "translate3d(0, " + e + "px, 0)";
            },
            setSizes: function () {
              var e = this.container.getBoundingClientRect();
              this.elTop = e.top + window.scrollY;
            },
            onReorder: function () {
              this.setSizes(), this.onScroll();
            },
            destroy: function () {
              (this.image.style.transform = "none"),
                window.off("scroll" + this.namespace),
                window.off("resize" + this.namespace);
            },
          })),
          t
        );
      })()),
      void 0 === window.noUiSlider)
    )
      throw Error(
        "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
      );
    (theme.PriceRange = (function () {
      var e = {
        priceRange: ".price-range",
        priceRangeSlider: ".price-range__slider",
        priceRangeInputMin: ".price-range__input-min",
        priceRangeInputMax: ".price-range__input-max",
        priceRangeDisplayMin: ".price-range__display-min",
        priceRangeDisplayMax: ".price-range__display-max",
      };
      function t(e, { onChange: t, onUpdate: i, ...n } = {}) {
        return (
          (this.container = e),
          (this.onChange = t),
          (this.onUpdate = i),
          (this.sliderOptions = n || {}),
          this.init()
        );
      }
      return (
        (t.prototype = Object.assign({}, t.prototype, {
          init: function () {
            if (!this.container.classList.contains("price-range"))
              throw Error(
                "You must instantiate PriceRange with a valid container"
              );
            return (
              (this.formEl = this.container.closest("form")),
              (this.sliderEl = this.container.querySelector(
                e.priceRangeSlider
              )),
              (this.inputMinEl = this.container.querySelector(
                e.priceRangeInputMin
              )),
              (this.inputMaxEl = this.container.querySelector(
                e.priceRangeInputMax
              )),
              (this.displayMinEl = this.container.querySelector(
                e.priceRangeDisplayMin
              )),
              (this.displayMaxEl = this.container.querySelector(
                e.priceRangeDisplayMax
              )),
              (this.minRange = parseFloat(this.container.dataset.min) || 0),
              (this.minValue =
                parseFloat(this.container.dataset.minValue) || 0),
              (this.maxRange = parseFloat(this.container.dataset.max) || 100),
              (this.maxValue =
                parseFloat(this.container.dataset.maxValue) || this.maxRange),
              this.createPriceRange()
            );
          },
          createPriceRange: function () {
            this.sliderEl &&
              this.sliderEl.noUiSlider &&
              "function" == typeof this.sliderEl.noUiSlider.destroy &&
              this.sliderEl.noUiSlider.destroy();
            var e = noUiSlider.create(this.sliderEl, {
              connect: !0,
              step: 10,
              ...this.sliderOptions,
              start: [this.minValue, this.maxValue],
              range: { min: this.minRange, max: this.maxRange },
            });
            return (
              e.on("update", (e) => {
                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                  e[0],
                  theme.settings.moneyFormat
                )),
                  (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                    e[1],
                    theme.settings.moneyFormat
                  )),
                  this.onUpdate && this.onUpdate(e);
              }),
              e.on("change", (e) => {
                if (
                  ((this.inputMinEl.value = e[0]),
                  (this.inputMaxEl.value = e[1]),
                  this.onChange)
                ) {
                  let t = new FormData(this.formEl);
                  this.onChange(t);
                }
              }),
              e
            );
          },
        })),
        t
      );
    })()),
      (theme.AjaxProduct = (function () {
        var e = { loading: !1 };
        function t(e, t, i) {
          (this.form = e),
            (this.args = i),
            this.form &&
              ((this.addToCart = e.querySelector(t || ".add-to-cart")),
              this.form.addEventListener(
                "submit",
                this.addItemFromForm.bind(this)
              ));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            addItemFromForm: function (t, i) {
              if ((t.preventDefault(), !e.loading)) {
                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                var n = theme.utils.serialize(this.form);
                fetch(theme.routes.cartAdd, {
                  method: "POST",
                  body: n,
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                })
                  .then((e) => e.json())
                  .then(
                    function (t) {
                      422 === t.status ? this.error(t) : this.success(t),
                        (e.loading = !1),
                        this.addToCart.classList.remove("btn--loading"),
                        document.body.classList.contains("template-cart") &&
                          (window.scrollTo(0, 0), location.reload());
                    }.bind(this)
                  );
              }
            },
            success: function (e) {
              var t = this.form.querySelector(".errors");
              t && t.remove(),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:added", {
                    detail: { product: e, addToCartBtn: this.addToCart },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:added:" + this.args.scopedEventId,
                      { detail: { product: e, addToCartBtn: this.addToCart } }
                    )
                  );
            },
            error: function (e) {
              if (!e.description) {
                console.warn(e);
                return;
              }
              var t = this.form.querySelector(".errors");
              t && t.remove();
              var i = document.createElement("div");
              i.classList.add("errors", "text-center"),
                (i.textContent = e.description),
                this.form.append(i),
                document.dispatchEvent(
                  new CustomEvent("ajaxProduct:error", {
                    detail: { errorMessage: e.description },
                  })
                ),
                this.args &&
                  this.args.scopedEventId &&
                  document.dispatchEvent(
                    new CustomEvent(
                      "ajaxProduct:error:" + this.args.scopedEventId,
                      { detail: { errorMessage: e.description } }
                    )
                  );
            },
          })),
          t
        );
      })()),
      (theme.ProductMedia = (function () {
        var e = {},
          t = {},
          i = {},
          n = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]",
          };
        function r(e) {
          if (!e) {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var n = t[i];
                !n.modelViewerUi &&
                  Shopify &&
                  (n.modelViewerUi = new Shopify.ModelViewerUI(n.element)),
                  o(n);
              }
          }
        }
        function o(e) {
          var t = i[e.sectionId];
          e.container.addEventListener("mediaVisible", function () {
            t.element.setAttribute("data-shopify-model3d-id", e.modelId),
              theme.config.isTouch || e.modelViewerUi.play();
          }),
            e.container.addEventListener("mediaHidden", function () {
              t.element.setAttribute("data-shopify-model3d-id", t.defaultId),
                e.modelViewerUi.pause();
            }),
            e.container.addEventListener("xrLaunch", function () {
              e.modelViewerUi.pause();
            });
        }
        return {
          init: function o(a, s) {
            (e[s] = { loaded: !1 }),
              a.forEach(function (e, r) {
                var o = e.dataset.mediaId,
                  a = e.querySelector("model-viewer"),
                  c = a.dataset.modelId;
                if (0 === r) {
                  var l = e.closest(n.mediaGroup).querySelector(n.xrButton);
                  i[s] = { element: l, defaultId: c };
                }
                t[o] = { modelId: c, sectionId: s, container: e, element: a };
              }),
              window.Shopify.loadFeatures([
                {
                  name: "shopify-xr",
                  version: "1.0",
                  onLoad: function t(i) {
                    if (!i) {
                      if (!window.ShopifyXR) {
                        document.addEventListener(
                          "shopify_xr_initialized",
                          function () {
                            t();
                          }
                        );
                        return;
                      }
                      for (var n in e)
                        if (e.hasOwnProperty(n)) {
                          var r = e[n];
                          if (r.loaded) continue;
                          var o = document.querySelector("#ModelJson-" + n);
                          window.ShopifyXR.addModels(JSON.parse(o.innerHTML)),
                            (r.loaded = !0);
                        }
                      window.ShopifyXR.setupXRElements();
                    }
                  },
                },
                { name: "model-viewer-ui", version: "1.0", onLoad: r },
              ]),
              theme.LibraryLoader.load("modelViewerUiStyles");
          },
          removeSectionModels: function i(n) {
            for (var r in t)
              t.hasOwnProperty(r) && t[r].sectionId === n && delete t[r];
            delete e[n];
          },
        };
      })()),
      (theme.QtySelector = (function () {
        var e = {
          input: ".js-qty__num",
          plus: ".js-qty__adjust--plus",
          minus: ".js-qty__adjust--minus",
        };
        function t(t, i) {
          (this.wrapper = t),
            (this.plus = t.querySelector(e.plus)),
            (this.minus = t.querySelector(e.minus)),
            (this.input = t.querySelector(e.input)),
            (this.minValue = this.input.getAttribute("min") || 1);
          var n = { namespace: null, isCart: !1, key: this.input.dataset.id };
          (this.options = Object.assign({}, n, i)), this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.plus.addEventListener(
                "click",
                function () {
                  var e = this._getQty();
                  this._change(e + 1);
                }.bind(this)
              ),
                this.minus.addEventListener(
                  "click",
                  function () {
                    var e = this._getQty();
                    this._change(e - 1);
                  }.bind(this)
                ),
                this.input.addEventListener(
                  "change",
                  function (e) {
                    this._change(this._getQty());
                  }.bind(this)
                );
            },
            _getQty: function () {
              var e = this.input.value;
              return (
                (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1),
                parseInt(e)
              );
            },
            _change: function (e) {
              e <= this.minValue && (e = this.minValue),
                (this.input.value = e),
                this.options.isCart &&
                  document.dispatchEvent(
                    new CustomEvent("cart:quantity" + this.options.namespace, {
                      detail: [this.options.key, e, this.wrapper],
                    })
                  );
            },
          })),
          t
        );
      })()),
      (theme.initQuickShop = function () {
        var e = document.querySelectorAll(".grid-product");
        function t(e) {
          var i = e.currentTarget;
          if (!theme.config.bpSmall) {
            if (
              (i.removeEventListener("mouseover", t),
              !i || !i.dataset.productId)
            )
              return;
            var n = i.dataset.productId,
              r = i.dataset.productHandle,
              o = i.querySelector(".quick-product__btn");
            theme.preloadProductModal(r, n, o);
          }
        }
        e.length &&
          theme.settings.quickView &&
          e.forEach((e) => {
            e.addEventListener("mouseover", t);
          });
      }),
      (theme.preloadProductModal = function (e, t, i) {
        var n = document.getElementById("QuickShopHolder-" + e),
          r = theme.routes.home + "/products/" + e + "?view=modal";
        fetch((r = r.replace("//", "/")))
          .then(function (e) {
            return e.text();
          })
          .then(function (r) {
            var o = new DOMParser()
              .parseFromString(r, "text/html")
              .querySelector(
                '.product-section[data-product-handle="' + e + '"]'
              );
            n &&
              ((n.innerHTML = ""),
              n.append(o),
              new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t),
              theme.sections.register("product", theme.Product, n),
              theme.collapsibles.init(),
              theme.videoModal(),
              i && i.classList.remove("quick-product__btn--not-ready"));
          });
      }),
      (theme.Slideshow = (function () {
        var e = {
            animateOut: "animate-out",
            isPaused: "is-paused",
            isActive: "is-active",
          },
          t = {
            allSlides: ".slideshow__slide",
            currentSlide: ".is-selected",
            wrapper: ".slideshow-wrapper",
            pauseButton: ".slideshow__pause",
          },
          i = {
            thumb: ".product__thumb-item:not(.hide)",
            links: ".product__thumb-item:not(.hide) a",
            arrow: ".product__thumb-arrow",
          },
          n = {
            adaptiveHeight: !1,
            autoPlay: !1,
            avoidReflow: !1,
            childNav: null,
            childNavScroller: null,
            childVertical: !1,
            fade: !1,
            initialIndex: 0,
            pageDots: !1,
            pauseAutoPlayOnHover: !1,
            prevNextButtons: !1,
            rightToLeft: theme.config.rtl,
            setGallerySize: !0,
            wrapAround: !0,
          };
        function r(e, r) {
          if (
            ((this.el = e),
            (this.args = Object.assign({}, n, r)),
            (this.args.on = {
              ready: this.init.bind(this),
              change: this.slideChange.bind(this),
              settle: this.afterChange.bind(this),
            }),
            this.args.childNav &&
              ((this.childNavEls = this.args.childNav.querySelectorAll(
                i.thumb
              )),
              (this.childNavLinks = this.args.childNav.querySelectorAll(
                i.links
              )),
              (this.arrows = this.args.childNav.querySelectorAll(i.arrow)),
              this.childNavLinks.length && this.initChildNav()),
            this.args.avoidReflow &&
              (function e(t) {
                if (t.id) {
                  for (var i = t.firstChild; null != i && 3 == i.nodeType; )
                    i = i.nextSibling;
                  var n = document.createElement("style");
                  (n.innerHTML = `#${t.id} .flickity-viewport{height:${i.offsetHeight}px}`),
                    document.head.appendChild(n);
                }
              })(e),
            (this.slideshow = new Flickity(e, this.args)),
            this.args.autoPlay)
          ) {
            var o = e.closest(t.wrapper);
            (this.pauseBtn = o.querySelector(t.pauseButton)),
              this.pauseBtn &&
                this.pauseBtn.addEventListener(
                  "click",
                  this._togglePause.bind(this)
                );
          }
          window.on(
            "resize",
            theme.utils.debounce(
              300,
              function () {
                this.resize();
              }.bind(this)
            )
          );
        }
        return (
          (r.prototype = Object.assign({}, r.prototype, {
            init: function (e) {
              (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.callbacks &&
                  this.args.callbacks.onInit &&
                  "function" == typeof this.args.callbacks.onInit &&
                  this.args.callbacks.onInit(this.currentSlide),
                window.AOS && AOS.refresh();
            },
            slideChange: function (t) {
              this.args.fade &&
                this.currentSlide &&
                (this.currentSlide.classList.add(e.animateOut),
                this.currentSlide.addEventListener(
                  "transitionend",
                  function () {
                    this.currentSlide.classList.remove(e.animateOut);
                  }.bind(this)
                )),
                this.args.childNav && this.childNavGoTo(t),
                this.args.callbacks &&
                  this.args.callbacks.onChange &&
                  "function" == typeof this.args.callbacks.onChange &&
                  this.args.callbacks.onChange(t),
                this.arrows &&
                  this.arrows.length &&
                  (this.arrows[0].classList.toggle("hide", 0 === t),
                  this.arrows[1].classList.toggle(
                    "hide",
                    t === this.childNavLinks.length - 1
                  ));
            },
            afterChange: function (i) {
              this.args.fade &&
                this.el.querySelectorAll(t.allSlides).forEach((t) => {
                  t.classList.remove(e.animateOut);
                }),
                (this.currentSlide = this.el.querySelector(t.currentSlide)),
                this.args.childNav &&
                  this.childNavGoTo(this.slideshow.selectedIndex);
            },
            destroy: function () {
              this.args.childNav &&
                this.childNavLinks.length &&
                this.childNavLinks.forEach((t) => {
                  t.classList.remove(e.isActive);
                }),
                this.slideshow.destroy();
            },
            _togglePause: function () {
              this.pauseBtn.classList.contains(e.isPaused)
                ? (this.pauseBtn.classList.remove(e.isPaused),
                  this.slideshow.playPlayer())
                : (this.pauseBtn.classList.add(e.isPaused),
                  this.slideshow.pausePlayer());
            },
            resize: function () {
              this.slideshow.resize();
            },
            play: function () {
              this.slideshow.playPlayer();
            },
            pause: function () {
              this.slideshow.pausePlayer();
            },
            goToSlide: function (e) {
              this.slideshow.select(e);
            },
            setDraggable: function (e) {
              (this.slideshow.options.draggable = e),
                this.slideshow.updateDraggable();
            },
            initChildNav: function () {
              this.childNavLinks[this.args.initialIndex].classList.add(
                "is-active"
              ),
                this.childNavLinks.forEach((e, t) => {
                  e.setAttribute("data-index", t),
                    e.addEventListener(
                      "click",
                      function (e) {
                        e.preventDefault(),
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "focus",
                      function (e) {
                        this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    ),
                    e.addEventListener(
                      "keydown",
                      function (e) {
                        13 === e.keyCode &&
                          this.goToSlide(this.getChildIndex(e.currentTarget));
                      }.bind(this)
                    );
                }),
                this.arrows.length &&
                  this.arrows.forEach((e) => {
                    e.addEventListener("click", this.arrowClick.bind(this));
                  });
            },
            getChildIndex: function (e) {
              return parseInt(e.dataset.index);
            },
            childNavGoTo: function (t) {
              this.childNavLinks.forEach((t) => {
                t.classList.remove(e.isActive);
              });
              var i = this.childNavLinks[t];
              if ((i.classList.add(e.isActive), this.args.childNavScroller)) {
                if (this.args.childVertical) {
                  var n = i.offsetTop;
                  this.args.childNavScroller.scrollTop = n - 100;
                } else {
                  var r = i.offsetLeft;
                  this.args.childNavScroller.scrollLeft = r - 100;
                }
              }
            },
            arrowClick: function (e) {
              e.currentTarget.classList.contains("product__thumb-arrow--prev")
                ? this.slideshow.previous()
                : this.slideshow.next();
            },
          })),
          r
        );
      })()),
      (theme.VariantAvailability = (function () {
        var e = { disabled: "disabled" };
        function t(e) {
          (this.type = e.type),
            (this.variantsObject = e.variantsObject),
            (this.currentVariantObject = e.currentVariantObject),
            (this.container = e.container),
            (this.namespace = e.namespace),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.on(
                "variantChange" + this.namespace,
                this.setAvailability.bind(this)
              ),
                this.setAvailability(null, this.currentVariantObject);
            },
            setAvailability: function (e, t) {
              if (e) var t = e.detail.variant;
              var i = { option1: [], option2: [], option3: [] },
                n = this.variantsObject.filter(function (e) {
                  return (
                    !!t &&
                    t.id !== e.id &&
                    ((t.option2 === e.option2 && t.option3 === e.option3) ||
                      (t.option1 === e.option1 && t.option3 === e.option3) ||
                      (t.option1 === e.option1 && t.option2 === e.option2) ||
                      void 0)
                  );
                }),
                r = Object.assign({}, { variant: t }, n);
              for (var o in (this.container
                .querySelectorAll(".variant-input-wrap")
                .forEach((e) => {
                  this.disableVariantGroup(e);
                }),
              r))
                if (r.hasOwnProperty(o)) {
                  var a = r[o];
                  if (!a) return;
                  var s = a.option1,
                    c = a.option2,
                    l = a.option3,
                    d = !1 === a.available;
                  s && i.option1.push({ value: s, soldOut: d }),
                    c && i.option2.push({ value: c, soldOut: d }),
                    l && i.option3.push({ value: l, soldOut: d });
                }
              for (var [u, h] of Object.entries(i))
                this.manageOptionState(u, h);
            },
            manageOptionState: function (e, t) {
              var i = this.container.querySelector(
                '.variant-input-wrap[data-index="' + e + '"]'
              );
              t.forEach((e) => {
                this.enableVariantOption(i, e);
              });
            },
            enableVariantOptionByValue: function (e, t) {
              for (
                var i = this.container.querySelector(
                    '.variant-input-wrap[data-index="' + t + '"]'
                  ),
                  n = 0;
                n < e.length;
                n++
              )
                this.enableVariantOption(i, e[n]);
            },
            enableVariantOption: function (t, i) {
              var n = i.value.replace(
                /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
                "\\$1"
              );
              if ("dropdown" === this.type)
                t.querySelector('option[value="' + n + '"]').disabled = !1;
              else {
                var r = t.querySelector(
                    '.variant-input[data-value="' + n + '"]'
                  ),
                  o = r.querySelector("input"),
                  a = r.querySelector("label");
                o.classList.remove(e.disabled),
                  a.classList.remove(e.disabled),
                  i.soldOut &&
                    (o.classList.add(e.disabled), a.classList.add(e.disabled));
              }
            },
            disableVariantGroup: function (t) {
              "dropdown" === this.type
                ? t.querySelectorAll("option").forEach((e) => {
                    e.disabled = !0;
                  })
                : (t.querySelectorAll("input").forEach((t) => {
                    t.classList.add(e.disabled);
                  }),
                  t.querySelectorAll("label").forEach((t) => {
                    t.classList.add(e.disabled);
                  }));
            },
          })),
          t
        );
      })()),
      (theme.videoModal = function () {
        var e,
          t = "VideoHolder",
          i = {
            youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
            mp4Trigger: ".product-video-trigger--mp4",
            mp4Player: ".product-video-mp4-sound",
          },
          n = document.querySelectorAll(i.youtube),
          r = document.querySelectorAll(i.mp4Trigger);
        if (n.length || r.length) {
          var o = document.getElementById(t);
          n.length && theme.LibraryLoader.load("youtubeSdk");
          var a = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: !0,
            solid: !0,
          });
          n.forEach((e) => {
            e.addEventListener("click", s);
          }),
            r.forEach((e) => {
              e.addEventListener("click", c);
            }),
            document.addEventListener("modalClose.VideoModal", function t() {
              e && "function" == typeof e.destroy ? e.destroy() : d();
            });
        }
        function s(i) {
          if (theme.config.youTubeReady) {
            i.preventDefault(), d(), a.open(i);
            var n,
              r,
              o =
                ((n = i.currentTarget.getAttribute("href")),
                (r = n.match(
                  /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                )),
                !!r && 11 == r[7].length && r[7]);
            e = new theme.YouTube(t, {
              videoId: o,
              style: "sound",
              events: { onReady: l },
            });
          }
        }
        function c(e) {
          d();
          var t = e.currentTarget.parentNode
            .querySelector(i.mp4Player)
            .cloneNode(!0);
          t.classList.remove("hide"),
            o.append(t),
            a.open(e),
            o.querySelector("video").play();
        }
        function l(e) {
          e.target.unMute(), e.target.playVideo();
        }
        function d() {
          o.innerHTML = "";
        }
      }),
      (theme.announcementBar = (function () {
        var e,
          t,
          i = {
            autoPlay: 5e3,
            avoidReflow: !0,
            cellAlign: theme.config.rtl ? "right" : "left",
          };
        function n() {
          t = new theme.Slideshow(e, i);
        }
        function r() {
          t && "function" == typeof t.destroy && t.destroy();
        }
        return {
          init: function t() {
            if ((e = document.getElementById("AnnouncementSlider")))
              r(),
                1 !== e.dataset.blockCount &&
                  ((theme.config.bpSmall || "true" === e.dataset.compact) &&
                    n(),
                  document.addEventListener("matchSmall", function () {
                    r(), n();
                  }),
                  document.addEventListener("unmatchSmall", function () {
                    r(), "true" === e.dataset.compact && n();
                  }));
          },
          onBlockSelect: function i(n) {
            var r = parseInt(
              e.querySelector("#AnnouncementSlide-" + n).dataset.index
            );
            t && "function" == typeof t.pause && (t.goToSlide(r), t.pause());
          },
          onBlockDeselect: function e() {
            t && "function" == typeof t.play && t.play();
          },
          unload: r,
        };
      })()),
      (theme.customerTemplates = function () {
        var e, t, i, n;
        function r() {
          document
            .getElementById("RecoverPasswordForm")
            .classList.toggle("hide"),
            document
              .getElementById("CustomerLoginForm")
              .classList.toggle("hide");
        }
        "#recover" === window.location.hash && r(),
          (e = document.getElementById("RecoverPassword")) &&
            e.addEventListener("click", function (e) {
              e.preventDefault(), r();
            }),
          (t = document.getElementById("HideRecoverPasswordLink")) &&
            t.addEventListener("click", function (e) {
              e.preventDefault(), r();
            }),
          document.querySelector(".reset-password-success") &&
            document.getElementById("ResetSuccess").classList.remove("hide"),
          (i = document.getElementById("AddressNewForm")),
          (n = document.querySelectorAll(".js-address-form")),
          i &&
            n.length &&
            (setTimeout(function () {
              document.querySelectorAll(".js-address-country").forEach((e) => {
                var t = e.dataset.countryId,
                  i = e.dataset.provinceId,
                  n = e.dataset.provinceContainerId;
                new Shopify.CountryProvinceSelector(t, i, { hideElement: n });
              });
            }, 1e3),
            document
              .querySelector(".address-new-toggle")
              .addEventListener("click", function () {
                i.classList.toggle("hide");
              }),
            document.querySelectorAll(".address-edit-toggle").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                document
                  .getElementById("EditAddress_" + t)
                  .classList.toggle("hide");
              });
            }),
            document.querySelectorAll(".address-delete").forEach((e) => {
              e.addEventListener("click", function (e) {
                var t = e.currentTarget.dataset.formId;
                confirm(
                  e.currentTarget.dataset.confirmMessage ||
                    "Are you sure you wish to delete this address?"
                ) &&
                  Shopify &&
                  Shopify.postLink("/account/addresses/" + t, {
                    parameters: { _method: "delete" },
                  });
              });
            }));
      }),
      (theme.CartDrawer = (function () {
        var e = { drawer: "#CartDrawer", form: "#CartDrawerForm" };
        function t() {
          (this.form = document.querySelector(e.form)),
            (this.drawer = new theme.Drawers("CartDrawer", "cart")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              (this.cartForm = new theme.CartForm(this.form)),
                this.cartForm.buildCart(),
                document.addEventListener(
                  "ajaxProduct:added",
                  function (e) {
                    this.cartForm.buildCart(), this.open();
                  }.bind(this)
                ),
                document.addEventListener(
                  "ajaxProduct:addedDrawerClose",
                  function (e) {
                    this.cartForm.buildCart(), this.close();
                  }.bind(this)
                ),
                document.addEventListener("cart:open", this.open.bind(this)),
                document.addEventListener("cart:close", this.close.bind(this));
            },
            open: function () {
              this.drawer.open();
            },
            close: function () {
              this.drawer.close();
            },
          })),
          t
        );
      })()),
      (theme.headerNav = (function () {
        var e,
          t,
          i = {
            wrapper: "#HeaderWrapper",
            siteHeader: "#SiteHeader",
            searchBtn: ".js-search-header",
            closeSearch: "#SearchClose",
            searchContainer: ".site-header__search-container",
            logo: "#LogoContainer img",
            megamenu: ".megamenu",
            navItems: ".site-nav__item",
            navLinks: ".site-nav__link",
            navLinksWithDropdown: ".site-nav__link--has-dropdown",
            navDropdownLinks: ".site-nav__dropdown-link--second-level",
          },
          n = {
            hasDropdownClass: "site-nav--has-dropdown",
            hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
            dropdownActive: "is-focused",
          },
          r = {
            namespace: ".siteNav",
            wrapperOverlayed: !1,
            overlayedClass: "is-light",
            overlayEnabledClass: "header-wrapper--sticky",
            stickyEnabled: !1,
            stickyActive: !1,
            stickyClass: "site-header--stuck",
            stickyHeaderWrapper: "StickyHeaderWrap",
            openTransitionClass: "site-header--opening",
            lastScroll: 0,
          };
        function o() {
          if (r.stickyEnabled) {
            var e = t.offsetHeight;
            document.querySelector("#" + r.stickyHeaderWrapper).style.height =
              e + "px";
          }
        }
        function a() {
          r.stickyEnabled &&
            !r.forceStopSticky &&
            (requestAnimationFrame(s), (r.lastScroll = window.scrollY));
        }
        function s() {
          if (window.scrollY > 250)
            !r.stickyActive &&
              ((r.stickyActive = !0),
              t.classList.add(r.stickyClass),
              r.wrapperOverlayed && e.classList.remove(r.overlayedClass),
              setTimeout(function () {
                t.classList.add(r.openTransitionClass);
              }, 100));
          else {
            if (!r.stickyActive) return;
            (r.stickyActive = !1),
              t.classList.remove(r.openTransitionClass),
              t.classList.remove(r.stickyClass),
              r.wrapperOverlayed && e.classList.add(r.overlayedClass);
          }
        }
        function c(e) {
          e.preventDefault(), e.stopImmediatePropagation();
          var t = document.querySelector(i.searchContainer);
          theme.utils.prepareTransition(
            t,
            function () {
              t.classList.add("is-active");
            }.bind(this)
          ),
            document.documentElement.classList.add(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            setTimeout(function () {
              theme.a11y.trapFocus({
                container: t,
                namespace: "header_search",
                elementToFocus: t.querySelector(".site-header__search-input"),
              });
            }, 100),
            theme.config.bpSmall &&
              r.stickyEnabled &&
              r.lastScroll < 300 &&
              window.scrollTo(0, 0),
            theme.a11y.lockMobileScrolling(r.namespace),
            (function e() {
              window.on(
                "keyup" + r.namespace,
                function (e) {
                  27 === e.keyCode && l();
                }.bind(this)
              ),
                document.documentElement.on(
                  "click" + r.namespace,
                  function (e) {
                    l(e);
                  }.bind(this)
                );
            })();
        }
        function l(e) {
          if (e) {
            for (
              var t = e.path || (e.composedPath && e.composedPath()), n = 0;
              n < t.length;
              n++
            )
              if (t[n].classList) {
                if (t[n].classList.contains("site-header__search-btn")) break;
                if (t[n].classList.contains("site-header__search-container"))
                  return;
              }
          }
          document.activeElement.blur(),
            document.documentElement.classList.add("js-drawer-closing"),
            document.documentElement.classList.remove(
              "js-drawer-open",
              "js-drawer-open--search"
            ),
            window.setTimeout(
              function () {
                document.documentElement.classList.remove("js-drawer-closing");
              }.bind(this),
              500
            );
          var o = document.querySelector(i.searchContainer);
          theme.utils.prepareTransition(
            o,
            function () {
              o.classList.remove("is-active");
            }.bind(this)
          ),
            theme.a11y.removeTrapFocus({
              container: o,
              namespace: "header_search",
            }),
            theme.a11y.unlockMobileScrolling(r.namespace),
            window.off("keyup" + r.namespace),
            document.documentElement.off("click" + r.namespace);
        }
        function d(e) {
          document.querySelectorAll(i.logo).forEach((e) => {
            var t = e.clientWidth,
              i = e.closest(".header-item").clientWidth;
            t > i ? (e.style.maxWidth = i) : e.removeAttribute("style");
          });
        }
        return {
          init: function s() {
            var u, h;
            (e = document.querySelector(i.wrapper)),
              (t = document.querySelector(i.siteHeader)),
              (r.stickyEnabled = "true" === t.dataset.sticky),
              r.stickyEnabled &&
                ((r.wrapperOverlayed = e.classList.contains(r.overlayedClass)),
                (theme.config.stickyHeader =
                  ((u = 0),
                  t.querySelectorAll(i.megamenu).forEach((e) => {
                    var t = e.offsetHeight;
                    t > u && (u = t);
                  }),
                  !(window.innerHeight < u + 120))),
                theme.config.stickyHeader
                  ? ((r.forceStopSticky = !1),
                    (r.lastScroll = 0),
                    ((h = document.createElement("div")).id =
                      r.stickyHeaderWrapper),
                    theme.utils.wrap(t, h),
                    o(),
                    window.on(
                      "resize" + r.namespace,
                      theme.utils.debounce(50, o)
                    ),
                    window.on(
                      "scroll" + r.namespace,
                      theme.utils.throttle(20, a)
                    ),
                    Shopify &&
                      Shopify.designMode &&
                      setTimeout(function () {
                        o();
                      }, 250))
                  : (r.forceStopSticky = !0)),
              (theme.settings.overlayHeader = "true" === t.dataset.overlay),
              theme.settings.overlayHeader &&
                Shopify &&
                Shopify.designMode &&
                document.body.classList.contains("template-collection") &&
                !document.querySelector(".collection-hero") &&
                this.disableOverlayHeader(),
              (function e() {
                var t = !1,
                  o = !1,
                  a = !1;
                function s(e) {
                  t && u(), o && h(), c(e.currentTarget);
                }
                function c(e) {
                  var i = e.parentNode;
                  if (
                    (i.classList.contains(n.hasDropdownClass) &&
                      (i.classList.add(n.dropdownActive), (t = !0)),
                    !theme.config.isTouch && !a)
                  ) {
                    var o = theme.config.isTouch ? "touchend" : "click";
                    (a = !0),
                      document.documentElement.on(
                        o + r.namespace,
                        function () {
                          d(),
                            document.documentElement.off(o + r.namespace),
                            (a = !1);
                        }.bind(this)
                      );
                  }
                }
                function l(e, t) {
                  var i = e.parentNode;
                  (i.classList.contains(n.hasSubDropdownClass) || t) &&
                    (i.classList.add(n.dropdownActive), (o = !0));
                }
                function d() {
                  u(), h();
                }
                function u() {
                  document.querySelectorAll(i.navItems).forEach((e) => {
                    e.classList.remove(n.dropdownActive);
                  });
                }
                function h() {
                  document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                    e.parentNode.classList.remove(n.dropdownActive);
                  });
                }
                theme.config.isTouch &&
                  document
                    .querySelectorAll(i.navLinksWithDropdown)
                    .forEach((e) => {
                      e.on("touchend" + r.namespace, function (e) {
                        e.currentTarget.parentNode.classList.contains(
                          n.dropdownActive
                        )
                          ? window.location.replace(
                              e.currentTarget.getAttribute("href")
                            )
                          : (e.preventDefault(), d(), c(e.currentTarget));
                      });
                    }),
                  document.querySelectorAll(i.navLinks).forEach((e) => {
                    e.on("focusin" + r.namespace, s),
                      e.on("mouseover" + r.namespace, s),
                      e.on("mouseleave" + r.namespace, d);
                  }),
                  document.querySelectorAll(i.navDropdownLinks).forEach((e) => {
                    theme.config.isTouch &&
                      e.on("touchend" + r.namespace, function (e) {
                        var t = e.currentTarget.parentNode;
                        t.classList.contains(n.hasSubDropdownClass)
                          ? t.classList.contains(n.dropdownActive)
                            ? window.location.replace(
                                e.currentTarget.getAttribute("href")
                              )
                            : (e.preventDefault(), h(), l(e.currentTarget))
                          : window.location.replace(
                              e.currentTarget.getAttribute("href")
                            );
                      }),
                      e.on("focusin" + r.namespace, function (e) {
                        h(), l(e.currentTarget, !0);
                      });
                  });
              })(),
              document.querySelectorAll(i.searchBtn).forEach((e) => {
                e.addEventListener("click", c);
              }),
              document
                .querySelector(i.closeSearch)
                .addEventListener("click", l),
              window.on("load" + r.namespace, d),
              window.on("resize" + r.namespace, theme.utils.debounce(150, d));
          },
          disableOverlayHeader: function t() {
            e.classList.remove(r.overlayEnabledClass, r.overlayedClass),
              (r.wrapperOverlayed = !1),
              (theme.settings.overlayHeader = !1);
          },
        };
      })()),
      (window.onpageshow = function (e) {
        e.persisted &&
          (document.body.classList.remove("unloading"),
          document.querySelectorAll(".cart__checkout").forEach((e) => {
            e.classList.remove("btn--loading");
          }));
      }),
      (theme.predictiveSearch = (function () {
        var e,
          t = "",
          i = !1,
          n = ".predictive",
          r = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: "#PredictiveWrapper",
            resultDiv: "#PredictiveResults",
            searchButton: "[data-predictive-search-button]",
          },
          o = {},
          a = { imageSize: "square" },
          s = { up_arrow: 38, down_arrow: 40, tab: 9 };
        function c() {
          o.wrapper.classList.add("hide"),
            (o.results.innerHTML = ""),
            clearTimeout(e);
        }
        function l() {
          o.form.submit();
        }
        function d(e) {
          e.preventDefault ? e.preventDefault() : (e.returnValue = !1);
          var t = {},
            i = new FormData(e.target);
          for (var n of i.keys()) t[n] = i.get(n);
          t.q && (t.q += "*");
          var r = h(t);
          return (window.location.href = "/search?" + r), !1;
        }
        function u(n) {
          n.keyCode !== s.up_arrow &&
            n.keyCode !== s.down_arrow &&
            n.keyCode !== s.tab &&
            (function n() {
              var r = o.input.value;
              if ("" === r) {
                c();
                return;
              }
              var s,
                l =
                  ((s = r),
                  "string" != typeof s
                    ? null
                    : s.trim().replace(/\ /g, "-").toLowerCase());
              clearTimeout(e),
                (e = setTimeout(
                  function () {
                    (function e(n) {
                      if (!i && t !== n) {
                        (t = n), (i = !0);
                        var r = {
                            q: n,
                            "resources[type]":
                              theme.settings.predictiveSearchType,
                            "resources[limit]": 4,
                            "resources[options][unavailable_products]": "last",
                            "resources[options][fields]":
                              "title,product_type,variants.title,vendor",
                          },
                          s = h(r);
                        fetch("/search/suggest.json?" + s)
                          .then((e) => e.json())
                          .then((e) => {
                            i = !1;
                            var t = {},
                              n = 0;
                            o.wrapper.classList.remove("hide");
                            var r = Object.entries(e.resources.results);
                            if (
                              (Object.keys(r).forEach(function (e) {
                                var i,
                                  o,
                                  s,
                                  c,
                                  l,
                                  d,
                                  u,
                                  h,
                                  p,
                                  f = r[e],
                                  m = f[0],
                                  g = f[1];
                                switch (((n += g.length), m)) {
                                  case "products":
                                    t[m] =
                                      ((i = g),
                                      (o = ""),
                                      (s = []),
                                      i.forEach((e) => {
                                        var t = {
                                          title: e.title,
                                          url: e.url,
                                          image_responsive_url:
                                            theme.Images.lazyloadImagePath(
                                              e.image
                                            ),
                                          image_aspect_ratio:
                                            e.featured_image.aspect_ratio,
                                        };
                                        s.push(t);
                                      }),
                                      s.length &&
                                        (o = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${theme.buildProductGridItem(
                s,
                "small--one-half medium-up--one-quarter",
                4,
                a.imageSize
              )}
            </div>
          </div>
        `),
                                      o);
                                    break;
                                  case "collections":
                                    t[m] =
                                      ((c = g),
                                      (l = ""),
                                      c.length &&
                                        (l = `
          <div data-type-collections>
            <p class="h6 predictive__label">${
              theme.strings.searchCollections
            }</p>
            <ul class="no-bullets">
              ${theme.buildCollectionItem(c)}
            </ul>
          </div>
        `),
                                      l);
                                    break;
                                  case "pages":
                                    t[m] =
                                      ((d = g),
                                      (u = ""),
                                      d.length &&
                                        (u = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${theme.buildPageItem(d)}
            </ul>
          </div>
        `),
                                      u);
                                    break;
                                  case "articles":
                                    t[m] =
                                      ((h = g),
                                      (p = ""),
                                      h.forEach((e) => {
                                        e.image &&
                                          (e.image =
                                            theme.Images.getSizedImageUrl(
                                              e.image,
                                              "200x200_crop_center"
                                            ));
                                      }),
                                      h.length &&
                                        (p = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${theme.buildArticleItem(h, a.imageSize)}
            </div>
          </div>
        `),
                                      p);
                                }
                              }),
                              0 === n)
                            ) {
                              c();
                              return;
                            }
                            var s,
                              l,
                              d =
                                ((s = t),
                                (l = ""),
                                s.products &&
                                  "" !== s.products &&
                                  (l += s.products),
                                s.collections &&
                                  "" !== s.collections &&
                                  (l += s.collections),
                                s.pages && "" !== s.pages && (l += s.pages),
                                s.articles &&
                                  "" !== s.articles &&
                                  (l += s.articles),
                                l);
                            (o.results.innerHTML = ""),
                              (o.results.innerHTML = d);
                          });
                      }
                    })(l);
                  }.bind(this),
                  500
                ));
            })();
        }
        function h(e) {
          return Object.keys(e)
            .map(function (t) {
              return t + "=" + encodeURIComponent(e[t]);
            })
            .join("&");
        }
        return {
          init: function e() {
            if (
              !document.getElementById("shopify-features") ||
              JSON.parse(document.getElementById("shopify-features").innerHTML)
                .predictiveSearch
            )
              (o.wrapper = document.querySelector(r.wrapper)),
                o.wrapper &&
                  ((a.imageSize = o.wrapper.dataset.imageSize),
                  (o.form = document.querySelector(r.form)),
                  o.form.setAttribute("autocomplete", "off"),
                  o.form.on("submit" + n, d),
                  (o.input = o.form.querySelector(r.input)),
                  o.input.on("keyup" + n, u),
                  (o.submit = o.wrapper.querySelector(r.searchButton)),
                  o.submit.on("click" + n, l),
                  (o.results = document.querySelector(r.resultDiv)));
          },
        };
      })()),
      (theme.buildProductGridItem = function (e, t, i, n) {
        // console.log(e, t, i, n);
        var r = "";
        return (
          e.forEach((e) => {
            let productHandle = e.url.match(/\/products\/([^/?]+)/)[1];
            r += `
        <div class="grid__item grid-product ${t} aos-animate" data-aos="row-of-${i}" hidden-handle="${productHandle}">
          <div class="grid-product__content zzzzzzzzzzz">
            <a href="${e.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${theme.buildProductImage(e, n)}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${e.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;
          }),
          r
        );
      }),
      (theme.buildProductImage = function (e, t) {
        var i = t || theme.settings.productImageSize,
          n = "";
        if ("natural" === i)
          n = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${e.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${e.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${e.image_aspect_ratio}"
            data-sizes="auto"
            alt="${e.title}">
        </div>`;
        else {
          var r = "lazyload";
          theme.settings.productImageCover || (r += " grid__image-contain"),
            (n = `
        <div class="grid__image-ratio grid__image-ratio--${i}">
          <img class="${r}"
              data-src="${e.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${e.aspect_ratio}"
              data-sizes="auto"
              alt="${e.title}">
        </div>
      `);
        }
        return n;
      }),
      (theme.buildCollectionItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
          }),
          t
        );
      }),
      (theme.buildPageItem = function (e) {
        var t = "";
        return (
          e.forEach((e) => {
            t += `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
          }),
          t
        );
      }),
      (theme.buildArticleItem = function (e, t) {
        var i = "";
        return (
          e.forEach((e) => {
            i += `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${
            e.url
          }" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${t}">
                <div class="predictive__image-wrap">
                  ${theme.buildPredictiveImage(e)}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${e.title}
            </div>
          </a>
        </div>
      `;
          }),
          i
        );
      }),
      (theme.buildPredictiveImage = function (e) {
        var t = "";
        return (
          e.image &&
            (t = `<img class="lazyload"
            data-src="${e.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`),
          t
        );
      }),
      (theme.Maps = (function () {
        var e = { zoom: 14 },
          t = null,
          i = [],
          n = {},
          r = {
            section: '[data-section-type="map"]',
            map: "[data-map]",
            mapOverlay: ".map-section__overlay",
          };
        function o(e) {
          (this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.map = e.querySelector(r.map)),
            (this.key = this.map.dataset.apiKey),
            (n = {
              addressNoResults: theme.strings.addressNoResults,
              addressQueryLimit: theme.strings.addressQueryLimit,
              addressError: theme.strings.addressError,
              authError: theme.strings.authError,
            }),
            this.key &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.prepMapApi.bind(this),
                threshold: 20,
              });
        }
        return (
          (window.gm_authFailure = function () {
            Shopify.designMode &&
              (document.querySelectorAll(r.section).forEach((e) => {
                e.classList.add("map-section--load-error");
              }),
              document.querySelectorAll(r.map).forEach((e) => {
                e.parentNode.removeChild(e);
              }),
              window.mapError(theme.strings.authError));
          }),
          (window.mapError = function (e) {
            var t = document.createElement("div");
            t.classList.add("map-section__error", "errors", "text-center"),
              (t.innerHTML = e),
              document.querySelectorAll(r.mapOverlay).forEach((e) => {
                e.parentNode.prepend(t);
              }),
              document.querySelectorAll(".map-section__link").forEach((e) => {
                e.classList.add("hide");
              });
          }),
          (o.prototype = Object.assign({}, o.prototype, {
            prepMapApi: function () {
              if ("loaded" === t) this.createMap();
              else if (
                (i.push(this),
                "loading" !== t &&
                  ((t = "loading"),
                  void 0 === window.google || void 0 === window.google.maps))
              ) {
                var e = document.createElement("script");
                (e.onload = function () {
                  (t = "loaded"),
                    i.forEach((e) => {
                      e.createMap();
                    });
                }),
                  (e.src =
                    "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                  document.head.appendChild(e);
              }
            },
            createMap: function () {
              var t = this.map;
              return (function e(t) {
                var i = new google.maps.Geocoder();
                if (t) {
                  var n = t.dataset.addressSetting;
                  return new Promise((e, t) => {
                    i.geocode({ address: n }, function (i, n) {
                      n !== google.maps.GeocoderStatus.OK && t(n), e(i);
                    });
                  });
                }
              })(t)
                .then(
                  function (i) {
                    var n = {
                        zoom: e.zoom,
                        backgroundColor: "none",
                        center: i[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      r = (this.map = new google.maps.Map(t, n)),
                      o = (this.center = r.getCenter());
                    new google.maps.Marker({ map: r, position: r.getCenter() }),
                      google.maps.event.addDomListener(
                        window,
                        "resize",
                        theme.utils.debounce(250, function () {
                          google.maps.event.trigger(r, "resize"),
                            r.setCenter(o),
                            t.removeAttribute("style");
                        })
                      ),
                      Shopify.designMode && window.AOS && AOS.refreshHard();
                  }.bind(this)
                )
                .catch(function (e) {
                  var t;
                  switch (e) {
                    case "ZERO_RESULTS":
                      t = n.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      t = n.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      t = n.authError;
                      break;
                    default:
                      t = n.addressError;
                  }
                  Shopify.designMode && window.mapError(t);
                });
            },
            onUnload: function () {
              0 !== this.map.length &&
                google &&
                google.maps &&
                google.maps.event &&
                google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          o
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function e(e) {
          this.container = e;
          var t = this.container.getAttribute("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + t),
            e && "/challenge" !== window.location.pathname)
          ) {
            if (
              ((this.data = {
                secondsBeforeShow: e.dataset.delaySeconds,
                daysBeforeReappear: e.dataset.delayDays,
                cookie: Cookies.get(this.cookieName),
                testMode: e.dataset.testMode,
              }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + t,
                "newsletter-popup-modal"
              )),
              (e.querySelector(".errors") ||
                e.querySelector(".note--success")) &&
                this.modal.open(),
              e.querySelector(".note--success"))
            ) {
              this.closePopup(!0);
              return;
            }
            document.addEventListener(
              "modalClose." + e.id,
              this.closePopup.bind(this)
            ),
              (this.data.cookie && "true" !== this.data.testMode) ||
                this.initPopupDelay();
          }
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            initPopupDelay: function () {
              (!Shopify || !Shopify.designMode) &&
                setTimeout(
                  function () {
                    this.modal.open();
                  }.bind(this),
                  1e3 * this.data.secondsBeforeShow
                );
            },
            closePopup: function (e) {
              if ("true" === this.data.testMode) {
                Cookies.remove(this.cookieName, { path: "/" });
                return;
              }
              var t = e ? 200 : this.data.daysBeforeReappear;
              Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
          })),
          e
        );
      })()),
      (theme.PasswordHeader = (function () {
        function e() {
          this.init();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            init: function () {
              if (document.querySelector("#LoginModal")) {
                var e = new theme.Modals("LoginModal", "login-modal", {
                  focusIdOnOpen: "password",
                  solid: !0,
                });
                document.querySelectorAll(".errors").length && e.open();
              }
            },
          })),
          e
        );
      })()),
      (theme.Photoswipe = (function () {
        var e = {
          trigger: ".js-photoswipe__zoom",
          images: ".photoswipe__image",
          slideshowTrack: ".flickity-viewport ",
          activeImage: ".is-selected",
        };
        function t(e, t) {
          (this.container = e),
            (this.sectionId = t),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.images,
            this.items,
            (this.inSlideshow = !1),
            e &&
              "false" !== e.dataset.zoom &&
              ("true" === e.dataset.hasSlideshow && (this.inSlideshow = !0),
              this.init());
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.container.querySelectorAll(e.trigger).forEach((e) => {
                e.on("click" + this.namespace, this.triggerClick.bind(this));
              });
            },
            triggerClick: function (t) {
              this.items = this.getImageData();
              var i = this.inSlideshow
                  ? this.container.querySelector(e.activeImage)
                  : t.currentTarget,
                n = this.inSlideshow ? this.getChildIndex(i) : i.dataset.index;
              this.initGallery(this.items, n);
            },
            getChildIndex: function (e) {
              for (var t = 0; null != (e = e.previousSibling); ) t++;
              return t + 1;
            },
            getImageData: function () {
              this.images = this.inSlideshow
                ? this.container.querySelectorAll(e.slideshowTrack + e.images)
                : this.container.querySelectorAll(e.images);
              var t = [];
              return (
                this.images.forEach((e) => {
                  var i = {
                    msrc: e.currentSrc || e.src,
                    src: e.getAttribute("data-photoswipe-src"),
                    w: e.getAttribute("data-photoswipe-width"),
                    h: e.getAttribute("data-photoswipe-height"),
                    el: e,
                    initialZoomLevel: 0.5,
                  };
                  t.push(i);
                }),
                t
              );
            },
            initGallery: function (e, t) {
              var i = document.querySelectorAll(".pswp")[0];
              (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                allowPanToNext: !1,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                index: t - 1,
                pinchToClose: !1,
                preloaderEl: !1,
                scaleMode: "zoom",
                shareEl: !1,
                tapToToggleControls: !1,
                getThumbBoundsFn: function (t) {
                  var i =
                      window.pageYOffset || document.documentElement.scrollTop,
                    n = e[t].el.getBoundingClientRect();
                  return { x: n.left, y: n.top + i, w: n.width };
                },
              })),
                this.gallery.init(),
                this.gallery.listen("afterChange", this.afterChange.bind(this));
            },
            afterChange: function () {
              var e = this.gallery.getCurrentIndex();
              this.container.dispatchEvent(
                new CustomEvent("photoswipe:afterChange", {
                  detail: { index: e },
                })
              );
            },
          })),
          t
        );
      })()),
      (theme.Recommendations = (function () {
        var e = {
          placeholder: ".product-recommendations-placeholder",
          sectionClass: " .product-recommendations",
          productResults: ".grid-product",
        };
        function t(t) {
          (this.container = t),
            (this.sectionId = t.getAttribute("data-section-id")),
            (this.url = t.dataset.url),
            (e.recommendations = "Recommendations-" + this.sectionId),
            theme.initWhenVisible({
              element: t,
              callback: this.init.bind(this),
              threshold: 500,
            });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = document.getElementById(e.recommendations);
              if (t && "false" !== t.dataset.enable) {
                var i = t.dataset.productId,
                  n = t.dataset.limit,
                  r =
                    this.url +
                    "?section_id=product-recommendations&limit=" +
                    n +
                    "&product_id=" +
                    i;
                if (Shopify.designMode) {
                  var o = t.querySelector(e.sectionClass);
                  o && (o.innerHTML = "");
                }
                fetch(r)
                  .then(function (e) {
                    return e.text();
                  })
                  .then(
                    function (i) {
                      var n = new DOMParser()
                          .parseFromString(i, "text/html")
                          .querySelector(e.sectionClass),
                        r = t.querySelector(e.placeholder);
                      if (r) {
                        if (((r.innerHTML = ""), !n)) {
                          this.container.classList.add("hide");
                          return;
                        }
                        r.appendChild(n),
                          theme.reinitProductGridItem(t),
                          document.dispatchEvent(
                            new CustomEvent("recommendations:loaded", {
                              detail: { section: t },
                            })
                          ),
                          0 === n.querySelectorAll(e.productResults).length &&
                            this.container.classList.add("hide");
                      }
                    }.bind(this)
                  );
              }
            },
          })),
          t
        );
      })()),
      (theme.SlideshowSection = (function () {
        var e = { parallaxContainer: ".parallax-container" };
        function t(e) {
          this.container = e;
          var t = e.getAttribute("data-section-id");
          if (
            ((this.slideshow = e.querySelector("#Slideshow-" + t)),
            (this.namespace = "." + t),
            (this.initialIndex = 0),
            this.slideshow)
          ) {
            var i = e.parentElement;
            0 === [].indexOf.call(i.parentElement.children, i)
              ? this.init()
              : theme.initWhenVisible({
                  element: this.container,
                  callback: this.init.bind(this),
                });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.slideshow.querySelectorAll(".slideshow__slide");
              if (
                (this.container.hasAttribute("data-immediate-load")
                  ? (this.slideshow.classList.remove(
                      "loading",
                      "loading--delayed"
                    ),
                    this.slideshow.classList.add("loaded"))
                  : theme.loadImageSection(this.slideshow),
                t.length > 1)
              ) {
                var i = {
                  prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                  pageDots: this.slideshow.hasAttribute("data-dots"),
                  fade: !0,
                  setGallerySize: !1,
                  initialIndex: this.initialIndex,
                  autoPlay:
                    "true" === this.slideshow.dataset.autoplay &&
                    parseInt(this.slideshow.dataset.speed),
                };
                this.flickity = new theme.Slideshow(this.slideshow, i);
              } else t[0].classList.add("is-selected");
              this.container.hasAttribute("data-parallax") &&
                this.container.querySelectorAll(e.parallaxContainer).forEach(
                  function (e, t) {
                    new theme.Parallax(e, {
                      namespace: this.namespace + "-parallax-" + t,
                    });
                  }.bind(this)
                );
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (e) {
              var t = parseInt(
                this.slideshow.querySelector(
                  ".slideshow__slide--" + e.detail.blockId
                ).dataset.index
              );
              this.flickity && "function" == typeof this.flickity.pause
                ? (this.flickity.goToSlide(t), this.flickity.pause())
                : ((this.initialIndex = t),
                  setTimeout(
                    function () {
                      this.flickity &&
                        "function" == typeof this.flickity.pause &&
                        this.flickity.pause();
                    }.bind(this),
                    1e3
                  ));
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.args.autoPlay &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.StoreAvailability = (function () {
        var e = {
          drawerOpenBtn: ".js-drawer-open-availability",
          modalOpenBtn: ".js-modal-open-availability",
          productTitle: "[data-availability-product-title]",
        };
        function t(e) {
          (this.container = e),
            (this.baseUrl = e.dataset.baseUrl),
            (this.productTitle = e.dataset.productName);
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            updateContent: function (t) {
              var i =
                  this.baseUrl +
                  "/variants/" +
                  t +
                  "/?section_id=store-availability",
                n = this;
              fetch(i)
                .then(function (e) {
                  return e.text();
                })
                .then(function (t) {
                  if ("" === t.trim()) {
                    this.container.innerHTML = "";
                    return;
                  }
                  (n.container.innerHTML = t),
                    (n.container.innerHTML =
                      n.container.firstElementChild.innerHTML),
                    n.container.querySelector(e.drawerOpenBtn) &&
                      (n.drawer = new theme.Drawers(
                        "StoreAvailabilityDrawer",
                        "availability"
                      )),
                    n.container.querySelector(e.modalOpenBtn) &&
                      (n.modal = new theme.Modals(
                        "StoreAvailabilityModal",
                        "availability"
                      ));
                  var i = n.container.querySelector(e.productTitle);
                  i && (i.textContent = n.productTitle);
                });
            },
          })),
          t
        );
      })()),
      (theme.VideoSection = (function () {
        var e = { videoParent: ".video-parent-section" };
        function t(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".video-" + this.sectionId),
            this.videoObject,
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 500,
            });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var e = this.container.querySelector(".video-div");
              if (e) {
                var t = e.dataset.type;
                switch (t) {
                  case "youtube":
                    var i = e.dataset.videoId;
                    this.initYoutubeVideo(i);
                    break;
                  case "vimeo":
                    var i = e.dataset.videoId;
                    this.initVimeoVideo(i);
                    break;
                  case "mp4":
                    this.initMp4Video();
                }
              }
            },
            initYoutubeVideo: function (t) {
              this.videoObject = new theme.YouTube(
                "YouTubeVideo-" + this.sectionId,
                { videoId: t, videoParent: e.videoParent }
              );
            },
            initVimeoVideo: function (t) {
              this.videoObject = new theme.VimeoPlayer(
                "Vimeo-" + this.sectionId,
                t,
                { videoParent: e.videoParent }
              );
            },
            initMp4Video: function () {
              var t = "Mp4Video-" + this.sectionId,
                i = document.getElementById(t),
                n = i.closest(e.videoParent);
              if (i) {
                n.classList.add("loaded");
                var r = document.querySelector("#" + t).play();
                void 0 !== r &&
                  r
                    .then(function () {})
                    .catch(function () {
                      i.setAttribute("controls", ""),
                        n.classList.add("video-interactable");
                    });
              }
            },
            onUnload: function (e) {
              e.target.id.replace("shopify-section-", ""),
                this.videoObject &&
                  "function" == typeof this.videoObject.destroy &&
                  this.videoObject.destroy();
            },
          })),
          t
        );
      })()),
      (theme.BackgroundImage = (function () {
        var e = { parallaxContainer: ".parallax-container" };
        function t(e) {
          if (((this.container = e), e)) {
            var t = e.getAttribute("data-section-id");
            (this.namespace = "." + t),
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
              });
          }
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (this.container.dataset && this.container.dataset.parallax) {
                var t = this.container.querySelector(e.parallaxContainer),
                  i = {
                    namespace: this.namespace + "-parallax",
                    desktopOnly: !0,
                  };
                theme.parallaxSections[this.namespace] = new theme.Parallax(
                  t,
                  i
                );
              }
            },
            onUnload: function (e) {
              this.container &&
                (theme.parallaxSections[this.namespace] &&
                  "function" ==
                    typeof theme.parallaxSections[this.namespace].destroy &&
                  theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.Blog = (function () {
        function e(e) {
          this.tagFilters();
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            tagFilters: function () {
              var e = document.getElementById("BlogTagFilter");
              e &&
                e.addEventListener("change", function () {
                  location.href = e.value;
                });
            },
          })),
          e
        );
      })()),
      (theme.CollectionHeader = (function () {
        var e = !1;
        function t(t) {
          this.namespace = ".collection-header";
          var i = t.querySelector(".collection-hero");
          if (i) {
            if (
              (e && this.checkIfNeedReload(),
              theme.loadImageSection(i),
              t.dataset && t.dataset.parallax)
            ) {
              var n = t.querySelector(".parallax-container"),
                r = { namespace: this.namespace + "-parallax" };
              theme.parallaxSections[this.namespace] = new theme.Parallax(n, r);
            }
          } else
            theme.settings.overlayHeader &&
              theme.headerNav.disableOverlayHeader();
          e = !0;
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            checkIfNeedReload: function () {
              Shopify.designMode &&
                theme.settings.overlayHeader &&
                (document
                  .querySelector(".header-wrapper")
                  .classList.contains("header-wrapper--overlay") ||
                  location.reload());
            },
            onUnload: function () {
              theme.parallaxSections[this.namespace] &&
                (theme.parallaxSections[this.namespace].destroy(),
                delete theme.parallaxSections[this.namespace]);
            },
          })),
          t
        );
      })()),
      (theme.CollectionSidebar = (function () {
        var e = !1,
          t = { sidebar: "#CollectionSidebar" };
        function i(e) {
          this.container = e.querySelector(t.sidebar);
        }
        return (
          (i.prototype = Object.assign({}, i.prototype, {
            init: function () {
              this.container &&
                (this.onUnload(),
                (e = "drawer" === this.container.dataset.style),
                (theme.FilterDrawer = new theme.Drawers(
                  "FilterDrawer",
                  "collection-filters",
                  !0
                )));
            },
            forceReload: function () {
              this.init();
            },
            onSelect: function () {
              if (theme.FilterDrawer) {
                if (!e) {
                  theme.FilterDrawer.close();
                  return;
                }
                (e || theme.config.bpSmall) && theme.FilterDrawer.open();
              }
            },
            onDeselect: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
            onUnload: function () {
              theme.FilterDrawer && theme.FilterDrawer.close();
            },
          })),
          i
        );
      })()),
      (theme.Collection = (function () {
        var e = !1,
          t = {
            sortSelect: "#SortBy",
            colorSwatchImage: ".grid-product__color-image",
            colorSwatch: ".color-swatch--with-image",
            collectionGrid: ".collection-grid__wrapper",
            trigger: ".collapsible-trigger",
            sidebar: "#CollectionSidebar",
            filterSidebar: ".collapsible-content--sidebar",
            activeTagList: ".tag-list--active-tags",
            tags: ".tag-list input",
            activeTags: ".tag-list a",
            tagsForm: ".filter-form",
            filters: ".collection-filter",
            priceRange: ".price-range",
          },
          i = {
            activeTag: "tag--active",
            removeTagParent: "tag--remove",
            filterSidebar: "collapsible-content--sidebar",
            isOpen: "is-open",
          };
        function n(e) {
          (this.container = e),
            (this.sectionId = e.getAttribute("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId),
            (this.sidebar = new theme.CollectionSidebar(e)),
            (this.ajaxRenderer = new theme.AjaxRenderer({
              sections: [
                { sectionId: this.sectionId, nodeId: "CollectionAjaxContent" },
              ],
              onReplace: this.onReplaceAjaxContent.bind(this),
              preserveParams: ["sort_by"],
            })),
            this.init();
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.initSort(),
                this.colorSwatchHovering(),
                this.initFilters(),
                this.initPriceRange(),
                this.sidebar.init();
            },
            initSort: function () {
              (this.sortSelect = document.querySelector(t.sortSelect)),
                this.sortSelect &&
                  ((this.defaultSort = this.getDefaultSortValue()),
                  this.sortSelect.on(
                    "change" + this.namespace,
                    this.onSortChange.bind(this)
                  ),
                  this.initParams());
            },
            initParams: function () {
              if (((this.queryParams = {}), location.search.length))
                for (
                  var e, t = location.search.substr(1).split("&"), i = 0;
                  i < t.length;
                  i++
                )
                  (e = t[i].split("=")).length > 1 &&
                    (this.queryParams[decodeURIComponent(e[0])] =
                      decodeURIComponent(e[1]));
            },
            getSortValue: function () {
              return this.sortSelect.value || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.sortSelect.getAttribute("data-default-sortby");
            },
            onSortChange: function () {
              (this.queryParams.sort_by = this.getSortValue()),
                this.queryParams.page && delete this.queryParams.page,
                (window.location.search = new URLSearchParams(
                  Object.entries(this.queryParams)
                ));
            },
            colorSwatchHovering: function () {
              this.container.querySelectorAll(t.colorSwatchImage).length &&
                this.container.querySelectorAll(t.colorSwatch).forEach((e) => {
                  e.addEventListener("mouseenter", function () {
                    var t = e.dataset.variantId,
                      i = e.dataset.variantImage,
                      n = document.querySelector(
                        ".grid-product__color-image--" + t
                      );
                    (n.style.backgroundImage = "url(" + i + ")"),
                      n.classList.add("is-active");
                  }),
                    e.addEventListener("mouseleave", function () {
                      var t = e.dataset.variantId;
                      document
                        .querySelector(".grid-product__color-image--" + t)
                        .classList.remove("is-active");
                    });
                });
            },
            initFilters: function () {
              document.querySelectorAll(t.tags).length &&
                (this.bindBackButton(),
                theme.config.stickyHeader &&
                  (this.setFilterStickyPosition(),
                  window.on(
                    "resize",
                    theme.utils.debounce(500, this.setFilterStickyPosition)
                  )),
                document.querySelectorAll(t.activeTags).forEach((e) => {
                  e.addEventListener("click", this.tagClick.bind(this));
                }),
                document.querySelectorAll(t.tagsForm).forEach((e) => {
                  e.addEventListener("input", this.onFormSubmit.bind(this));
                }));
            },
            initPriceRange: function () {
              let e = document.querySelectorAll(t.priceRange);
              e.forEach(
                (e) =>
                  new theme.PriceRange(e, {
                    onChange: this.renderFromFormData.bind(this),
                  })
              );
            },
            tagClick: function (t) {
              var i = t.currentTarget;
              if (
                (theme.FilterDrawer && theme.FilterDrawer.close(),
                i.classList.contains("no-ajax") || (t.preventDefault(), e))
              )
                return;
              e = !0;
              let n = i.parentNode,
                r = new URL(i.href);
              this.renderActiveTag(n, i),
                this.updateScroll(!0),
                this.startLoading(),
                this.renderCollectionPage(r.searchParams);
            },
            onFormSubmit: function (t) {
              var i = t.target;
              if (
                (theme.FilterDrawer && theme.FilterDrawer.close(),
                i.classList.contains("no-ajax") || (t.preventDefault(), e))
              )
                return;
              e = !0;
              let n = i.closest("li"),
                r = i.closest("form"),
                o = new FormData(r);
              this.renderActiveTag(n, i),
                this.updateScroll(!0),
                this.startLoading(),
                this.renderFromFormData(o);
            },
            fetchOpenCollasibleFilters: function () {
              return Array.from(
                document.querySelectorAll(
                  `${t.sidebar} ${t.trigger}.${i.isOpen}`
                )
              ).map((e) => e.dataset.collapsibleId);
            },
            renderActiveTag: function (e, n) {
              let r = e.querySelector(".tag__text");
              e.classList.contains(i.activeTag)
                ? e.classList.remove(i.activeTag)
                : (e.classList.add(i.activeTag),
                  n.closest("li").classList.contains(i.removeTagParent)
                    ? e.remove()
                    : document
                        .querySelectorAll(t.activeTagList)
                        .forEach((e) => {
                          let t = document.createElement("li"),
                            i = document.createElement("a");
                          t.classList.add("tag", "tag--remove"),
                            i.classList.add("btn", "btn--small"),
                            (i.innerText = r.innerText),
                            t.appendChild(i),
                            e.appendChild(t);
                        }));
            },
            renderFromFormData: function (e) {
              let t = new URLSearchParams(e);
              this.renderCollectionPage(t);
            },
            onReplaceAjaxContent: function (e, t) {
              let i = this.fetchOpenCollasibleFilters();
              i.forEach((t) => {
                e.querySelectorAll(`[data-collapsible-id=${t}]`).forEach(
                  this.openCollapsible
                );
              }),
                (document.getElementById(t.nodeId).innerHTML = e.getElementById(
                  t.nodeId
                ).innerHTML);
              collectionItemEqual();
            },
            openCollapsible: function (e) {
              e.classList.contains(i.filterSidebar) &&
                (e.style.height = "auto"),
                e.classList.add(i.isOpen);
            },
            renderCollectionPage: function (t, i = !0) {
              this.ajaxRenderer
                .renderPage(window.location.pathname, t, i)
                .then(() => {
                  theme.sections.reinit("collection-template"),
                    this.updateScroll(!1),
                    this.initPriceRange(),
                    theme.reinitProductGridItem(),
                    (e = !1);
                });
            },
            bindBackButton: function () {
              window.off("popstate" + this.namespace),
                window.on(
                  "popstate" + this.namespace,
                  function (e) {
                    if (e) {
                      let t = new URL(window.location.href);
                      this.renderCollectionPage(t.searchParams, !1);
                    }
                  }.bind(this)
                );
            },
            updateScroll: function (e) {
              var t;
              (t = theme.config.bpSmall
                ? document.querySelector("[data-scroll-to]").offsetTop - 60
                : document.getElementById("CollectionAjaxResult").offsetTop +
                  1),
                theme.config.stickyHeader &&
                  (t -= document.querySelector(".site-header").offsetHeight),
                e
                  ? window.scrollTo({ top: t, behavior: "smooth" })
                  : window.scrollTo({ top: t });
            },
            setFilterStickyPosition: function () {
              var e = document.querySelector(".site-header").offsetHeight;
              document.querySelector(t.filters).style.top = e + 10 + "px";
              var i = document.querySelector(".grid__item--sidebar");
              i && (i.style.top = e + 10 + "px");
            },
            forceReload: function () {
              this.init();
            },
            startLoading: function () {
              document.querySelector(t.collectionGrid).classList.add("unload");
            },
          })),
          n
        );
      })()),
      (theme.FooterSection = (function () {
        var e = {
          locale: "[data-disclosure-locale]",
          currency: "[data-disclosure-currency]",
        };
        function t(e) {
          (this.container = e),
            (this.localeDisclosure = null),
            (this.currencyDisclosure = null),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              var t = this.container.querySelector(e.locale),
                i = this.container.querySelector(e.currency);
              t && (this.localeDisclosure = new theme.Disclosure(t)),
                i && (this.currencyDisclosure = new theme.Disclosure(i));
              var n = document.querySelector(".footer__newsletter-input");
              n &&
                n.addEventListener("keyup", function () {
                  n.classList.add("footer__newsletter-input--active");
                }),
                theme.collapsibles.init(this.container);
            },
            onUnload: function () {
              this.localeDisclosure && this.localeDisclosure.destroy(),
                this.currencyDisclosure && this.currencyDisclosure.destroy();
            },
          })),
          t
        );
      })()),
      (theme.HeaderSection = (function () {
        var e = {
          locale: "[data-disclosure-locale]",
          currency: "[data-disclosure-currency]",
        };
        function t(e) {
          (this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            this.init();
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              Shopify &&
                Shopify.designMode &&
                (theme.sections.reinit("slideshow-section"),
                setTimeout(function () {
                  window.dispatchEvent(new Event("resize"));
                }, 500)),
                this.initDrawers(),
                this.initDisclosures(),
                theme.headerNav.init(),
                theme.announcementBar.init();
            },
            initDisclosures: function () {
              var t = this.container.querySelector(e.locale),
                i = this.container.querySelector(e.currency);
              t && (this.localeDisclosure = new theme.Disclosure(t)),
                i && (this.currencyDisclosure = new theme.Disclosure(i));
            },
            initDrawers: function () {
              (theme.NavDrawer = new theme.Drawers("NavDrawer", "nav")),
                "drawer" !== theme.settings.cartType ||
                  document.body.classList.contains("template-cart") ||
                  new theme.CartDrawer(),
                theme.collapsibles.init(document.getElementById("NavDrawer"));
            },
            onBlockSelect: function (e) {
              theme.announcementBar.onBlockSelect(e.detail.blockId);
            },
            onBlockDeselect: function () {
              theme.announcementBar.onBlockDeselect();
            },
            onUnload: function () {
              theme.NavDrawer.close(),
                theme.announcementBar.unload(),
                this.localeDisclosure && this.localeDisclosure.destroy(),
                this.currencyDisclosure && this.currencyDisclosure.destroy();
            },
          })),
          t
        );
      })()),
      (theme.Product = (function () {
        var e = {},
          t = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible",
          },
          i = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            slide: ".product-main-slide",
            currentSlide: ".is-selected",
            startingSlide: ".starting-slide",
            variantType: ".variant-wrapper",
            blocks: "[data-product-blocks]",
            blocksHolder: "[data-blocks-holder]",
          };
        function n(e) {
          this.container = e;
          var t = (this.sectionId = e.getAttribute("data-section-id")),
            i = (this.productId = e.getAttribute("data-product-id"));
          (this.inModal = "true" === e.dataset.modal),
            this.modal,
            (this.settings = {
              enableHistoryState: e.dataset.history || !1,
              namespace: ".product-" + t,
              inventory: !1,
              inventoryThreshold: 10,
              modalInit: !1,
              hasImages: !0,
              imageSetName: null,
              imageSetIndex: null,
              currentImageSet: null,
              imageSize: "620x",
              currentSlideIndex: 0,
              videoLooping: e.dataset.videoLooping,
            }),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.settings.namespace = ".product-" + t + "-modal"),
              (this.modal = document.getElementById("QuickShopModal-" + i))),
            (this.selectors = {
              variantsJson: "[data-variant-json]",
              currentVariantJson: "[data-current-variant-json]",
              form: ".product-single__form",
              media: "[data-product-media-type-model]",
              closeMedia: ".product-single__close-media",
              photoThumbs: "[data-product-thumb]",
              thumbSlider: "[data-product-thumbs]",
              thumbScroller: ".product__thumbs--scroller",
              mainSlider: "[data-product-photos]",
              imageContainer: "[data-product-images]",
              productImageMain: "[data-product-image-main]",
              priceWrapper: "[data-product-price-wrap]",
              price: "[data-product-price]",
              comparePrice: "[data-compare-price]",
              savePrice: "[data-save-price]",
              priceA11y: "[data-a11y-price]",
              comparePriceA11y: "[data-compare-price-a11y]",
              unitWrapper: "[data-unit-price-wrapper]",
              unitPrice: "[data-unit-price]",
              unitPriceBaseUnit: "[data-unit-base]",
              sku: "[data-sku]",
              inventory: "[data-product-inventory]",
              incomingInventory: "[data-incoming-inventory]",
              colorLabel: "[data-variant-color-label]",
              addToCart: "[data-add-to-cart]",
              addToCartText: "[data-add-to-cart-text]",
              originalSelectorId: "[data-product-select]",
              singleOptionSelector: "[data-variant-input]",
              variantColorSwatch: ".variant__input--color-swatch",
              availabilityContainer: "[data-store-availability-holder]",
            }),
            this.cacheElements(),
            (this.firstProductImage =
              this.cache.mainSlider.querySelector("img")),
            this.firstProductImage || (this.settings.hasImages = !1);
          var n = this.cache.mainSlider.querySelector("[data-set-name]");
          n && (this.settings.imageSetName = n.dataset.setName), this.init();
        }
        return (
          (n.prototype = Object.assign({}, n.prototype, {
            init: function () {
              this.inModal &&
                (this.container.classList.add(t.isModal),
                document.addEventListener(
                  "modalOpen.QuickShopModal-" + this.productId,
                  this.openModalProduct.bind(this)
                ),
                document.addEventListener(
                  "modalClose.QuickShopModal-" + this.productId,
                  this.closeModalProduct.bind(this)
                )),
                this.inModal ||
                  (this.formSetup(),
                  this.productSetup(),
                  this.videoSetup(),
                  this.initProductSlider(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed());
            },
            cacheElements: function () {
              this.cache = {
                form: this.container.querySelector(this.selectors.form),
                mainSlider: this.container.querySelector(
                  this.selectors.mainSlider
                ),
                thumbSlider: this.container.querySelector(
                  this.selectors.thumbSlider
                ),
                thumbScroller: this.container.querySelector(
                  this.selectors.thumbScroller
                ),
                productImageMain: this.container.querySelector(
                  this.selectors.productImageMain
                ),
                priceWrapper: this.container.querySelector(
                  this.selectors.priceWrapper
                ),
                comparePriceA11y: this.container.querySelector(
                  this.selectors.comparePriceA11y
                ),
                comparePrice: this.container.querySelector(
                  this.selectors.comparePrice
                ),
                price: this.container.querySelector(this.selectors.price),
                savePrice: this.container.querySelector(
                  this.selectors.savePrice
                ),
                priceA11y: this.container.querySelector(
                  this.selectors.priceA11y
                ),
              };
            },
            formSetup: function () {
              this.initQtySelector(),
                this.initAjaxProductForm(),
                this.availabilitySetup(),
                this.initVariants(),
                this.settings.imageSetName && this.updateImageSet();
            },
            availabilitySetup: function () {
              var e = this.container.querySelector(
                this.selectors.availabilityContainer
              );
              e && (this.storeAvailability = new theme.StoreAvailability(e));
            },
            productSetup: function () {
              this.setImageSizes(),
                this.initImageZoom(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch(),
                window.SPR && (SPR.initDomEls(), SPR.loadBadges());
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var e = this.firstProductImage.currentSrc;
                e && (this.settings.imageSize = theme.Images.imageSize(e));
              }
            },
            addIdToRecentlyViewed: function () {
              var e = this.container.getAttribute("data-product-handle"),
                t = this.container.getAttribute("data-product-url"),
                i = this.container.getAttribute("data-aspect-ratio"),
                n = this.container.getAttribute("data-img-url");
              theme.recentlyViewed.recent.hasOwnProperty(e) &&
                delete theme.recentlyViewed.recent[e],
                (theme.recentlyViewed.recent[e] = {
                  url: t,
                  aspectRatio: i,
                  featuredImage: n,
                }),
                theme.config.hasLocalStorage &&
                  window.localStorage.setItem(
                    "theme-recent",
                    JSON.stringify(theme.recentlyViewed.recent)
                  );
            },
            initVariants: function () {
              var e = this.container.querySelector(this.selectors.variantsJson);
              if (e) {
                this.variantsObject = JSON.parse(e.innerHTML);
                var t = {
                    container: this.container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    variants: this.variantsObject,
                  },
                  n = this.container.querySelectorAll(
                    this.selectors.variantColorSwatch
                  );
                if (
                  (n.length &&
                    n.forEach((e) => {
                      e.addEventListener(
                        "change",
                        function (t) {
                          var i = e.dataset.colorName,
                            n = e.dataset.colorIndex;
                          this.updateColorName(i, n);
                        }.bind(this)
                      );
                    }),
                  (this.variants = new theme.Variants(t)),
                  this.storeAvailability)
                ) {
                  var r = this.variants.currentVariant
                    ? this.variants.currentVariant.id
                    : this.variants.variants[0].id;
                  this.storeAvailability.updateContent(r),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateAvailability.bind(this)
                    );
                }
                this.container.on(
                  "variantChange" + this.settings.namespace,
                  this.updateCartButton.bind(this)
                ),
                  this.container.on(
                    "variantImageChange" + this.settings.namespace,
                    this.updateVariantImage.bind(this)
                  ),
                  this.container.on(
                    "variantPriceChange" + this.settings.namespace,
                    this.updatePrice.bind(this)
                  ),
                  this.container.on(
                    "variantUnitPriceChange" + this.settings.namespace,
                    this.updateUnitPrice.bind(this)
                  ),
                  this.container.querySelector(this.selectors.sku) &&
                    this.container.on(
                      "variantSKUChange" + this.settings.namespace,
                      this.updateSku.bind(this)
                    );
                var o = this.container.querySelector(this.selectors.inventory);
                if (
                  (o &&
                    ((this.settings.inventory = !0),
                    (this.settings.inventoryThreshold = o.dataset.threshold),
                    this.container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateInventory.bind(this)
                    )),
                  theme.settings.dynamicVariantsEnable)
                ) {
                  var a = this.container.querySelector(
                    this.selectors.currentVariantJson
                  );
                  if (a) {
                    var s = this.container.querySelector(i.variantType);
                    s &&
                      new theme.VariantAvailability({
                        container: this.container,
                        namespace: this.settings.namespace,
                        type: s.dataset.type,
                        variantsObject: this.variantsObject,
                        currentVariantObject: JSON.parse(a.innerHTML),
                      });
                  }
                }
                this.settings.imageSetName &&
                  ((this.settings.imageSetIndex = this.container.querySelector(
                    '.variant-input-wrap[data-handle="' +
                      this.settings.imageSetName +
                      '"]'
                  ).dataset.index),
                  this.container.on(
                    "variantChange" + this.settings.namespace,
                    this.updateImageSet.bind(this)
                  ));
              }
            },
            initQtySelector: function () {
              this.container
                .querySelectorAll(".js-qty__wrapper")
                .forEach((e) => {
                  new theme.QtySelector(e, { namespace: ".product" });
                });
            },
            initAjaxProductForm: function () {
              "drawer" === theme.settings.cartType &&
                new theme.AjaxProduct(this.cache.form);
            },
            updateColorName: function (e, t) {
              this.container.querySelector(
                this.selectors.colorLabel + `[data-index="${t}"`
              ).textContent = e;
            },
            updateCartButton: function (e) {
              var i = e.detail.variant,
                n = this.container.querySelector(this.selectors.addToCart),
                r = this.container.querySelector(this.selectors.addToCartText);
              if (i) {
                if (i.available) {
                  n.classList.remove(t.disabled), (n.disabled = !1);
                  var o = r.dataset.defaultText;
                  r.textContent = o;
                } else
                  n.classList.add(t.disabled),
                    (n.disabled = !0),
                    (r.textContent = theme.strings.soldOut);
              } else
                n.classList.add(t.disabled),
                  (n.disabled = !0),
                  (r.textContent = theme.strings.unavailable);
            },
            updatePrice: function (e) {
              var i = e.detail.variant;
              if (i) {
                if (
                  ((this.cache.price.innerHTML = theme.Currency.formatMoney(
                    i.price,
                    theme.settings.moneyFormat
                  )),
                  i.compare_at_price > i.price)
                ) {
                  (this.cache.comparePrice.innerHTML =
                    theme.Currency.formatMoney(
                      i.compare_at_price,
                      theme.settings.moneyFormat
                    )),
                    this.cache.priceWrapper.classList.remove(t.hidden),
                    this.cache.price.classList.add(t.onSale),
                    this.cache.comparePriceA11y.setAttribute(
                      "aria-hidden",
                      "false"
                    ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "false");
                  var n = i.compare_at_price - i.price;
                  (n =
                    "percent" == theme.settings.saveType
                      ? Math.round((100 * n) / i.compare_at_price) + "%"
                      : theme.Currency.formatMoney(
                          n,
                          theme.settings.moneyFormat
                        )),
                    this.cache.savePrice.classList.remove(t.hidden),
                    (this.cache.savePrice.innerHTML =
                      theme.strings.savePrice.replace("[saved_amount]", n));
                } else
                  this.cache.priceWrapper &&
                    this.cache.priceWrapper.classList.add(t.hidden),
                    this.cache.savePrice.classList.add(t.hidden),
                    this.cache.price.classList.remove(t.onSale),
                    this.cache.comparePriceA11y &&
                      this.cache.comparePriceA11y.setAttribute(
                        "aria-hidden",
                        "true"
                      ),
                    this.cache.priceA11y.setAttribute("aria-hidden", "true");
              }
            },
            updateUnitPrice: function (e) {
              var i = e.detail.variant;
              i && i.unit_price
                ? ((this.container.querySelector(
                    this.selectors.unitPrice
                  ).innerHTML = theme.Currency.formatMoney(
                    i.unit_price,
                    theme.settings.moneyFormat
                  )),
                  (this.container.querySelector(
                    this.selectors.unitPriceBaseUnit
                  ).innerHTML = theme.Currency.getBaseUnit(i)),
                  this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.remove(t.hidden))
                : this.container
                    .querySelector(this.selectors.unitWrapper)
                    .classList.add(t.hidden);
            },
            imageSetArguments: function (e) {
              var e =
                e || (this.variants ? this.variants.currentVariant : null);
              if (e) {
                var t = (this.settings.currentImageSet = this.getImageSetName(
                    e[this.settings.imageSetIndex]
                  )),
                  i = this.settings.imageSetName + "_" + t;
                return (
                  (this.settings.currentSlideIndex = 0),
                  {
                    cellSelector: '[data-group="' + i + '"]',
                    imageSet: i,
                    initialIndex: this.settings.currentSlideIndex,
                  }
                );
              }
            },
            updateImageSet: function (e) {
              var t = e
                ? e.detail.variant
                : this.variants
                ? this.variants.currentVariant
                : null;
              if (t) {
                var i = this.getImageSetName(t[this.settings.imageSetIndex]);
                this.settings.currentImageSet !== i &&
                  this.initProductSlider(t);
              }
            },
            updateImageSetThumbs: function (e) {
              this.cache.thumbSlider
                .querySelectorAll(".product__thumb-item")
                .forEach((i) => {
                  i.classList.toggle(t.hidden, i.dataset.group !== e);
                });
            },
            getImageSetName: function (e) {
              return e
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
            },
            updateSku: function (e) {
              var t = e.detail.variant,
                i = "";
              t &&
                (t.sku && (i = t.sku),
                (this.container.querySelector(this.selectors.sku).textContent =
                  i));
            },
            updateInventory: function (e) {
              var t = e.detail.variant;
              if (
                !t ||
                !t.inventory_management ||
                "continue" === t.inventory_policy
              ) {
                this.toggleInventoryQuantity(t, !1),
                  this.toggleIncomingInventory(!1);
                return;
              }
              if (
                "shopify" === t.inventory_management &&
                window.inventories &&
                window.inventories[this.productId]
              ) {
                var i = window.inventories[this.productId][t.id],
                  n = i.quantity,
                  r = !0,
                  o = !1;
                (n <= 0 || n > this.settings.inventoryThreshold) && (r = !1),
                  this.toggleInventoryQuantity(t, r, n),
                  !r &&
                    "true" === i.incoming &&
                    n <= this.settings.inventoryThreshold &&
                    (o = !0),
                  this.toggleIncomingInventory(
                    o,
                    t.available,
                    i.next_incoming_date
                  );
              }
            },
            updateAvailability: function (e) {
              var t = e.detail.variant;
              t && this.storeAvailability.updateContent(t.id);
            },
            toggleInventoryQuantity: function (e, i, n) {
              this.settings.inventory || (i = !1);
              var r = this.container.querySelector(this.selectors.inventory),
                o = r.closest(".product-block");
              parseInt(n) <= parseInt(this.settings.inventoryThreshold)
                ? (r.parentNode.classList.add("inventory--low"),
                  (r.textContent = theme.strings.stockLabel.replace(
                    "[count]",
                    n
                  )))
                : (r.parentNode.classList.remove("inventory--low"),
                  (r.textContent = theme.strings.inStockLabel)),
                e && e.available
                  ? (r.parentNode.classList.remove(t.hidden),
                    o && o.classList.remove(t.hidden))
                  : (r.parentNode.classList.add(t.hidden),
                    o && o.classList.add(t.hidden));
            },
            toggleIncomingInventory: function (e, i, n) {
              var r = this.container.querySelector(
                this.selectors.incomingInventory
              );
              if (r) {
                var o = r.querySelector(".js-incoming-text");
                if (e) {
                  var a = i
                    ? theme.strings.willNotShipUntil.replace("[date]", n)
                    : theme.strings.willBeInStockAfter.replace("[date]", n);
                  n || (a = theme.strings.waitingForStock),
                    r.classList.remove(t.hidden),
                    (o.textContent = a);
                } else r.classList.add(t.hidden);
              }
            },
            videoSetup: function () {
              var e = this.cache.mainSlider.querySelectorAll(i.productVideo);
              if (!e.length) return !1;
              e.forEach((e) => {
                var t = e.dataset.videoType;
                "youtube" === t
                  ? this.initYoutubeVideo(e)
                  : "mp4" === t && this.initMp4Video(e);
              });
            },
            initYoutubeVideo: function (t) {
              e[t.id] = new theme.YouTube(t.id, {
                videoId: t.dataset.youtubeId,
                videoParent: i.videoParent,
                autoplay: !1,
                style: t.dataset.videoStyle,
                loop: t.dataset.videoLoop,
                events: {
                  onReady: this.youtubePlayerReady.bind(this),
                  onStateChange: this.youtubePlayerStateChange.bind(this),
                },
              });
            },
            youtubePlayerReady: function (t) {
              var i = t.target.getIframe().id;
              if (e[i]) {
                var n = e[i],
                  r = n.videoPlayer;
                "sound" !== n.options.style && r.mute(),
                  n.parent.classList.remove("loading"),
                  n.parent.classList.add("loaded"),
                  this._isFirstSlide(i) &&
                    "sound" !== n.options.style &&
                    r.playVideo();
              }
            },
            _isFirstSlide: function (e) {
              return this.cache.mainSlider.querySelector(
                i.startingSlide + " #" + e
              );
            },
            youtubePlayerStateChange: function (t) {
              var i = e[t.target.getIframe().id];
              switch (t.data) {
                case -1:
                  i.attemptedToPlay &&
                    i.parent.classList.add("video-interactable");
                  break;
                case 0:
                  i && "true" === i.options.loop && i.videoPlayer.playVideo();
                  break;
                case 3:
                  i.attemptedToPlay = !0;
              }
            },
            initMp4Video: function (t) {
              (e[t.id] = { id: t.id, type: "mp4" }),
                this._isFirstSlide(t.id) && this.playMp4Video(t.id);
            },
            stopVideos: function () {
              for (var [t, i] of Object.entries(e))
                i.videoPlayer
                  ? "function" == typeof i.videoPlayer.stopVideo &&
                    i.videoPlayer.stopVideo()
                  : "mp4" === i.type && this.stopMp4Video(i.id);
            },
            _getVideoType: function (e) {
              return e.getAttribute("data-video-type");
            },
            _getVideoDivId: function (e) {
              return e.id;
            },
            playMp4Video: function (e) {
              var t = this.container.querySelector("#" + e),
                n = t.play();
              void 0 !== n &&
                n
                  .then(function () {})
                  .catch(function (e) {
                    t.setAttribute("controls", ""),
                      t
                        .closest(i.videoParent)
                        .setAttribute("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (e) {
              var t = this.container.querySelector("#" + e);
              t && "function" == typeof t.pause && t.pause();
            },
            initImageZoom: function () {
              var e = this.container.querySelector(
                this.selectors.imageContainer
              );
              e &&
                (new theme.Photoswipe(e, this.sectionId),
                e.addEventListener(
                  "photoswipe:afterChange",
                  function (e) {
                    this.flickity && this.flickity.goToSlide(e.detail.index);
                  }.bind(this)
                ));
            },
            getThumbIndex: function (e) {
              return e.dataset.index;
            },
            updateVariantImage: function (e) {
              var t = e.detail.variant;
              theme.Images.getSizedImageUrl(
                t.featured_media.preview_image.src,
                this.settings.imageSize
              );
              var i = this.container.querySelector(
                  '.product__thumb[data-id="' + t.featured_media.id + '"]'
                ),
                n = this.getThumbIndex(i);
              void 0 !== n && this.flickity && this.flickity.goToSlide(n);
            },
            initProductSlider: function (e) {
              if (this.cache.mainSlider.querySelectorAll(i.slide).length <= 1) {
                var t = this.cache.mainSlider.querySelector(i.slide);
                t && t.classList.add("is-selected");
                return;
              }
              if (
                (this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy(),
                !e)
              ) {
                var n = this.cache.mainSlider.querySelector(i.startingSlide);
                this.settings.currentSlideIndex = this._slideIndex(n);
              }
              var r = {
                adaptiveHeight: !0,
                avoidReflow: !0,
                initialIndex: this.settings.currentSlideIndex,
                childNav: this.cache.thumbSlider,
                childNavScroller: this.cache.thumbScroller,
                childVertical:
                  "beside" === this.cache.thumbSlider.dataset.position,
                pageDots: !0,
                wrapAround: !0,
                prevNextButtons: !0,
                callbacks: {
                  onInit: this.onSliderInit.bind(this),
                  onChange: this.onSlideChange.bind(this),
                },
              };
              this.settings.imageSetName &&
                ((r = Object.assign({}, r, this.imageSetArguments(e))),
                this.updateImageSetThumbs(r.imageSet)),
                (this.flickity = new theme.Slideshow(this.cache.mainSlider, r));
            },
            onSliderInit: function (e) {
              this.settings.imageSetName && this.prepMediaOnSlide(e);
            },
            onSlideChange: function (e) {
              if (this.flickity) {
                var t = this.cache.mainSlider.querySelector(
                    '.product-main-slide[data-index="' +
                      this.settings.currentSlideIndex +
                      '"]'
                  ),
                  i = this.settings.imageSetName
                    ? this.cache.mainSlider.querySelectorAll(
                        ".flickity-slider .product-main-slide"
                      )[e]
                    : this.cache.mainSlider.querySelector(
                        '.product-main-slide[data-index="' + e + '"]'
                      );
                t.setAttribute("tabindex", "-1"),
                  i.setAttribute("tabindex", 0),
                  this.stopMediaOnSlide(t),
                  this.prepMediaOnSlide(i),
                  (this.settings.currentSlideIndex = e);
              }
            },
            stopMediaOnSlide(t) {
              var n = t.querySelector(i.productVideo);
              if (n) {
                var r = this._getVideoType(n),
                  o = this._getVideoDivId(n);
                if ("youtube" === r) {
                  if (e[o].videoPlayer) {
                    e[o].videoPlayer.stopVideo();
                    return;
                  }
                } else if ("mp4" === r) {
                  this.stopMp4Video(o);
                  return;
                }
              }
              var a = t.querySelector(this.selectors.media);
              a &&
                a.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                );
            },
            prepMediaOnSlide(t) {
              var n = t.querySelector(i.productVideo);
              if (n) {
                var r = this._getVideoType(n),
                  o = this._getVideoDivId(n);
                if ("youtube" === r) {
                  if (e[o].videoPlayer && "sound" !== e[o].options.style) {
                    e[o].videoPlayer.playVideo();
                    return;
                  }
                } else "mp4" === r && this.playMp4Video(o);
              }
              var a = t.querySelector(this.selectors.media);
              a &&
                (a.dispatchEvent(
                  new CustomEvent("mediaVisible", {
                    bubbles: !0,
                    cancelable: !0,
                  })
                ),
                t
                  .querySelector(".shopify-model-viewer-ui__button")
                  .setAttribute("tabindex", 0),
                t
                  .querySelector(".product-single__close-media")
                  .setAttribute("tabindex", 0));
            },
            _slideIndex: function (e) {
              return e.getAttribute("data-index");
            },
            openModalProduct: function () {
              var e = !1;
              this.settings.modalInit
                ? (e = !0)
                : ((this.blocksHolder = this.container.querySelector(
                    i.blocksHolder
                  )),
                  fetch(this.blocksHolder.dataset.url)
                    .then(function (e) {
                      return e.text();
                    })
                    .then(
                      function (e) {
                        var t = new DOMParser()
                          .parseFromString(e, "text/html")
                          .querySelector(i.blocks);
                        t.querySelectorAll("[id]").forEach((e) => {
                          var i = e.getAttribute("id");
                          e.setAttribute("id", i + "-modal");
                          var n = t.querySelector(`[for="${i}"]`);
                          n && n.setAttribute("for", i + "-modal");
                          var r = t.querySelector(`[aria-controls="${i}"]`);
                          r && r.setAttribute("aria-controls", i + "-modal");
                        });
                        var n = t
                          .querySelector(this.selectors.form)
                          .getAttribute("id");
                        t.querySelectorAll("[form]").forEach((e) => {
                          e.setAttribute("form", n);
                        }),
                          (this.blocksHolder.innerHTML = ""),
                          this.blocksHolder.append(t),
                          this.blocksHolder.classList.add(
                            "product-form-holder--loaded"
                          ),
                          this.cacheElements(),
                          this.formSetup(),
                          this.updateModalProductInventory(),
                          Shopify &&
                            Shopify.PaymentButton &&
                            Shopify.PaymentButton.init(),
                          theme.collapsibles.init(this.container),
                          document.dispatchEvent(
                            new CustomEvent("quickview:loaded", {
                              detail: { productId: this.sectionId },
                            })
                          );
                      }.bind(this)
                    ),
                  this.productSetup(),
                  this.videoSetup(),
                  this.settings.imageSetName
                    ? this.variants
                      ? this.initProductSlider()
                      : document.addEventListener(
                          "quickview:loaded",
                          function (e) {
                            e.detail.productId === this.sectionId &&
                              this.initProductSlider();
                          }.bind(this)
                        )
                    : this.initProductSlider(),
                  this.customMediaListners(),
                  this.addIdToRecentlyViewed(),
                  (this.settings.modalInit = !0)),
                AOS.refreshHard(),
                document.dispatchEvent(
                  new CustomEvent("quickview:open", {
                    detail: { initialized: e, productId: this.sectionId },
                  })
                );
            },
            updateModalProductInventory: function () {
              (window.inventories = window.inventories || {}),
                this.container
                  .querySelectorAll(".js-product-inventory-data")
                  .forEach((e) => {
                    var t = e.dataset.productId;
                    (window.inventories[t] = {}),
                      e
                        .querySelectorAll(".js-variant-inventory-data")
                        .forEach((e) => {
                          window.inventories[t][e.dataset.id] = {
                            quantity: e.dataset.quantity,
                            incoming: e.dataset.incoming,
                            next_incoming_date: e.dataset.date,
                          };
                        });
                  });
            },
            closeModalProduct: function () {
              this.stopVideos();
            },
            initModelViewerLibraries: function () {
              var e = this.container.querySelectorAll(this.selectors.media);
              e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              document.addEventListener(
                "shopify_xr_launch",
                function () {
                  this.container
                    .querySelector(
                      this.selectors.productMediaWrapper +
                        ":not(." +
                        self.classes.hidden +
                        ")"
                    )
                    .dispatchEvent(
                      new CustomEvent("xrLaunch", {
                        bubbles: !0,
                        cancelable: !0,
                      })
                    );
                }.bind(this)
              );
            },
            customMediaListners: function () {
              document
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.addEventListener(
                    "click",
                    function () {
                      var e = this.cache.mainSlider
                        .querySelector(i.currentSlide)
                        .querySelector(this.selectors.media);
                      e &&
                        e.dispatchEvent(
                          new CustomEvent("mediaHidden", {
                            bubbles: !0,
                            cancelable: !0,
                          })
                        );
                    }.bind(this)
                  );
                });
              var e = this.container.querySelectorAll("model-viewer");
              e.length &&
                e.forEach((e) => {
                  e.addEventListener(
                    "shopify_model_viewer_ui_toggle_play",
                    function (e) {
                      this.mediaLoaded(e);
                    }.bind(this)
                  ),
                    e.addEventListener(
                      "shopify_model_viewer_ui_toggle_pause",
                      function (e) {
                        this.mediaUnloaded(e);
                      }.bind(this)
                    );
                });
            },
            mediaLoaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.remove(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!1);
            },
            mediaUnloaded: function (e) {
              this.container
                .querySelectorAll(this.selectors.closeMedia)
                .forEach((e) => {
                  e.classList.add(t.hidden);
                }),
                this.flickity && this.flickity.setDraggable(!0);
            },
            onUnload: function () {
              theme.ProductMedia.removeSectionModels(this.sectionId),
                this.flickity &&
                  "function" == typeof this.flickity.destroy &&
                  this.flickity.destroy();
            },
          })),
          n
        );
      })()),
      (theme.RecentlyViewed = (function () {
        var e = !1;
        function t(e) {
          e &&
            ((this.container = e),
            (this.sectionId = this.container.getAttribute("data-section-id")),
            (this.namespace = ".recently-viewed" + this.sectionId),
            (this.gridItemWidth = this.container.getAttribute(
              "data-grid-item-class"
            )),
            (this.rowOf = this.container.getAttribute("data-row-of")),
            theme.initWhenVisible({
              element: this.container,
              callback: this.init.bind(this),
              threshold: 600,
            }));
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              if (!e) {
                if (
                  ((e = !0),
                  0 === Object.keys(theme.recentlyViewed.recent).length &&
                    theme.recentlyViewed.recent.constructor === Object)
                ) {
                  this.container.classList.add("hide");
                  return;
                }
                (this.outputContainer = document.getElementById(
                  "RecentlyViewed-" + this.sectionId
                )),
                  (this.handle = this.container.getAttribute(
                    "data-product-handle"
                  ));
                var t = [];
                Object.keys(theme.recentlyViewed.recent).forEach(
                  function (e) {
                    "undefined" !== e && t.push(this.getProductInfo(e));
                  }.bind(this)
                ),
                  Promise.all(t).then(
                    function (e) {
                      this.setupOutput(e), this.captureProductDetails(e);
                    }.bind(this)
                  );
              }
            },
            getProductInfo: function (e) {
              return new Promise(function (t, i) {
                theme.recentlyViewed.productInfo.hasOwnProperty(e)
                  ? t(theme.recentlyViewed.productInfo[e])
                  : fetch("/products/" + e + ".js")
                      .then(function (e) {
                        return e.text();
                      })
                      .then(function (e) {
                        t(e);
                      });
              });
            },
            setupOutput: function (e) {
              var t = [],
                i = this.container.getAttribute("data-recent-count"),
                n = 0;
              if (
                (Object.keys(e).forEach(
                  function (i) {
                    if (e[i]) {
                      var r = JSON.parse(e[i]);
                      if (r.handle !== this.handle && void 0 !== r.handle) {
                        n++,
                          (r.url = theme.recentlyViewed.recent[r.handle]
                            ? theme.recentlyViewed.recent[r.handle].url
                            : r.url),
                          (r.image_responsive_url =
                            theme.recentlyViewed.recent[
                              r.handle
                            ].featuredImage),
                          (r.image_aspect_ratio =
                            theme.recentlyViewed.recent[r.handle].aspectRatio);
                        var o = r.variants[0];
                        if (o && o.unit_price) {
                          var a = "";
                          o.unit_price_measurement &&
                            (1 != o.unit_price_measurement.reference_value &&
                              (a +=
                                o.unit_price_measurement.reference_value + " "),
                            (a += o.unit_price_measurement.reference_unit)),
                            (r.unit_price = theme.Currency.formatMoney(
                              o.unit_price
                            )),
                            "" != a && (r.unit_price += "/" + a);
                        }
                        t.unshift(r);
                      }
                    }
                  }.bind(this)
                ),
                0 === t.length)
              ) {
                this.container.classList.add("hide");
                return;
              }
              var r = theme.buildProductGridItem(
                t.slice(0, i),
                this.gridItemWidth,
                this.rowOf
              );
              (this.outputContainer.innerHTML = r), AOS && AOS.refreshHard();
            },
            captureProductDetails: function (e) {
              for (var t = 0; t < e.length; t++) {
                var i = e[t];
                theme.recentlyViewed.productInfo[i.handle] = i;
              }
              theme.config.hasSessionStorage &&
                sessionStorage.setItem(
                  "recent-products",
                  JSON.stringify(theme.recentlyViewed.productInfo)
                );
            },
            onUnload: function () {
              e = !1;
            },
          })),
          t
        );
      })()),
      (theme.Testimonials = (function () {
        var e = {
          adaptiveHeight: !0,
          avoidReflow: !0,
          pageDots: !0,
          prevNextButtons: !1,
        };
        function t(e) {
          (this.container = e), this.timeout;
          var t = e.getAttribute("data-section-id");
          (this.slideshow = e.querySelector("#Testimonials-" + t)),
            (this.namespace = ".testimonial-" + t),
            this.slideshow &&
              theme.initWhenVisible({
                element: this.container,
                callback: this.init.bind(this),
                threshold: 600,
              });
        }
        return (
          (t.prototype = Object.assign({}, t.prototype, {
            init: function () {
              this.slideshow.dataset.count <= 3 && (e.wrapAround = !1),
                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                this.slideshow.dataset.count > 2 &&
                  (this.timeout = setTimeout(
                    function () {
                      this.flickity.goToSlide(1);
                    }.bind(this),
                    1e3
                  ));
            },
            onUnload: function () {
              this.flickity &&
                "function" == typeof this.flickity.destroy &&
                this.flickity.destroy();
            },
            onDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
            onBlockSelect: function (e) {
              var t = parseInt(
                this.slideshow.querySelector(
                  ".testimonials-slide--" + e.detail.blockId
                ).dataset.index
              );
              clearTimeout(this.timeout),
                this.flickity &&
                  "function" == typeof this.flickity.pause &&
                  (this.flickity.goToSlide(t), this.flickity.pause());
            },
            onBlockDeselect: function () {
              this.flickity &&
                "function" == typeof this.flickity.play &&
                this.flickity.play();
            },
          })),
          t
        );
      })()),
      (theme.isStorageSupported = function (e) {
        if (window.self !== window.top) return !1;
        var t,
          i = "test";
        "session" === e && (t = window.sessionStorage),
          "local" === e && (t = window.localStorage);
        try {
          return t.setItem(i, "1"), t.removeItem(i), !0;
        } catch (n) {
          return !1;
        }
      }),
      (theme.reinitProductGridItem = function (e) {
        AOS && AOS.refreshHard(),
          theme.initQuickShop(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          theme.collapsibles.init();
      }),
      (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
      (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
      AOS.init({
        easing: "ease-out-quad",
        once: !0,
        offset: 60,
        disableMutationObserver: !0,
      }),
      theme.config.hasLocalStorage &&
        ((theme.recentlyViewed.localStorage =
          window.localStorage.getItem("theme-recent")),
        theme.recentlyViewed.localStorage &&
          (theme.recentlyViewed.recent = JSON.parse(
            theme.recentlyViewed.localStorage
          ))),
      (theme.recentlyViewed.productInfo =
        theme.config.hasSessionStorage && sessionStorage["recent-products"]
          ? JSON.parse(sessionStorage["recent-products"])
          : {}),
      (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
      matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
        e.matches
          ? ((theme.config.bpSmall = !0),
            document.dispatchEvent(new CustomEvent("matchSmall")))
          : ((theme.config.bpSmall = !1),
            document.dispatchEvent(new CustomEvent("unmatchSmall")));
      }),
      (theme.initGlobals = function () {
        theme.collapsibles.init(), theme.videoModal();
      }),
      (o = function () {
        if (
          ((theme.sections = new theme.Sections()),
          theme.sections.register("slideshow-section", theme.SlideshowSection),
          theme.sections.register("header", theme.HeaderSection),
          theme.sections.register("product", theme.Product),
          theme.sections.register("blog", theme.Blog),
          theme.sections.register("password-header", theme.PasswordHeader),
          theme.sections.register("photoswipe", theme.Photoswipe),
          theme.sections.register(
            "product-recommendations",
            theme.Recommendations
          ),
          theme.sections.register("background-image", theme.BackgroundImage),
          theme.sections.register("testimonials", theme.Testimonials),
          theme.sections.register("video-section", theme.VideoSection),
          theme.sections.register("map", theme.Maps),
          theme.sections.register("footer-section", theme.FooterSection),
          theme.sections.register(
            "store-availability",
            theme.StoreAvailability
          ),
          theme.sections.register("recently-viewed", theme.RecentlyViewed),
          theme.sections.register("newsletter-popup", theme.NewsletterPopup),
          theme.sections.register("collection-header", theme.CollectionHeader),
          theme.sections.register("collection-template", theme.Collection),
          theme.initGlobals(),
          theme.initQuickShop(),
          theme.rteInit(),
          document.body.classList.contains("template-cart"))
        ) {
          var e = document.getElementById("CartPageForm");
          e && new theme.CartForm(e);
        }
        theme.settings.predictiveSearch && theme.predictiveSearch.init(),
          theme.settings.isCustomerTemplate && theme.customerTemplates(),
          document.dispatchEvent(new CustomEvent("page:loaded"));
      }),
      "loading" != document.readyState
        ? o()
        : document.addEventListener("DOMContentLoaded", o);
  })(),
  (function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = e.document
          ? t(e, !0)
          : function (e) {
              if (!e.document)
                throw Error("jQuery requires a window with a document");
              return t(e);
            })
      : t(e);
  })("undefined" != typeof window ? window : this, function (e, t) {
    "use strict";
    var i = [],
      n = Object.getPrototypeOf,
      r = i.slice,
      o = i.flat
        ? function (e) {
            return i.flat.call(e);
          }
        : function (e) {
            return i.concat.apply([], e);
          },
      a = i.push,
      s = i.indexOf,
      c = {},
      l = c.toString,
      d = c.hasOwnProperty,
      u = d.toString,
      h = u.call(Object),
      p = {},
      f = function (e) {
        return "function" == typeof e && "number" != typeof e.nodeType;
      },
      m = function (e) {
        return null != e && e === e.window;
      },
      g = e.document,
      v = { type: !0, src: !0, nonce: !0, noModule: !0 };
    function y(e, t, i) {
      var n,
        r,
        o = (i = i || g).createElement("script");
      if (((o.text = e), t))
        for (n in v)
          (r = t[n] || (t.getAttribute && t.getAttribute(n))) &&
            o.setAttribute(n, r);
      i.head.appendChild(o).parentNode.removeChild(o);
    }
    function b(e) {
      return null == e
        ? e + ""
        : "object" == typeof e || "function" == typeof e
        ? c[l.call(e)] || "object"
        : typeof e;
    }
    var S = "3.5.1",
      w = function (e, t) {
        return new w.fn.init(e, t);
      };
    function x(e) {
      var t = !!e && "length" in e && e.length,
        i = b(e);
      return (
        !f(e) &&
        !m(e) &&
        ("array" === i ||
          0 === t ||
          ("number" == typeof t && 0 < t && t - 1 in e))
      );
    }
    (w.fn = w.prototype =
      {
        jquery: S,
        constructor: w,
        length: 0,
        toArray: function () {
          return r.call(this);
        },
        get: function (e) {
          return null == e
            ? r.call(this)
            : e < 0
            ? this[e + this.length]
            : this[e];
        },
        pushStack: function (e) {
          var t = w.merge(this.constructor(), e);
          return (t.prevObject = this), t;
        },
        each: function (e) {
          return w.each(this, e);
        },
        map: function (e) {
          return this.pushStack(
            w.map(this, function (t, i) {
              return e.call(t, i, t);
            })
          );
        },
        slice: function () {
          return this.pushStack(r.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        even: function () {
          return this.pushStack(
            w.grep(this, function (e, t) {
              return (t + 1) % 2;
            })
          );
        },
        odd: function () {
          return this.pushStack(
            w.grep(this, function (e, t) {
              return t % 2;
            })
          );
        },
        eq: function (e) {
          var t = this.length,
            i = +e + (e < 0 ? t : 0);
          return this.pushStack(0 <= i && i < t ? [this[i]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: a,
        sort: i.sort,
        splice: i.splice,
      }),
      (w.extend = w.fn.extend =
        function () {
          var e,
            t,
            i,
            n,
            r,
            o,
            a = arguments[0] || {},
            s = 1,
            c = arguments.length,
            l = !1;
          for (
            "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
              "object" == typeof a || f(a) || (a = {}),
              s === c && ((a = this), s--);
            s < c;
            s++
          )
            if (null != (e = arguments[s]))
              for (t in e)
                (n = e[t]),
                  "__proto__" !== t &&
                    a !== n &&
                    (l && n && (w.isPlainObject(n) || (r = Array.isArray(n)))
                      ? ((i = a[t]),
                        (o =
                          r && !Array.isArray(i)
                            ? []
                            : r || w.isPlainObject(i)
                            ? i
                            : {}),
                        (r = !1),
                        (a[t] = w.extend(l, o, n)))
                      : void 0 !== n && (a[t] = n));
          return a;
        }),
      w.extend({
        expando: "jQuery" + (S + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (e) {
          throw Error(e);
        },
        noop: function () {},
        isPlainObject: function (e) {
          var t, i;
          return (
            !(!e || "[object Object]" !== l.call(e)) &&
            (!(t = n(e)) ||
              ("function" ==
                typeof (i = d.call(t, "constructor") && t.constructor) &&
                u.call(i) === h))
          );
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        globalEval: function (e, t, i) {
          y(e, { nonce: t && t.nonce }, i);
        },
        each: function (e, t) {
          var i,
            n = 0;
          if (x(e))
            for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
          else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
          return e;
        },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (x(Object(e))
                ? w.merge(i, "string" == typeof e ? [e] : e)
                : a.call(i, e)),
            i
          );
        },
        inArray: function (e, t, i) {
          return null == t ? -1 : s.call(t, e, i);
        },
        merge: function (e, t) {
          for (var i = +t.length, n = 0, r = e.length; n < i; n++)
            e[r++] = t[n];
          return (e.length = r), e;
        },
        grep: function (e, t, i) {
          for (var n = [], r = 0, o = e.length, a = !i; r < o; r++)
            !t(e[r], r) !== a && n.push(e[r]);
          return n;
        },
        map: function (e, t, i) {
          var n,
            r,
            a = 0,
            s = [];
          if (x(e))
            for (n = e.length; a < n; a++)
              null != (r = t(e[a], a, i)) && s.push(r);
          else for (a in e) null != (r = t(e[a], a, i)) && s.push(r);
          return o(s);
        },
        guid: 1,
        support: p,
      }),
      "function" == typeof Symbol &&
        (w.fn[Symbol.iterator] = i[Symbol.iterator]),
      w.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (e, t) {
          c["[object " + t + "]"] = t.toLowerCase();
        }
      );
    var _ = (function (e) {
      var t,
        i,
        n,
        r,
        o,
        a,
        s,
        c,
        l,
        d,
        u,
        h,
        p,
        f,
        m,
        g,
        v,
        y,
        b,
        S = "sizzle" + 1 * new Date(),
        w = e.document,
        x = 0,
        _ = 0,
        k = ed(),
        L = ed(),
        C = ed(),
        E = ed(),
        T = function (e, t) {
          return e === t && (u = !0), 0;
        },
        q = {}.hasOwnProperty,
        I = [],
        A = I.pop,
        P = I.push,
        D = I.push,
        N = I.slice,
        j = function (e, t) {
          for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
          return -1;
        },
        M =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        H = "[\\x20\\t\\r\\n\\f]",
        O =
          "(?:\\\\[\\da-fA-F]{1,6}" +
          H +
          "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
        V =
          "\\[" +
          H +
          "*(" +
          O +
          ")(?:" +
          H +
          "*([*^$|!~]?=)" +
          H +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          O +
          "))|)" +
          H +
          "*\\]",
        B =
          ":(" +
          O +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          V +
          ")*)|.*)\\)|)",
        R = RegExp(H + "+", "g"),
        F = RegExp("^" + H + "+|((?:^|[^\\\\])(?:\\\\.)*)" + H + "+$", "g"),
        U = RegExp("^" + H + "*," + H + "*"),
        W = RegExp("^" + H + "*([>+~]|" + H + ")" + H + "*"),
        z = RegExp(H + "|>"),
        Q = RegExp(B),
        G = RegExp("^" + O + "$"),
        X = {
          ID: RegExp("^#(" + O + ")"),
          CLASS: RegExp("^\\.(" + O + ")"),
          TAG: RegExp("^(" + O + "|[*])"),
          ATTR: RegExp("^" + V),
          PSEUDO: RegExp("^" + B),
          CHILD: RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              H +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              H +
              "*(?:([+-]|)" +
              H +
              "*(\\d+)|))" +
              H +
              "*\\)|)",
            "i"
          ),
          bool: RegExp("^(?:" + M + ")$", "i"),
          needsContext: RegExp(
            "^" +
              H +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              H +
              "*((?:-\\d)?\\d*)" +
              H +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        Y = /HTML$/i,
        K = /^(?:input|select|textarea|button)$/i,
        J = /^h\d$/i,
        Z = /^[^{]+\{\s*\[native \w/,
        ee = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        et = /[+~]/,
        ei = RegExp("\\\\[\\da-fA-F]{1,6}" + H + "?|\\\\([^\\r\\n\\f])", "g"),
        en = function (e, t) {
          var i = "0x" + e.slice(1) - 65536;
          return (
            t ||
            (i < 0
              ? String.fromCharCode(i + 65536)
              : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320))
          );
        },
        er = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        eo = function (e, t) {
          return t
            ? "\0" === e
              ? "�"
              : e.slice(0, -1) +
                "\\" +
                e.charCodeAt(e.length - 1).toString(16) +
                " "
            : "\\" + e;
        },
        ea = function () {
          h();
        },
        es = ew(
          function (e) {
            return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
          },
          { dir: "parentNode", next: "legend" }
        );
      try {
        D.apply((I = N.call(w.childNodes)), w.childNodes),
          I[w.childNodes.length].nodeType;
      } catch (ec) {
        D = {
          apply: I.length
            ? function (e, t) {
                P.apply(e, N.call(t));
              }
            : function (e, t) {
                for (var i = e.length, n = 0; (e[i++] = t[n++]); );
                e.length = i - 1;
              },
        };
      }
      function el(e, t, n, r) {
        var o,
          s,
          l,
          d,
          u,
          f,
          v,
          y = t && t.ownerDocument,
          w = t ? t.nodeType : 9;
        if (
          ((n = n || []),
          "string" != typeof e || !e || (1 !== w && 9 !== w && 11 !== w))
        )
          return n;
        if (!r && (h(t), (t = t || p), m)) {
          if (11 !== w && (u = ee.exec(e))) {
            if ((o = u[1])) {
              if (9 === w) {
                if (!(l = t.getElementById(o))) return n;
                if (l.id === o) return n.push(l), n;
              } else if (
                y &&
                (l = y.getElementById(o)) &&
                b(t, l) &&
                l.id === o
              )
                return n.push(l), n;
            } else {
              if (u[2]) return D.apply(n, t.getElementsByTagName(e)), n;
              if (
                (o = u[3]) &&
                i.getElementsByClassName &&
                t.getElementsByClassName
              )
                return D.apply(n, t.getElementsByClassName(o)), n;
            }
          }
          if (
            i.qsa &&
            !E[e + " "] &&
            (!g || !g.test(e)) &&
            (1 !== w || "object" !== t.nodeName.toLowerCase())
          ) {
            if (((v = e), (y = t), 1 === w && (z.test(e) || W.test(e)))) {
              for (
                ((y = (et.test(e) && eb(t.parentNode)) || t) === t &&
                  i.scope) ||
                  ((d = t.getAttribute("id"))
                    ? (d = d.replace(er, eo))
                    : t.setAttribute("id", (d = S))),
                  s = (f = a(e)).length;
                s--;

              )
                f[s] = (d ? "#" + d : ":scope") + " " + eS(f[s]);
              v = f.join(",");
            }
            try {
              return D.apply(n, y.querySelectorAll(v)), n;
            } catch (x) {
              E(e, !0);
            } finally {
              d === S && t.removeAttribute("id");
            }
          }
        }
        return c(e.replace(F, "$1"), t, n, r);
      }
      function ed() {
        var e = [];
        return function t(i, r) {
          return (
            e.push(i + " ") > n.cacheLength && delete t[e.shift()],
            (t[i + " "] = r)
          );
        };
      }
      function eu(e) {
        return (e[S] = !0), e;
      }
      function eh(e) {
        var t = p.createElement("fieldset");
        try {
          return !!e(t);
        } catch (i) {
          return !1;
        } finally {
          t.parentNode && t.parentNode.removeChild(t), (t = null);
        }
      }
      function ep(e, t) {
        for (var i = e.split("|"), r = i.length; r--; ) n.attrHandle[i[r]] = t;
      }
      function ef(e, t) {
        var i = t && e,
          n =
            i &&
            1 === e.nodeType &&
            1 === t.nodeType &&
            e.sourceIndex - t.sourceIndex;
        if (n) return n;
        if (i) {
          for (; (i = i.nextSibling); ) if (i === t) return -1;
        }
        return e ? 1 : -1;
      }
      function em(e) {
        return function (t) {
          return "input" === t.nodeName.toLowerCase() && t.type === e;
        };
      }
      function eg(e) {
        return function (t) {
          var i = t.nodeName.toLowerCase();
          return ("input" === i || "button" === i) && t.type === e;
        };
      }
      function ev(e) {
        return function (t) {
          return "form" in t
            ? t.parentNode && !1 === t.disabled
              ? "label" in t
                ? "label" in t.parentNode
                  ? t.parentNode.disabled === e
                  : t.disabled === e
                : t.isDisabled === e || (!e !== t.isDisabled && es(t) === e)
              : t.disabled === e
            : "label" in t && t.disabled === e;
        };
      }
      function ey(e) {
        return eu(function (t) {
          return (
            (t = +t),
            eu(function (i, n) {
              for (var r, o = e([], i.length, t), a = o.length; a--; )
                i[(r = o[a])] && (i[r] = !(n[r] = i[r]));
            })
          );
        });
      }
      function eb(e) {
        return e && void 0 !== e.getElementsByTagName && e;
      }
      for (t in ((i = el.support = {}),
      (o = el.isXML =
        function (e) {
          var t = e.namespaceURI,
            i = (e.ownerDocument || e).documentElement;
          return !Y.test(t || (i && i.nodeName) || "HTML");
        }),
      (h = el.setDocument =
        function (e) {
          var t,
            r,
            a = e ? e.ownerDocument || e : w;
          return (
            a != p &&
              9 === a.nodeType &&
              a.documentElement &&
              ((f = (p = a).documentElement),
              (m = !o(p)),
              w != p &&
                (r = p.defaultView) &&
                r.top !== r &&
                (r.addEventListener
                  ? r.addEventListener("unload", ea, !1)
                  : r.attachEvent && r.attachEvent("onunload", ea)),
              (i.scope = eh(function (e) {
                return (
                  f.appendChild(e).appendChild(p.createElement("div")),
                  void 0 !== e.querySelectorAll &&
                    !e.querySelectorAll(":scope fieldset div").length
                );
              })),
              (i.attributes = eh(function (e) {
                return (e.className = "i"), !e.getAttribute("className");
              })),
              (i.getElementsByTagName = eh(function (e) {
                return (
                  e.appendChild(p.createComment("")),
                  !e.getElementsByTagName("*").length
                );
              })),
              (i.getElementsByClassName = Z.test(p.getElementsByClassName)),
              (i.getById = eh(function (e) {
                return (
                  (f.appendChild(e).id = S),
                  !p.getElementsByName || !p.getElementsByName(S).length
                );
              })),
              i.getById
                ? ((n.filter.ID = function (e) {
                    var t = e.replace(ei, en);
                    return function (e) {
                      return e.getAttribute("id") === t;
                    };
                  }),
                  (n.find.ID = function (e, t) {
                    if (void 0 !== t.getElementById && m) {
                      var i = t.getElementById(e);
                      return i ? [i] : [];
                    }
                  }))
                : ((n.filter.ID = function (e) {
                    var t = e.replace(ei, en);
                    return function (e) {
                      var i =
                        void 0 !== e.getAttributeNode &&
                        e.getAttributeNode("id");
                      return i && i.value === t;
                    };
                  }),
                  (n.find.ID = function (e, t) {
                    if (void 0 !== t.getElementById && m) {
                      var i,
                        n,
                        r,
                        o = t.getElementById(e);
                      if (o) {
                        if ((i = o.getAttributeNode("id")) && i.value === e)
                          return [o];
                        for (r = t.getElementsByName(e), n = 0; (o = r[n++]); )
                          if ((i = o.getAttributeNode("id")) && i.value === e)
                            return [o];
                      }
                      return [];
                    }
                  })),
              (n.find.TAG = i.getElementsByTagName
                ? function (e, t) {
                    return void 0 !== t.getElementsByTagName
                      ? t.getElementsByTagName(e)
                      : i.qsa
                      ? t.querySelectorAll(e)
                      : void 0;
                  }
                : function (e, t) {
                    var i,
                      n = [],
                      r = 0,
                      o = t.getElementsByTagName(e);
                    if ("*" === e) {
                      for (; (i = o[r++]); ) 1 === i.nodeType && n.push(i);
                      return n;
                    }
                    return o;
                  }),
              (n.find.CLASS =
                i.getElementsByClassName &&
                function (e, t) {
                  if (void 0 !== t.getElementsByClassName && m)
                    return t.getElementsByClassName(e);
                }),
              (v = []),
              (g = []),
              (i.qsa = Z.test(p.querySelectorAll)) &&
                (eh(function (e) {
                  var t;
                  (f.appendChild(e).innerHTML =
                    "<a id='" +
                    S +
                    "'></a><select id='" +
                    S +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    e.querySelectorAll("[msallowcapture^='']").length &&
                      g.push("[*^$]=" + H + "*(?:''|\"\")"),
                    e.querySelectorAll("[selected]").length ||
                      g.push("\\[" + H + "*(?:value|" + M + ")"),
                    e.querySelectorAll("[id~=" + S + "-]").length ||
                      g.push("~="),
                    (t = p.createElement("input")).setAttribute("name", ""),
                    e.appendChild(t),
                    e.querySelectorAll("[name='']").length ||
                      g.push(
                        "\\[" + H + "*name" + H + "*=" + H + "*(?:''|\"\")"
                      ),
                    e.querySelectorAll(":checked").length || g.push(":checked"),
                    e.querySelectorAll("a#" + S + "+*").length ||
                      g.push(".#.+[+~]"),
                    e.querySelectorAll("\\\f"),
                    g.push("[\\r\\n\\f]");
                }),
                eh(function (e) {
                  e.innerHTML =
                    "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                  var t = p.createElement("input");
                  t.setAttribute("type", "hidden"),
                    e.appendChild(t).setAttribute("name", "D"),
                    e.querySelectorAll("[name=d]").length &&
                      g.push("name" + H + "*[*^$|!~]?="),
                    2 !== e.querySelectorAll(":enabled").length &&
                      g.push(":enabled", ":disabled"),
                    (f.appendChild(e).disabled = !0),
                    2 !== e.querySelectorAll(":disabled").length &&
                      g.push(":enabled", ":disabled"),
                    e.querySelectorAll("*,:x"),
                    g.push(",.*:");
                })),
              (i.matchesSelector = Z.test(
                (y =
                  f.matches ||
                  f.webkitMatchesSelector ||
                  f.mozMatchesSelector ||
                  f.oMatchesSelector ||
                  f.msMatchesSelector)
              )) &&
                eh(function (e) {
                  (i.disconnectedMatch = y.call(e, "*")),
                    y.call(e, "[s!='']:x"),
                    v.push("!=", B);
                }),
              (g = g.length && RegExp(g.join("|"))),
              (v = v.length && RegExp(v.join("|"))),
              (b =
                (t = Z.test(f.compareDocumentPosition)) || Z.test(f.contains)
                  ? function (e, t) {
                      var i = 9 === e.nodeType ? e.documentElement : e,
                        n = t && t.parentNode;
                      return (
                        e === n ||
                        !(
                          !n ||
                          1 !== n.nodeType ||
                          !(i.contains
                            ? i.contains(n)
                            : e.compareDocumentPosition &&
                              16 & e.compareDocumentPosition(n))
                        )
                      );
                    }
                  : function (e, t) {
                      if (t) {
                        for (; (t = t.parentNode); ) if (t === e) return !0;
                      }
                      return !1;
                    }),
              (T = t
                ? function (e, t) {
                    if (e === t) return (u = !0), 0;
                    var n =
                      !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return (
                      n ||
                      (1 &
                        (n =
                          (e.ownerDocument || e) == (t.ownerDocument || t)
                            ? e.compareDocumentPosition(t)
                            : 1) ||
                      (!i.sortDetached && t.compareDocumentPosition(e) === n)
                        ? e == p || (e.ownerDocument == w && b(w, e))
                          ? -1
                          : t == p || (t.ownerDocument == w && b(w, t))
                          ? 1
                          : d
                          ? j(d, e) - j(d, t)
                          : 0
                        : 4 & n
                        ? -1
                        : 1)
                    );
                  }
                : function (e, t) {
                    if (e === t) return (u = !0), 0;
                    var i,
                      n = 0,
                      r = e.parentNode,
                      o = t.parentNode,
                      a = [e],
                      s = [t];
                    if (!r || !o)
                      return e == p
                        ? -1
                        : t == p
                        ? 1
                        : r
                        ? -1
                        : o
                        ? 1
                        : d
                        ? j(d, e) - j(d, t)
                        : 0;
                    if (r === o) return ef(e, t);
                    for (i = e; (i = i.parentNode); ) a.unshift(i);
                    for (i = t; (i = i.parentNode); ) s.unshift(i);
                    for (; a[n] === s[n]; ) n++;
                    return n
                      ? ef(a[n], s[n])
                      : a[n] == w
                      ? -1
                      : s[n] == w
                      ? 1
                      : 0;
                  })),
            p
          );
        }),
      (el.matches = function (e, t) {
        return el(e, null, null, t);
      }),
      (el.matchesSelector = function (e, t) {
        if (
          (h(e),
          i.matchesSelector &&
            m &&
            !E[t + " "] &&
            (!v || !v.test(t)) &&
            (!g || !g.test(t)))
        )
          try {
            var n = y.call(e, t);
            if (
              n ||
              i.disconnectedMatch ||
              (e.document && 11 !== e.document.nodeType)
            )
              return n;
          } catch (r) {
            E(t, !0);
          }
        return 0 < el(t, p, null, [e]).length;
      }),
      (el.contains = function (e, t) {
        return (e.ownerDocument || e) != p && h(e), b(e, t);
      }),
      (el.attr = function (e, t) {
        (e.ownerDocument || e) != p && h(e);
        var r = n.attrHandle[t.toLowerCase()],
          o = r && q.call(n.attrHandle, t.toLowerCase()) ? r(e, t, !m) : void 0;
        return void 0 !== o
          ? o
          : i.attributes || !m
          ? e.getAttribute(t)
          : (o = e.getAttributeNode(t)) && o.specified
          ? o.value
          : null;
      }),
      (el.escape = function (e) {
        return (e + "").replace(er, eo);
      }),
      (el.error = function (e) {
        throw Error("Syntax error, unrecognized expression: " + e);
      }),
      (el.uniqueSort = function (e) {
        var t,
          n = [],
          r = 0,
          o = 0;
        if (
          ((u = !i.detectDuplicates),
          (d = !i.sortStable && e.slice(0)),
          e.sort(T),
          u)
        ) {
          for (; (t = e[o++]); ) t === e[o] && (r = n.push(o));
          for (; r--; ) e.splice(n[r], 1);
        }
        return (d = null), e;
      }),
      (r = el.getText =
        function (e) {
          var t,
            i = "",
            n = 0,
            o = e.nodeType;
          if (o) {
            if (1 === o || 9 === o || 11 === o) {
              if ("string" == typeof e.textContent) return e.textContent;
              for (e = e.firstChild; e; e = e.nextSibling) i += r(e);
            } else if (3 === o || 4 === o) return e.nodeValue;
          } else for (; (t = e[n++]); ) i += r(t);
          return i;
        }),
      ((n = el.selectors =
        {
          cacheLength: 50,
          createPseudo: eu,
          match: X,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (e) {
              return (
                (e[1] = e[1].replace(ei, en)),
                (e[3] = (e[3] || e[4] || e[5] || "").replace(ei, en)),
                "~=" === e[2] && (e[3] = " " + e[3] + " "),
                e.slice(0, 4)
              );
            },
            CHILD: function (e) {
              return (
                (e[1] = e[1].toLowerCase()),
                "nth" === e[1].slice(0, 3)
                  ? (e[3] || el.error(e[0]),
                    (e[4] = +(e[4]
                      ? e[5] + (e[6] || 1)
                      : 2 * ("even" === e[3] || "odd" === e[3]))),
                    (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                  : e[3] && el.error(e[0]),
                e
              );
            },
            PSEUDO: function (e) {
              var t,
                i = !e[6] && e[2];
              return X.CHILD.test(e[0])
                ? null
                : (e[3]
                    ? (e[2] = e[4] || e[5] || "")
                    : i &&
                      Q.test(i) &&
                      (t = a(i, !0)) &&
                      (t = i.indexOf(")", i.length - t) - i.length) &&
                      ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                  e.slice(0, 3));
            },
          },
          filter: {
            TAG: function (e) {
              var t = e.replace(ei, en).toLowerCase();
              return "*" === e
                ? function () {
                    return !0;
                  }
                : function (e) {
                    return e.nodeName && e.nodeName.toLowerCase() === t;
                  };
            },
            CLASS: function (e) {
              var t = k[e + " "];
              return (
                t ||
                ((t = RegExp("(^|" + H + ")" + e + "(" + H + "|$)")),
                k(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                      ""
                  );
                }))
              );
            },
            ATTR: function (e, t, i) {
              return function (n) {
                var r = el.attr(n, e);
                return null == r
                  ? "!=" === t
                  : !t ||
                      ((r += ""),
                      "=" === t
                        ? r === i
                        : "!=" === t
                        ? r !== i
                        : "^=" === t
                        ? i && 0 === r.indexOf(i)
                        : "*=" === t
                        ? i && -1 < r.indexOf(i)
                        : "$=" === t
                        ? i && r.slice(-i.length) === i
                        : "~=" === t
                        ? -1 < (" " + r.replace(R, " ") + " ").indexOf(i)
                        : "|=" === t &&
                          (r === i || r.slice(0, i.length + 1) === i + "-"));
              };
            },
            CHILD: function (e, t, i, n, r) {
              var o = "nth" !== e.slice(0, 3),
                a = "last" !== e.slice(-4),
                s = "of-type" === t;
              return 1 === n && 0 === r
                ? function (e) {
                    return !!e.parentNode;
                  }
                : function (t, i, c) {
                    var l,
                      d,
                      u,
                      h,
                      p,
                      f,
                      m = o !== a ? "nextSibling" : "previousSibling",
                      g = t.parentNode,
                      v = s && t.nodeName.toLowerCase(),
                      y = !c && !s,
                      b = !1;
                    if (g) {
                      if (o) {
                        for (; m; ) {
                          for (h = t; (h = h[m]); )
                            if (
                              s
                                ? h.nodeName.toLowerCase() === v
                                : 1 === h.nodeType
                            )
                              return !1;
                          f = m = "only" === e && !f && "nextSibling";
                        }
                        return !0;
                      }
                      if (((f = [a ? g.firstChild : g.lastChild]), a && y)) {
                        for (
                          b =
                            (p =
                              (l =
                                (d =
                                  (u = (h = g)[S] || (h[S] = {}))[h.uniqueID] ||
                                  (u[h.uniqueID] = {}))[e] || [])[0] === x &&
                              l[1]) && l[2],
                            h = p && g.childNodes[p];
                          (h = (++p && h && h[m]) || (b = p = 0) || f.pop());

                        )
                          if (1 === h.nodeType && ++b && h === t) {
                            d[e] = [x, p, b];
                            break;
                          }
                      } else if (
                        (y &&
                          (b = p =
                            (l =
                              (d =
                                (u = (h = t)[S] || (h[S] = {}))[h.uniqueID] ||
                                (u[h.uniqueID] = {}))[e] || [])[0] === x &&
                            l[1]),
                        !1 === b)
                      )
                        for (
                          ;
                          (h = (++p && h && h[m]) || (b = p = 0) || f.pop()) &&
                          (!(
                            (s
                              ? h.nodeName.toLowerCase() === v
                              : 1 === h.nodeType) && ++b
                          ) ||
                            (y &&
                              ((d =
                                (u = h[S] || (h[S] = {}))[h.uniqueID] ||
                                (u[h.uniqueID] = {}))[e] = [x, b]),
                            h !== t));

                        );
                      return (b -= r) === n || (b % n == 0 && 0 <= b / n);
                    }
                  };
            },
            PSEUDO: function (e, t) {
              var i,
                r =
                  n.pseudos[e] ||
                  n.setFilters[e.toLowerCase()] ||
                  el.error("unsupported pseudo: " + e);
              return r[S]
                ? r(t)
                : 1 < r.length
                ? ((i = [e, e, "", t]),
                  n.setFilters.hasOwnProperty(e.toLowerCase())
                    ? eu(function (e, i) {
                        for (var n, o = r(e, t), a = o.length; a--; )
                          e[(n = j(e, o[a]))] = !(i[n] = o[a]);
                      })
                    : function (e) {
                        return r(e, 0, i);
                      })
                : r;
            },
          },
          pseudos: {
            not: eu(function (e) {
              var t = [],
                i = [],
                n = s(e.replace(F, "$1"));
              return n[S]
                ? eu(function (e, t, i, r) {
                    for (var o, a = n(e, null, r, []), s = e.length; s--; )
                      (o = a[s]) && (e[s] = !(t[s] = o));
                  })
                : function (e, r, o) {
                    return (
                      (t[0] = e), n(t, null, o, i), (t[0] = null), !i.pop()
                    );
                  };
            }),
            has: eu(function (e) {
              return function (t) {
                return 0 < el(e, t).length;
              };
            }),
            contains: eu(function (e) {
              return (
                (e = e.replace(ei, en)),
                function (t) {
                  return -1 < (t.textContent || r(t)).indexOf(e);
                }
              );
            }),
            lang: eu(function (e) {
              return (
                G.test(e || "") || el.error("unsupported lang: " + e),
                (e = e.replace(ei, en).toLowerCase()),
                function (t) {
                  var i;
                  do
                    if (
                      (i = m
                        ? t.lang
                        : t.getAttribute("xml:lang") || t.getAttribute("lang"))
                    )
                      return (
                        (i = i.toLowerCase()) === e || 0 === i.indexOf(e + "-")
                      );
                  while ((t = t.parentNode) && 1 === t.nodeType);
                  return !1;
                }
              );
            }),
            target: function (t) {
              var i = e.location && e.location.hash;
              return i && i.slice(1) === t.id;
            },
            root: function (e) {
              return e === f;
            },
            focus: function (e) {
              return (
                e === p.activeElement &&
                (!p.hasFocus || p.hasFocus()) &&
                !!(e.type || e.href || ~e.tabIndex)
              );
            },
            enabled: ev(!1),
            disabled: ev(!0),
            checked: function (e) {
              var t = e.nodeName.toLowerCase();
              return (
                ("input" === t && !!e.checked) ||
                ("option" === t && !!e.selected)
              );
            },
            selected: function (e) {
              return (
                e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
              );
            },
            empty: function (e) {
              for (e = e.firstChild; e; e = e.nextSibling)
                if (e.nodeType < 6) return !1;
              return !0;
            },
            parent: function (e) {
              return !n.pseudos.empty(e);
            },
            header: function (e) {
              return J.test(e.nodeName);
            },
            input: function (e) {
              return K.test(e.nodeName);
            },
            button: function (e) {
              var t = e.nodeName.toLowerCase();
              return ("input" === t && "button" === e.type) || "button" === t;
            },
            text: function (e) {
              var t;
              return (
                "input" === e.nodeName.toLowerCase() &&
                "text" === e.type &&
                (null == (t = e.getAttribute("type")) ||
                  "text" === t.toLowerCase())
              );
            },
            first: ey(function () {
              return [0];
            }),
            last: ey(function (e, t) {
              return [t - 1];
            }),
            eq: ey(function (e, t, i) {
              return [i < 0 ? i + t : i];
            }),
            even: ey(function (e, t) {
              for (var i = 0; i < t; i += 2) e.push(i);
              return e;
            }),
            odd: ey(function (e, t) {
              for (var i = 1; i < t; i += 2) e.push(i);
              return e;
            }),
            lt: ey(function (e, t, i) {
              for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; ) e.push(n);
              return e;
            }),
            gt: ey(function (e, t, i) {
              for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
              return e;
            }),
          },
        }).pseudos.nth = n.pseudos.eq),
      { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
        n.pseudos[t] = em(t);
      for (t in { submit: !0, reset: !0 }) n.pseudos[t] = eg(t);
      function e$() {}
      function eS(e) {
        for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
        return n;
      }
      function ew(e, t, i) {
        var n = t.dir,
          r = t.next,
          o = r || n,
          a = i && "parentNode" === o,
          s = _++;
        return t.first
          ? function (t, i, r) {
              for (; (t = t[n]); ) if (1 === t.nodeType || a) return e(t, i, r);
              return !1;
            }
          : function (t, i, c) {
              var l,
                d,
                u,
                h = [x, s];
              if (c) {
                for (; (t = t[n]); )
                  if ((1 === t.nodeType || a) && e(t, i, c)) return !0;
              } else
                for (; (t = t[n]); )
                  if (1 === t.nodeType || a) {
                    if (
                      ((d =
                        (u = t[S] || (t[S] = {}))[t.uniqueID] ||
                        (u[t.uniqueID] = {})),
                      r && r === t.nodeName.toLowerCase())
                    )
                      t = t[n] || t;
                    else {
                      if ((l = d[o]) && l[0] === x && l[1] === s)
                        return (h[2] = l[2]);
                      if (((d[o] = h)[2] = e(t, i, c))) return !0;
                    }
                  }
              return !1;
            };
      }
      function ex(e) {
        return 1 < e.length
          ? function (t, i, n) {
              for (var r = e.length; r--; ) if (!e[r](t, i, n)) return !1;
              return !0;
            }
          : e[0];
      }
      function e_(e, t, i, n, r) {
        for (var o, a = [], s = 0, c = e.length, l = null != t; s < c; s++)
          (o = e[s]) && ((i && !i(o, n, r)) || (a.push(o), l && t.push(s)));
        return a;
      }
      function ek(e, t, i, n, r, o) {
        return (
          n && !n[S] && (n = ek(n)),
          r && !r[S] && (r = ek(r, o)),
          eu(function (o, a, s, c) {
            var l,
              d,
              u,
              h = [],
              p = [],
              f = a.length,
              m =
                o ||
                (function (e, t, i) {
                  for (var n = 0, r = t.length; n < r; n++) el(e, t[n], i);
                  return i;
                })(t || "*", s.nodeType ? [s] : s, []),
              g = e && (o || !t) ? e_(m, h, e, s, c) : m,
              v = i ? (r || (o ? e : f || n) ? [] : a) : g;
            if ((i && i(g, v, s, c), n))
              for (l = e_(v, p), n(l, [], s, c), d = l.length; d--; )
                (u = l[d]) && (v[p[d]] = !(g[p[d]] = u));
            if (o) {
              if (r || e) {
                if (r) {
                  for (l = [], d = v.length; d--; )
                    (u = v[d]) && l.push((g[d] = u));
                  r(null, (v = []), l, c);
                }
                for (d = v.length; d--; )
                  (u = v[d]) &&
                    -1 < (l = r ? j(o, u) : h[d]) &&
                    (o[l] = !(a[l] = u));
              }
            } else (v = e_(v === a ? v.splice(f, v.length) : v)), r ? r(null, a, v, c) : D.apply(a, v);
          })
        );
      }
      function eL(e) {
        for (
          var t,
            i,
            r,
            o = e.length,
            a = n.relative[e[0].type],
            s = a || n.relative[" "],
            c = a ? 1 : 0,
            d = ew(
              function (e) {
                return e === t;
              },
              s,
              !0
            ),
            u = ew(
              function (e) {
                return -1 < j(t, e);
              },
              s,
              !0
            ),
            h = [
              function (e, i, n) {
                var r =
                  (!a && (n || i !== l)) ||
                  ((t = i).nodeType ? d(e, i, n) : u(e, i, n));
                return (t = null), r;
              },
            ];
          c < o;
          c++
        )
          if ((i = n.relative[e[c].type])) h = [ew(ex(h), i)];
          else {
            if ((i = n.filter[e[c].type].apply(null, e[c].matches))[S]) {
              for (r = ++c; r < o && !n.relative[e[r].type]; r++);
              return ek(
                1 < c && ex(h),
                1 < c &&
                  eS(
                    e
                      .slice(0, c - 1)
                      .concat({ value: " " === e[c - 2].type ? "*" : "" })
                  ).replace(F, "$1"),
                i,
                c < r && eL(e.slice(c, r)),
                r < o && eL((e = e.slice(r))),
                r < o && eS(e)
              );
            }
            h.push(i);
          }
        return ex(h);
      }
      return (
        (e$.prototype = n.filters = n.pseudos),
        (n.setFilters = new e$()),
        (a = el.tokenize =
          function (e, t) {
            var i,
              r,
              o,
              a,
              s,
              c,
              l,
              d = L[e + " "];
            if (d) return t ? 0 : d.slice(0);
            for (s = e, c = [], l = n.preFilter; s; ) {
              for (a in ((!i || (r = U.exec(s))) &&
                (r && (s = s.slice(r[0].length) || s), c.push((o = []))),
              (i = !1),
              (r = W.exec(s)) &&
                ((i = r.shift()),
                o.push({ value: i, type: r[0].replace(F, " ") }),
                (s = s.slice(i.length))),
              n.filter))
                (r = X[a].exec(s)) &&
                  (!l[a] || (r = l[a](r))) &&
                  ((i = r.shift()),
                  o.push({ value: i, type: a, matches: r }),
                  (s = s.slice(i.length)));
              if (!i) break;
            }
            return t ? s.length : s ? el.error(e) : L(e, c).slice(0);
          }),
        (s = el.compile =
          function (e, t) {
            var i,
              r,
              o,
              s,
              c,
              d,
              u = [],
              f = [],
              g = C[e + " "];
            if (!g) {
              for (t || (t = a(e)), i = t.length; i--; )
                (g = eL(t[i]))[S] ? u.push(g) : f.push(g);
              (g = C(
                e,
                ((r = f),
                (s = 0 < (o = u).length),
                (c = 0 < r.length),
                (d = function (e, t, i, a, d) {
                  var u,
                    f,
                    g,
                    v = 0,
                    y = "0",
                    b = e && [],
                    S = [],
                    w = l,
                    _ = e || (c && n.find.TAG("*", d)),
                    k = (x += null == w ? 1 : Math.random() || 0.1),
                    L = _.length;
                  for (
                    d && (l = t == p || t || d);
                    y !== L && null != (u = _[y]);
                    y++
                  ) {
                    if (c && u) {
                      for (
                        f = 0, t || u.ownerDocument == p || (h(u), (i = !m));
                        (g = r[f++]);

                      )
                        if (g(u, t || p, i)) {
                          a.push(u);
                          break;
                        }
                      d && (x = k);
                    }
                    s && ((u = !g && u) && v--, e && b.push(u));
                  }
                  if (((v += y), s && y !== v)) {
                    for (f = 0; (g = o[f++]); ) g(b, S, t, i);
                    if (e) {
                      if (0 < v)
                        for (; y--; ) b[y] || S[y] || (S[y] = A.call(a));
                      S = e_(S);
                    }
                    D.apply(a, S),
                      d &&
                        !e &&
                        0 < S.length &&
                        1 < v + o.length &&
                        el.uniqueSort(a);
                  }
                  return d && ((x = k), (l = w)), b;
                }),
                s ? eu(d) : d)
              )).selector = e;
            }
            return g;
          }),
        (c = el.select =
          function (e, t, i, r) {
            var o,
              c,
              l,
              d,
              u,
              h = "function" == typeof e && e,
              p = !r && a((e = h.selector || e));
            if (((i = i || []), 1 === p.length)) {
              if (
                2 < (c = p[0] = p[0].slice(0)).length &&
                "ID" === (l = c[0]).type &&
                9 === t.nodeType &&
                m &&
                n.relative[c[1].type]
              ) {
                if (
                  !(t = (n.find.ID(l.matches[0].replace(ei, en), t) || [])[0])
                )
                  return i;
                h && (t = t.parentNode), (e = e.slice(c.shift().value.length));
              }
              for (
                o = X.needsContext.test(e) ? 0 : c.length;
                o-- && ((l = c[o]), !n.relative[(d = l.type)]);

              )
                if (
                  (u = n.find[d]) &&
                  (r = u(
                    l.matches[0].replace(ei, en),
                    (et.test(c[0].type) && eb(t.parentNode)) || t
                  ))
                ) {
                  if ((c.splice(o, 1), !(e = r.length && eS(c))))
                    return D.apply(i, r), i;
                  break;
                }
            }
            return (
              (h || s(e, p))(
                r,
                t,
                !m,
                i,
                !t || (et.test(e) && eb(t.parentNode)) || t
              ),
              i
            );
          }),
        (i.sortStable = S.split("").sort(T).join("") === S),
        (i.detectDuplicates = !!u),
        h(),
        (i.sortDetached = eh(function (e) {
          return 1 & e.compareDocumentPosition(p.createElement("fieldset"));
        })),
        eh(function (e) {
          return (
            (e.innerHTML = "<a href='#'></a>"),
            "#" === e.firstChild.getAttribute("href")
          );
        }) ||
          ep("type|href|height|width", function (e, t, i) {
            if (!i)
              return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
          }),
        (i.attributes &&
          eh(function (e) {
            return (
              (e.innerHTML = "<input/>"),
              e.firstChild.setAttribute("value", ""),
              "" === e.firstChild.getAttribute("value")
            );
          })) ||
          ep("value", function (e, t, i) {
            if (!i && "input" === e.nodeName.toLowerCase())
              return e.defaultValue;
          }),
        eh(function (e) {
          return null == e.getAttribute("disabled");
        }) ||
          ep(M, function (e, t, i) {
            var n;
            if (!i)
              return !0 === e[t]
                ? t.toLowerCase()
                : (n = e.getAttributeNode(t)) && n.specified
                ? n.value
                : null;
          }),
        el
      );
    })(e);
    (w.find = _),
      (w.expr = _.selectors),
      (w.expr[":"] = w.expr.pseudos),
      (w.uniqueSort = w.unique = _.uniqueSort),
      (w.text = _.getText),
      (w.isXMLDoc = _.isXML),
      (w.contains = _.contains),
      (w.escapeSelector = _.escape);
    var k = function (e, t, i) {
        for (var n = [], r = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
          if (1 === e.nodeType) {
            if (r && w(e).is(i)) break;
            n.push(e);
          }
        return n;
      },
      L = function (e, t) {
        for (var i = []; e; e = e.nextSibling)
          1 === e.nodeType && e !== t && i.push(e);
        return i;
      },
      C = w.expr.match.needsContext;
    function E(e, t) {
      return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    var T = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function q(e, t, i) {
      return f(t)
        ? w.grep(e, function (e, n) {
            return !!t.call(e, n, e) !== i;
          })
        : t.nodeType
        ? w.grep(e, function (e) {
            return (e === t) !== i;
          })
        : "string" != typeof t
        ? w.grep(e, function (e) {
            return -1 < s.call(t, e) !== i;
          })
        : w.filter(t, e, i);
    }
    (w.filter = function (e, t, i) {
      var n = t[0];
      return (
        i && (e = ":not(" + e + ")"),
        1 === t.length && 1 === n.nodeType
          ? w.find.matchesSelector(n, e)
            ? [n]
            : []
          : w.find.matches(
              e,
              w.grep(t, function (e) {
                return 1 === e.nodeType;
              })
            )
      );
    }),
      w.fn.extend({
        find: function (e) {
          var t,
            i,
            n = this.length,
            r = this;
          if ("string" != typeof e)
            return this.pushStack(
              w(e).filter(function () {
                for (t = 0; t < n; t++) if (w.contains(r[t], this)) return !0;
              })
            );
          for (i = this.pushStack([]), t = 0; t < n; t++) w.find(e, r[t], i);
          return 1 < n ? w.uniqueSort(i) : i;
        },
        filter: function (e) {
          return this.pushStack(q(this, e || [], !1));
        },
        not: function (e) {
          return this.pushStack(q(this, e || [], !0));
        },
        is: function (e) {
          return !!q(
            this,
            "string" == typeof e && C.test(e) ? w(e) : e || [],
            !1
          ).length;
        },
      });
    var I,
      A = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((w.fn.init = function (e, t, i) {
      var n, r;
      if (!e) return this;
      if (((i = i || I), "string" == typeof e)) {
        if (
          !(n =
            "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
              ? [null, e, null]
              : A.exec(e)) ||
          (!n[1] && t)
        )
          return !t || t.jquery
            ? (t || i).find(e)
            : this.constructor(t).find(e);
        if (n[1]) {
          if (
            ((t = t instanceof w ? t[0] : t),
            w.merge(
              this,
              w.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : g, !0)
            ),
            T.test(n[1]) && w.isPlainObject(t))
          )
            for (n in t) f(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
          return this;
        }
        return (
          (r = g.getElementById(n[2])) && ((this[0] = r), (this.length = 1)),
          this
        );
      }
      return e.nodeType
        ? ((this[0] = e), (this.length = 1), this)
        : f(e)
        ? void 0 !== i.ready
          ? i.ready(e)
          : e(w)
        : w.makeArray(e, this);
    }).prototype = w.fn),
      (I = w(g));
    var P = /^(?:parents|prev(?:Until|All))/,
      D = { children: !0, contents: !0, next: !0, prev: !0 };
    function N(e, t) {
      for (; (e = e[t]) && 1 !== e.nodeType; );
      return e;
    }
    w.fn.extend({
      has: function (e) {
        var t = w(e, this),
          i = t.length;
        return this.filter(function () {
          for (var e = 0; e < i; e++) if (w.contains(this, t[e])) return !0;
        });
      },
      closest: function (e, t) {
        var i,
          n = 0,
          r = this.length,
          o = [],
          a = "string" != typeof e && w(e);
        if (!C.test(e)) {
          for (; n < r; n++)
            for (i = this[n]; i && i !== t; i = i.parentNode)
              if (
                i.nodeType < 11 &&
                (a
                  ? -1 < a.index(i)
                  : 1 === i.nodeType && w.find.matchesSelector(i, e))
              ) {
                o.push(i);
                break;
              }
        }
        return this.pushStack(1 < o.length ? w.uniqueSort(o) : o);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? s.call(w(e), this[0])
            : s.call(this, e.jquery ? e[0] : e)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      w.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return k(e, "parentNode");
          },
          parentsUntil: function (e, t, i) {
            return k(e, "parentNode", i);
          },
          next: function (e) {
            return N(e, "nextSibling");
          },
          prev: function (e) {
            return N(e, "previousSibling");
          },
          nextAll: function (e) {
            return k(e, "nextSibling");
          },
          prevAll: function (e) {
            return k(e, "previousSibling");
          },
          nextUntil: function (e, t, i) {
            return k(e, "nextSibling", i);
          },
          prevUntil: function (e, t, i) {
            return k(e, "previousSibling", i);
          },
          siblings: function (e) {
            return L((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return L(e.firstChild);
          },
          contents: function (e) {
            return null != e.contentDocument && n(e.contentDocument)
              ? e.contentDocument
              : (E(e, "template") && (e = e.content || e),
                w.merge([], e.childNodes));
          },
        },
        function (e, t) {
          w.fn[e] = function (i, n) {
            var r = w.map(this, t, i);
            return (
              "Until" !== e.slice(-5) && (n = i),
              n && "string" == typeof n && (r = w.filter(n, r)),
              1 < this.length &&
                (D[e] || w.uniqueSort(r), P.test(e) && r.reverse()),
              this.pushStack(r)
            );
          };
        }
      );
    var j = /[^\x20\t\r\n\f]+/g;
    function M(e) {
      return e;
    }
    function H(e) {
      throw e;
    }
    function O(e, t, i, n) {
      var r;
      try {
        e && f((r = e.promise))
          ? r.call(e).done(t).fail(i)
          : e && f((r = e.then))
          ? r.call(e, t, i)
          : t.apply(void 0, [e].slice(n));
      } catch (o) {
        i.apply(void 0, [o]);
      }
    }
    (w.Callbacks = function (e) {
      e =
        "string" == typeof e
          ? ((t = e),
            (i = {}),
            w.each(t.match(j) || [], function (e, t) {
              i[t] = !0;
            }),
            i)
          : w.extend({}, e);
      var t,
        i,
        n,
        r,
        o,
        a,
        s = [],
        c = [],
        l = -1,
        d = function () {
          for (a = a || e.once, o = n = !0; c.length; l = -1)
            for (r = c.shift(); ++l < s.length; )
              !1 === s[l].apply(r[0], r[1]) &&
                e.stopOnFalse &&
                ((l = s.length), (r = !1));
          e.memory || (r = !1), (n = !1), a && (s = r ? [] : "");
        },
        u = {
          add: function () {
            return (
              s &&
                (r && !n && ((l = s.length - 1), c.push(r)),
                (function t(i) {
                  w.each(i, function (i, n) {
                    f(n)
                      ? (e.unique && u.has(n)) || s.push(n)
                      : n && n.length && "string" !== b(n) && t(n);
                  });
                })(arguments),
                r && !n && d()),
              this
            );
          },
          remove: function () {
            return (
              w.each(arguments, function (e, t) {
                for (var i; -1 < (i = w.inArray(t, s, i)); )
                  s.splice(i, 1), i <= l && l--;
              }),
              this
            );
          },
          has: function (e) {
            return e ? -1 < w.inArray(e, s) : 0 < s.length;
          },
          empty: function () {
            return s && (s = []), this;
          },
          disable: function () {
            return (a = c = []), (s = r = ""), this;
          },
          disabled: function () {
            return !s;
          },
          lock: function () {
            return (a = c = []), r || n || (s = r = ""), this;
          },
          locked: function () {
            return !!a;
          },
          fireWith: function (e, t) {
            return (
              a ||
                ((t = [e, (t = t || []).slice ? t.slice() : t]),
                c.push(t),
                n || d()),
              this
            );
          },
          fire: function () {
            return u.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!o;
          },
        };
      return u;
    }),
      w.extend({
        Deferred: function (t) {
          var i = [
              [
                "notify",
                "progress",
                w.Callbacks("memory"),
                w.Callbacks("memory"),
                2,
              ],
              [
                "resolve",
                "done",
                w.Callbacks("once memory"),
                w.Callbacks("once memory"),
                0,
                "resolved",
              ],
              [
                "reject",
                "fail",
                w.Callbacks("once memory"),
                w.Callbacks("once memory"),
                1,
                "rejected",
              ],
            ],
            n = "pending",
            r = {
              state: function () {
                return n;
              },
              always: function () {
                return o.done(arguments).fail(arguments), this;
              },
              catch: function (e) {
                return r.then(null, e);
              },
              pipe: function () {
                var e = arguments;
                return w
                  .Deferred(function (t) {
                    w.each(i, function (i, n) {
                      var r = f(e[n[4]]) && e[n[4]];
                      o[n[1]](function () {
                        var e = r && r.apply(this, arguments);
                        e && f(e.promise)
                          ? e
                              .promise()
                              .progress(t.notify)
                              .done(t.resolve)
                              .fail(t.reject)
                          : t[n[0] + "With"](this, r ? [e] : arguments);
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              then: function (t, n, r) {
                var o = 0;
                function a(t, i, n, r) {
                  return function () {
                    var s = this,
                      c = arguments,
                      l = function () {
                        var e, l;
                        if (!(t < o)) {
                          if ((e = n.apply(s, c)) === i.promise())
                            throw TypeError("Thenable self-resolution");
                          f(
                            (l =
                              e &&
                              ("object" == typeof e ||
                                "function" == typeof e) &&
                              e.then)
                          )
                            ? r
                              ? l.call(e, a(o, i, M, r), a(o, i, H, r))
                              : (o++,
                                l.call(
                                  e,
                                  a(o, i, M, r),
                                  a(o, i, H, r),
                                  a(o, i, M, i.notifyWith)
                                ))
                            : (n !== M && ((s = void 0), (c = [e])),
                              (r || i.resolveWith)(s, c));
                        }
                      },
                      d = r
                        ? l
                        : function () {
                            try {
                              l();
                            } catch (e) {
                              w.Deferred.exceptionHook &&
                                w.Deferred.exceptionHook(e, d.stackTrace),
                                o <= t + 1 &&
                                  (n !== H && ((s = void 0), (c = [e])),
                                  i.rejectWith(s, c));
                            }
                          };
                    t
                      ? d()
                      : (w.Deferred.getStackHook &&
                          (d.stackTrace = w.Deferred.getStackHook()),
                        e.setTimeout(d));
                  };
                }
                return w
                  .Deferred(function (e) {
                    i[0][3].add(a(0, e, f(r) ? r : M, e.notifyWith)),
                      i[1][3].add(a(0, e, f(t) ? t : M)),
                      i[2][3].add(a(0, e, f(n) ? n : H));
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? w.extend(e, r) : r;
              },
            },
            o = {};
          return (
            w.each(i, function (e, t) {
              var a = t[2],
                s = t[5];
              (r[t[1]] = a.add),
                s &&
                  a.add(
                    function () {
                      n = s;
                    },
                    i[3 - e][2].disable,
                    i[3 - e][3].disable,
                    i[0][2].lock,
                    i[0][3].lock
                  ),
                a.add(t[3].fire),
                (o[t[0]] = function () {
                  return (
                    o[t[0] + "With"](this === o ? void 0 : this, arguments),
                    this
                  );
                }),
                (o[t[0] + "With"] = a.fireWith);
            }),
            r.promise(o),
            t && t.call(o, o),
            o
          );
        },
        when: function (e) {
          var t = arguments.length,
            i = t,
            n = Array(i),
            o = r.call(arguments),
            a = w.Deferred(),
            s = function (e) {
              return function (i) {
                (n[e] = this),
                  (o[e] = 1 < arguments.length ? r.call(arguments) : i),
                  --t || a.resolveWith(n, o);
              };
            };
          if (
            t <= 1 &&
            (O(e, a.done(s(i)).resolve, a.reject, !t),
            "pending" === a.state() || f(o[i] && o[i].then))
          )
            return a.then();
          for (; i--; ) O(o[i], s(i), a.reject);
          return a.promise();
        },
      });
    var V = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (w.Deferred.exceptionHook = function (t, i) {
      e.console &&
        e.console.warn &&
        t &&
        V.test(t.name) &&
        e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, i);
    }),
      (w.readyException = function (t) {
        e.setTimeout(function () {
          throw t;
        });
      });
    var B = w.Deferred();
    function R() {
      g.removeEventListener("DOMContentLoaded", R),
        e.removeEventListener("load", R),
        w.ready();
    }
    (w.fn.ready = function (e) {
      return (
        B.then(e).catch(function (e) {
          w.readyException(e);
        }),
        this
      );
    }),
      w.extend({
        isReady: !1,
        readyWait: 1,
        ready: function (e) {
          (!0 === e ? --w.readyWait : w.isReady) ||
            ((w.isReady = !0) !== e && 0 < --w.readyWait) ||
            B.resolveWith(g, [w]);
        },
      }),
      (w.ready.then = B.then),
      "complete" !== g.readyState &&
      ("loading" === g.readyState || g.documentElement.doScroll)
        ? (g.addEventListener("DOMContentLoaded", R),
          e.addEventListener("load", R))
        : e.setTimeout(w.ready);
    var F = function (e, t, i, n, r, o, a) {
        var s = 0,
          c = e.length,
          l = null == i;
        if ("object" === b(i))
          for (s in ((r = !0), i)) F(e, t, s, i[s], !0, o, a);
        else if (
          void 0 !== n &&
          ((r = !0),
          f(n) || (a = !0),
          l &&
            (a
              ? (t.call(e, n), (t = null))
              : ((l = t),
                (t = function (e, t, i) {
                  return l.call(w(e), i);
                }))),
          t)
        )
          for (; s < c; s++) t(e[s], i, a ? n : n.call(e[s], s, t(e[s], i)));
        return r ? e : l ? t.call(e) : c ? t(e[0], i) : o;
      },
      U = /^-ms-/,
      W = /-([a-z])/g;
    function z(e, t) {
      return t.toUpperCase();
    }
    function Q(e) {
      return e.replace(U, "ms-").replace(W, z);
    }
    var G = function (e) {
      return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
    };
    function X() {
      this.expando = w.expando + X.uid++;
    }
    (X.uid = 1),
      (X.prototype = {
        cache: function (e) {
          var t = e[this.expando];
          return (
            t ||
              ((t = {}),
              G(e) &&
                (e.nodeType
                  ? (e[this.expando] = t)
                  : Object.defineProperty(e, this.expando, {
                      value: t,
                      configurable: !0,
                    }))),
            t
          );
        },
        set: function (e, t, i) {
          var n,
            r = this.cache(e);
          if ("string" == typeof t) r[Q(t)] = i;
          else for (n in t) r[Q(n)] = t[n];
          return r;
        },
        get: function (e, t) {
          return void 0 === t
            ? this.cache(e)
            : e[this.expando] && e[this.expando][Q(t)];
        },
        access: function (e, t, i) {
          return void 0 === t || (t && "string" == typeof t && void 0 === i)
            ? this.get(e, t)
            : (this.set(e, t, i), void 0 !== i ? i : t);
        },
        remove: function (e, t) {
          var i,
            n = e[this.expando];
          if (void 0 !== n) {
            if (void 0 !== t)
              for (
                i = (t = Array.isArray(t)
                  ? t.map(Q)
                  : ((t = Q(t)) in n)
                  ? [t]
                  : t.match(j) || []).length;
                i--;

              )
                delete n[t[i]];
            (void 0 === t || w.isEmptyObject(n)) &&
              (e.nodeType
                ? (e[this.expando] = void 0)
                : delete e[this.expando]);
          }
        },
        hasData: function (e) {
          var t = e[this.expando];
          return void 0 !== t && !w.isEmptyObject(t);
        },
      });
    var Y = new X(),
      K = new X(),
      J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      Z = /[A-Z]/g;
    function ee(e, t, i) {
      var n, r;
      if (void 0 === i && 1 === e.nodeType) {
        if (
          ((n = "data-" + t.replace(Z, "-$&").toLowerCase()),
          "string" == typeof (i = e.getAttribute(n)))
        ) {
          try {
            i =
              "true" === (r = i) ||
              ("false" !== r &&
                ("null" === r
                  ? null
                  : r === +r + ""
                  ? +r
                  : J.test(r)
                  ? JSON.parse(r)
                  : r));
          } catch (o) {}
          K.set(e, t, i);
        } else i = void 0;
      }
      return i;
    }
    w.extend({
      hasData: function (e) {
        return K.hasData(e) || Y.hasData(e);
      },
      data: function (e, t, i) {
        return K.access(e, t, i);
      },
      removeData: function (e, t) {
        K.remove(e, t);
      },
      _data: function (e, t, i) {
        return Y.access(e, t, i);
      },
      _removeData: function (e, t) {
        Y.remove(e, t);
      },
    }),
      w.fn.extend({
        data: function (e, t) {
          var i,
            n,
            r,
            o = this[0],
            a = o && o.attributes;
          if (void 0 === e) {
            if (
              this.length &&
              ((r = K.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))
            ) {
              for (i = a.length; i--; )
                a[i] &&
                  0 === (n = a[i].name).indexOf("data-") &&
                  ee(o, (n = Q(n.slice(5))), r[n]);
              Y.set(o, "hasDataAttrs", !0);
            }
            return r;
          }
          return "object" == typeof e
            ? this.each(function () {
                K.set(this, e);
              })
            : F(
                this,
                function (t) {
                  var i;
                  if (o && void 0 === t)
                    return void 0 !== (i = K.get(o, e))
                      ? i
                      : void 0 !== (i = ee(o, e))
                      ? i
                      : void 0;
                  this.each(function () {
                    K.set(this, e, t);
                  });
                },
                null,
                t,
                1 < arguments.length,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            K.remove(this, e);
          });
        },
      }),
      w.extend({
        queue: function (e, t, i) {
          var n;
          if (e)
            return (
              (t = (t || "fx") + "queue"),
              (n = Y.get(e, t)),
              i &&
                (!n || Array.isArray(i)
                  ? (n = Y.access(e, t, w.makeArray(i)))
                  : n.push(i)),
              n || []
            );
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var i = w.queue(e, t),
            n = i.length,
            r = i.shift(),
            o = w._queueHooks(e, t);
          "inprogress" === r && ((r = i.shift()), n--),
            r &&
              ("fx" === t && i.unshift("inprogress"),
              delete o.stop,
              r.call(
                e,
                function () {
                  w.dequeue(e, t);
                },
                o
              )),
            !n && o && o.empty.fire();
        },
        _queueHooks: function (e, t) {
          var i = t + "queueHooks";
          return (
            Y.get(e, i) ||
            Y.access(e, i, {
              empty: w.Callbacks("once memory").add(function () {
                Y.remove(e, [t + "queue", i]);
              }),
            })
          );
        },
      }),
      w.fn.extend({
        queue: function (e, t) {
          var i = 2;
          return (
            "string" != typeof e && ((t = e), (e = "fx"), i--),
            arguments.length < i
              ? w.queue(this[0], e)
              : void 0 === t
              ? this
              : this.each(function () {
                  var i = w.queue(this, e, t);
                  w._queueHooks(this, e),
                    "fx" === e && "inprogress" !== i[0] && w.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            w.dequeue(this, e);
          });
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, t) {
          var i,
            n = 1,
            r = w.Deferred(),
            o = this,
            a = this.length,
            s = function () {
              --n || r.resolveWith(o, [o]);
            };
          for (
            "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
            a--;

          )
            (i = Y.get(o[a], e + "queueHooks")) &&
              i.empty &&
              (n++, i.empty.add(s));
          return s(), r.promise(t);
        },
      });
    var et = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      ei = RegExp("^(?:([+-])=|)(" + et + ")([a-z%]*)$", "i"),
      en = ["Top", "Right", "Bottom", "Left"],
      er = g.documentElement,
      eo = function (e) {
        return w.contains(e.ownerDocument, e);
      },
      ea = { composed: !0 };
    er.getRootNode &&
      (eo = function (e) {
        return (
          w.contains(e.ownerDocument, e) ||
          e.getRootNode(ea) === e.ownerDocument
        );
      });
    var es = function (e, t) {
      return (
        "none" === (e = t || e).style.display ||
        ("" === e.style.display && eo(e) && "none" === w.css(e, "display"))
      );
    };
    function ec(e, t, i, n) {
      var r,
        o,
        a = 20,
        s = n
          ? function () {
              return n.cur();
            }
          : function () {
              return w.css(e, t, "");
            },
        c = s(),
        l = (i && i[3]) || (w.cssNumber[t] ? "" : "px"),
        d =
          e.nodeType &&
          (w.cssNumber[t] || ("px" !== l && +c)) &&
          ei.exec(w.css(e, t));
      if (d && d[3] !== l) {
        for (c /= 2, l = l || d[3], d = +c || 1; a--; )
          w.style(e, t, d + l),
            (1 - o) * (1 - (o = s() / c || 0.5)) <= 0 && (a = 0),
            (d /= o);
        (d *= 2), w.style(e, t, d + l), (i = i || []);
      }
      return (
        i &&
          ((d = +d || +c || 0),
          (r = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
          n && ((n.unit = l), (n.start = d), (n.end = r))),
        r
      );
    }
    var el = {};
    function ed(e, t) {
      for (var i, n, r, o, a, s, c, l = [], d = 0, u = e.length; d < u; d++)
        (n = e[d]).style &&
          ((i = n.style.display),
          t
            ? ("none" === i &&
                ((l[d] = Y.get(n, "display") || null),
                l[d] || (n.style.display = "")),
              "" === n.style.display &&
                es(n) &&
                (l[d] =
                  ((c = a = o = void 0),
                  (a = (r = n).ownerDocument),
                  (c = el[(s = r.nodeName)]) ||
                    ((o = a.body.appendChild(a.createElement(s))),
                    (c = w.css(o, "display")),
                    o.parentNode.removeChild(o),
                    "none" === c && (c = "block"),
                    (el[s] = c)))))
            : "none" !== i && ((l[d] = "none"), Y.set(n, "display", i)));
      for (d = 0; d < u; d++) null != l[d] && (e[d].style.display = l[d]);
      return e;
    }
    w.fn.extend({
      show: function () {
        return ed(this, !0);
      },
      hide: function () {
        return ed(this);
      },
      toggle: function (e) {
        return "boolean" == typeof e
          ? e
            ? this.show()
            : this.hide()
          : this.each(function () {
              es(this) ? w(this).show() : w(this).hide();
            });
      },
    });
    var eu,
      eh,
      ep = /^(?:checkbox|radio)$/i,
      ef = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
      em = /^$|^module$|\/(?:java|ecma)script/i;
    (eu = g.createDocumentFragment().appendChild(g.createElement("div"))),
      (eh = g.createElement("input")).setAttribute("type", "radio"),
      eh.setAttribute("checked", "checked"),
      eh.setAttribute("name", "t"),
      eu.appendChild(eh),
      (p.checkClone = eu.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (eu.innerHTML = "<textarea>x</textarea>"),
      (p.noCloneChecked = !!eu.cloneNode(!0).lastChild.defaultValue),
      (eu.innerHTML = "<option></option>"),
      (p.option = !!eu.lastChild);
    var eg = {
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
    function ev(e, t) {
      var i;
      return (
        (i =
          void 0 !== e.getElementsByTagName
            ? e.getElementsByTagName(t || "*")
            : void 0 !== e.querySelectorAll
            ? e.querySelectorAll(t || "*")
            : []),
        void 0 === t || (t && E(e, t)) ? w.merge([e], i) : i
      );
    }
    function ey(e, t) {
      for (var i = 0, n = e.length; i < n; i++)
        Y.set(e[i], "globalEval", !t || Y.get(t[i], "globalEval"));
    }
    (eg.tbody = eg.tfoot = eg.colgroup = eg.caption = eg.thead),
      (eg.th = eg.td),
      p.option ||
        (eg.optgroup = eg.option =
          [1, "<select multiple='multiple'>", "</select>"]);
    var eb = /<|&#?\w+;/;
    function e$(e, t, i, n, r) {
      for (
        var o,
          a,
          s,
          c,
          l,
          d,
          u = t.createDocumentFragment(),
          h = [],
          p = 0,
          f = e.length;
        p < f;
        p++
      )
        if ((o = e[p]) || 0 === o) {
          if ("object" === b(o)) w.merge(h, o.nodeType ? [o] : o);
          else if (eb.test(o)) {
            for (
              a = a || u.appendChild(t.createElement("div")),
                c =
                  eg[(s = (ef.exec(o) || ["", ""])[1].toLowerCase())] ||
                  eg._default,
                a.innerHTML = c[1] + w.htmlPrefilter(o) + c[2],
                d = c[0];
              d--;

            )
              a = a.lastChild;
            w.merge(h, a.childNodes), ((a = u.firstChild).textContent = "");
          } else h.push(t.createTextNode(o));
        }
      for (u.textContent = "", p = 0; (o = h[p++]); )
        if (n && -1 < w.inArray(o, n)) r && r.push(o);
        else if (
          ((l = eo(o)), (a = ev(u.appendChild(o), "script")), l && ey(a), i)
        )
          for (d = 0; (o = a[d++]); ) em.test(o.type || "") && i.push(o);
      return u;
    }
    var eS = /^key/,
      ew = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      ex = /^([^.]*)(?:\.(.+)|)/;
    function e_() {
      return !0;
    }
    function ek() {
      return !1;
    }
    function eL(e, t) {
      return (
        (e ===
          (function () {
            try {
              return g.activeElement;
            } catch (e) {}
          })()) ==
        ("focus" === t)
      );
    }
    function e8(e, t, i, n, r, o) {
      var a, s;
      if ("object" == typeof t) {
        for (s in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
          e8(e, s, i, n, t[s], o);
        return e;
      }
      if (
        (null == n && null == r
          ? ((r = i), (n = i = void 0))
          : null == r &&
            ("string" == typeof i
              ? ((r = n), (n = void 0))
              : ((r = n), (n = i), (i = void 0))),
        !1 === r)
      )
        r = ek;
      else if (!r) return e;
      return (
        1 === o &&
          ((a = r),
          ((r = function (e) {
            return w().off(e), a.apply(this, arguments);
          }).guid = a.guid || (a.guid = w.guid++))),
        e.each(function () {
          w.event.add(this, t, r, n, i);
        })
      );
    }
    function eC(e, t, i) {
      i
        ? (Y.set(e, t, !1),
          w.event.add(e, t, {
            namespace: !1,
            handler: function (e) {
              var n,
                o,
                a = Y.get(this, t);
              if (1 & e.isTrigger && this[t]) {
                if (a.length)
                  (w.event.special[t] || {}).delegateType &&
                    e.stopPropagation();
                else if (
                  ((a = r.call(arguments)),
                  Y.set(this, t, a),
                  (n = i(this, t)),
                  this[t](),
                  a !== (o = Y.get(this, t)) || n
                    ? Y.set(this, t, !1)
                    : (o = {}),
                  a !== o)
                )
                  return (
                    e.stopImmediatePropagation(), e.preventDefault(), o.value
                  );
              } else
                a.length &&
                  (Y.set(this, t, {
                    value: w.event.trigger(
                      w.extend(a[0], w.Event.prototype),
                      a.slice(1),
                      this
                    ),
                  }),
                  e.stopImmediatePropagation());
            },
          }))
        : void 0 === Y.get(e, t) && w.event.add(e, t, e_);
    }
    (w.event = {
      global: {},
      add: function (e, t, i, n, r) {
        var o,
          a,
          s,
          c,
          l,
          d,
          u,
          h,
          p,
          f,
          m,
          g = Y.get(e);
        if (G(e))
          for (
            i.handler && ((i = (o = i).handler), (r = o.selector)),
              r && w.find.matchesSelector(er, r),
              i.guid || (i.guid = w.guid++),
              (c = g.events) || (c = g.events = Object.create(null)),
              (a = g.handle) ||
                (a = g.handle =
                  function (t) {
                    return w.event.triggered !== t.type
                      ? w.event.dispatch.apply(e, arguments)
                      : void 0;
                  }),
              l = (t = (t || "").match(j) || [""]).length;
            l--;

          )
            (p = m = (s = ex.exec(t[l]) || [])[1]),
              (f = (s[2] || "").split(".").sort()),
              p &&
                ((u = w.event.special[p] || {}),
                (p = (r ? u.delegateType : u.bindType) || p),
                (u = w.event.special[p] || {}),
                (d = w.extend(
                  {
                    type: p,
                    origType: m,
                    data: n,
                    handler: i,
                    guid: i.guid,
                    selector: r,
                    needsContext: r && w.expr.match.needsContext.test(r),
                    namespace: f.join("."),
                  },
                  o
                )),
                (h = c[p]) ||
                  (((h = c[p] = []).delegateCount = 0),
                  (u.setup && !1 !== u.setup.call(e, n, f, a)) ||
                    (e.addEventListener && e.addEventListener(p, a))),
                u.add &&
                  (u.add.call(e, d),
                  d.handler.guid || (d.handler.guid = i.guid)),
                r ? h.splice(h.delegateCount++, 0, d) : h.push(d),
                (w.event.global[p] = !0));
      },
      remove: function (e, t, i, n, r) {
        var o,
          a,
          s,
          c,
          l,
          d,
          u,
          h,
          p,
          f,
          m,
          g = Y.hasData(e) && Y.get(e);
        if (g && (c = g.events)) {
          for (l = (t = (t || "").match(j) || [""]).length; l--; )
            if (
              ((p = m = (s = ex.exec(t[l]) || [])[1]),
              (f = (s[2] || "").split(".").sort()),
              p)
            ) {
              for (
                u = w.event.special[p] || {},
                  h = c[(p = (n ? u.delegateType : u.bindType) || p)] || [],
                  s =
                    s[2] &&
                    RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  a = o = h.length;
                o--;

              )
                (d = h[o]),
                  (!r && m !== d.origType) ||
                    (i && i.guid !== d.guid) ||
                    (s && !s.test(d.namespace)) ||
                    (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                    (h.splice(o, 1),
                    d.selector && h.delegateCount--,
                    u.remove && u.remove.call(e, d));
              a &&
                !h.length &&
                ((u.teardown && !1 !== u.teardown.call(e, f, g.handle)) ||
                  w.removeEvent(e, p, g.handle),
                delete c[p]);
            } else for (p in c) w.event.remove(e, p + t[l], i, n, !0);
          w.isEmptyObject(c) && Y.remove(e, "handle events");
        }
      },
      dispatch: function (e) {
        var t,
          i,
          n,
          r,
          o,
          a,
          s = Array(arguments.length),
          c = w.event.fix(e),
          l = (Y.get(this, "events") || Object.create(null))[c.type] || [],
          d = w.event.special[c.type] || {};
        for (s[0] = c, t = 1; t < arguments.length; t++) s[t] = arguments[t];
        if (
          ((c.delegateTarget = this),
          !d.preDispatch || !1 !== d.preDispatch.call(this, c))
        ) {
          for (
            a = w.event.handlers.call(this, c, l), t = 0;
            (r = a[t++]) && !c.isPropagationStopped();

          )
            for (
              c.currentTarget = r.elem, i = 0;
              (o = r.handlers[i++]) && !c.isImmediatePropagationStopped();

            )
              (c.rnamespace &&
                !1 !== o.namespace &&
                !c.rnamespace.test(o.namespace)) ||
                ((c.handleObj = o),
                (c.data = o.data),
                void 0 !==
                  (n = (
                    (w.event.special[o.origType] || {}).handle || o.handler
                  ).apply(r.elem, s)) &&
                  !1 === (c.result = n) &&
                  (c.preventDefault(), c.stopPropagation()));
          return d.postDispatch && d.postDispatch.call(this, c), c.result;
        }
      },
      handlers: function (e, t) {
        var i,
          n,
          r,
          o,
          a,
          s = [],
          c = t.delegateCount,
          l = e.target;
        if (c && l.nodeType && !("click" === e.type && 1 <= e.button)) {
          for (; l !== this; l = l.parentNode || this)
            if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
              for (o = [], a = {}, i = 0; i < c; i++)
                void 0 === a[(r = (n = t[i]).selector + " ")] &&
                  (a[r] = n.needsContext
                    ? -1 < w(r, this).index(l)
                    : w.find(r, this, null, [l]).length),
                  a[r] && o.push(n);
              o.length && s.push({ elem: l, handlers: o });
            }
        }
        return (
          (l = this),
          c < t.length && s.push({ elem: l, handlers: t.slice(c) }),
          s
        );
      },
      addProp: function (e, t) {
        Object.defineProperty(w.Event.prototype, e, {
          enumerable: !0,
          configurable: !0,
          get: f(t)
            ? function () {
                if (this.originalEvent) return t(this.originalEvent);
              }
            : function () {
                if (this.originalEvent) return this.originalEvent[e];
              },
          set: function (t) {
            Object.defineProperty(this, e, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: t,
            });
          },
        });
      },
      fix: function (e) {
        return e[w.expando] ? e : new w.Event(e);
      },
      special: {
        load: { noBubble: !0 },
        click: {
          setup: function (e) {
            var t = this || e;
            return (
              ep.test(t.type) && t.click && E(t, "input") && eC(t, "click", e_),
              !1
            );
          },
          trigger: function (e) {
            var t = this || e;
            return (
              ep.test(t.type) && t.click && E(t, "input") && eC(t, "click"), !0
            );
          },
          _default: function (e) {
            var t = e.target;
            return (
              (ep.test(t.type) &&
                t.click &&
                E(t, "input") &&
                Y.get(t, "click")) ||
              E(t, "a")
            );
          },
        },
        beforeunload: {
          postDispatch: function (e) {
            void 0 !== e.result &&
              e.originalEvent &&
              (e.originalEvent.returnValue = e.result);
          },
        },
      },
    }),
      (w.removeEvent = function (e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i);
      }),
      (w.Event = function (e, t) {
        if (!(this instanceof w.Event)) return new w.Event(e, t);
        e && e.type
          ? ((this.originalEvent = e),
            (this.type = e.type),
            (this.isDefaultPrevented =
              e.defaultPrevented ||
              (void 0 === e.defaultPrevented && !1 === e.returnValue)
                ? e_
                : ek),
            (this.target =
              e.target && 3 === e.target.nodeType
                ? e.target.parentNode
                : e.target),
            (this.currentTarget = e.currentTarget),
            (this.relatedTarget = e.relatedTarget))
          : (this.type = e),
          t && w.extend(this, t),
          (this.timeStamp = (e && e.timeStamp) || Date.now()),
          (this[w.expando] = !0);
      }),
      (w.Event.prototype = {
        constructor: w.Event,
        isDefaultPrevented: ek,
        isPropagationStopped: ek,
        isImmediatePropagationStopped: ek,
        isSimulated: !1,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = e_),
            e && !this.isSimulated && e.preventDefault();
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = e_),
            e && !this.isSimulated && e.stopPropagation();
        },
        stopImmediatePropagation: function () {
          var e = this.originalEvent;
          (this.isImmediatePropagationStopped = e_),
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      w.each(
        {
          altKey: !0,
          bubbles: !0,
          cancelable: !0,
          changedTouches: !0,
          ctrlKey: !0,
          detail: !0,
          eventPhase: !0,
          metaKey: !0,
          pageX: !0,
          pageY: !0,
          shiftKey: !0,
          view: !0,
          char: !0,
          code: !0,
          charCode: !0,
          key: !0,
          keyCode: !0,
          button: !0,
          buttons: !0,
          clientX: !0,
          clientY: !0,
          offsetX: !0,
          offsetY: !0,
          pointerId: !0,
          pointerType: !0,
          screenX: !0,
          screenY: !0,
          targetTouches: !0,
          toElement: !0,
          touches: !0,
          which: function (e) {
            var t = e.button;
            return null == e.which && eS.test(e.type)
              ? null != e.charCode
                ? e.charCode
                : e.keyCode
              : !e.which && void 0 !== t && ew.test(e.type)
              ? 1 & t
                ? 1
                : 2 & t
                ? 3
                : 4 & t
                ? 2
                : 0
              : e.which;
          },
        },
        w.event.addProp
      ),
      w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
        w.event.special[e] = {
          setup: function () {
            return eC(this, e, eL), !1;
          },
          trigger: function () {
            return eC(this, e), !0;
          },
          delegateType: t,
        };
      }),
      w.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (e, t) {
          w.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var i,
                n = e.relatedTarget,
                r = e.handleObj;
              return (
                (n && (n === this || w.contains(this, n))) ||
                  ((e.type = r.origType),
                  (i = r.handler.apply(this, arguments)),
                  (e.type = t)),
                i
              );
            },
          };
        }
      ),
      w.fn.extend({
        on: function (e, t, i, n) {
          return e8(this, e, t, i, n);
        },
        one: function (e, t, i, n) {
          return e8(this, e, t, i, n, 1);
        },
        off: function (e, t, i) {
          var n, r;
          if (e && e.preventDefault && e.handleObj)
            return (
              (n = e.handleObj),
              w(e.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (r in e) this.off(r, t, e[r]);
            return this;
          }
          return (
            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
            !1 === i && (i = ek),
            this.each(function () {
              w.event.remove(this, e, i, t);
            })
          );
        },
      });
    var eE = /<script|<style|<link/i,
      eT = /checked\s*(?:[^=]|=\s*.checked.)/i,
      eq = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function eI(e, t) {
      return (
        (E(e, "table") &&
          E(11 !== t.nodeType ? t : t.firstChild, "tr") &&
          w(e).children("tbody")[0]) ||
        e
      );
    }
    function eA(e) {
      return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function eP(e) {
      return (
        "true/" === (e.type || "").slice(0, 5)
          ? (e.type = e.type.slice(5))
          : e.removeAttribute("type"),
        e
      );
    }
    function eD(e, t) {
      var i, n, r, o, a, s;
      if (1 === t.nodeType) {
        if (Y.hasData(e) && (s = Y.get(e).events))
          for (r in (Y.remove(t, "handle events"), s))
            for (i = 0, n = s[r].length; i < n; i++) w.event.add(t, r, s[r][i]);
        K.hasData(e) && ((o = K.access(e)), (a = w.extend({}, o)), K.set(t, a));
      }
    }
    function eN(e, t, i, n) {
      t = o(t);
      var r,
        a,
        s,
        c,
        l,
        d,
        u = 0,
        h = e.length,
        m = h - 1,
        g = t[0],
        v = f(g);
      if (v || (1 < h && "string" == typeof g && !p.checkClone && eT.test(g)))
        return e.each(function (r) {
          var o = e.eq(r);
          v && (t[0] = g.call(this, r, o.html())), eN(o, t, i, n);
        });
      if (
        h &&
        ((a = (r = e$(t, e[0].ownerDocument, !1, e, n)).firstChild),
        1 === r.childNodes.length && (r = a),
        a || n)
      ) {
        for (c = (s = w.map(ev(r, "script"), eA)).length; u < h; u++)
          (l = r),
            u !== m &&
              ((l = w.clone(l, !0, !0)), c && w.merge(s, ev(l, "script"))),
            i.call(e[u], l, u);
        if (c)
          for (
            d = s[s.length - 1].ownerDocument, w.map(s, eP), u = 0;
            u < c;
            u++
          )
            (l = s[u]),
              em.test(l.type || "") &&
                !Y.access(l, "globalEval") &&
                w.contains(d, l) &&
                (l.src && "module" !== (l.type || "").toLowerCase()
                  ? w._evalUrl &&
                    !l.noModule &&
                    w._evalUrl(
                      l.src,
                      { nonce: l.nonce || l.getAttribute("nonce") },
                      d
                    )
                  : y(l.textContent.replace(eq, ""), l, d));
      }
      return e;
    }
    function ej(e, t, i) {
      for (var n, r = t ? w.filter(t, e) : e, o = 0; null != (n = r[o]); o++)
        i || 1 !== n.nodeType || w.cleanData(ev(n)),
          n.parentNode &&
            (i && eo(n) && ey(ev(n, "script")), n.parentNode.removeChild(n));
      return e;
    }
    w.extend({
      htmlPrefilter: function (e) {
        return e;
      },
      clone: function (e, t, i) {
        var n,
          r,
          o,
          a,
          s,
          c,
          l,
          d = e.cloneNode(!0),
          u = eo(e);
        if (
          !(
            p.noCloneChecked ||
            (1 !== e.nodeType && 11 !== e.nodeType) ||
            w.isXMLDoc(e)
          )
        )
          for (a = ev(d), n = 0, r = (o = ev(e)).length; n < r; n++)
            (s = o[n]),
              "input" === (l = (c = a[n]).nodeName.toLowerCase()) &&
              ep.test(s.type)
                ? (c.checked = s.checked)
                : ("input" !== l && "textarea" !== l) ||
                  (c.defaultValue = s.defaultValue);
        if (t) {
          if (i)
            for (
              o = o || ev(e), a = a || ev(d), n = 0, r = o.length;
              n < r;
              n++
            )
              eD(o[n], a[n]);
          else eD(e, d);
        }
        return (
          0 < (a = ev(d, "script")).length && ey(a, !u && ev(e, "script")), d
        );
      },
      cleanData: function (e) {
        for (
          var t, i, n, r = w.event.special, o = 0;
          void 0 !== (i = e[o]);
          o++
        )
          if (G(i)) {
            if ((t = i[Y.expando])) {
              if (t.events)
                for (n in t.events)
                  r[n] ? w.event.remove(i, n) : w.removeEvent(i, n, t.handle);
              i[Y.expando] = void 0;
            }
            i[K.expando] && (i[K.expando] = void 0);
          }
      },
    }),
      w.fn.extend({
        detach: function (e) {
          return ej(this, e, !0);
        },
        remove: function (e) {
          return ej(this, e);
        },
        text: function (e) {
          return F(
            this,
            function (e) {
              return void 0 === e
                ? w.text(this)
                : this.empty().each(function () {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      (this.textContent = e);
                  });
            },
            null,
            e,
            arguments.length
          );
        },
        append: function () {
          return eN(this, arguments, function (e) {
            (1 !== this.nodeType &&
              11 !== this.nodeType &&
              9 !== this.nodeType) ||
              eI(this, e).appendChild(e);
          });
        },
        prepend: function () {
          return eN(this, arguments, function (e) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var t = eI(this, e);
              t.insertBefore(e, t.firstChild);
            }
          });
        },
        before: function () {
          return eN(this, arguments, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return eN(this, arguments, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++)
            1 === e.nodeType && (w.cleanData(ev(e, !1)), (e.textContent = ""));
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return w.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return F(
            this,
            function (e) {
              var t = this[0] || {},
                i = 0,
                n = this.length;
              if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
              if (
                "string" == typeof e &&
                !eE.test(e) &&
                !eg[(ef.exec(e) || ["", ""])[1].toLowerCase()]
              ) {
                e = w.htmlPrefilter(e);
                try {
                  for (; i < n; i++)
                    1 === (t = this[i] || {}).nodeType &&
                      (w.cleanData(ev(t, !1)), (t.innerHTML = e));
                  t = 0;
                } catch (r) {}
              }
              t && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function () {
          var e = [];
          return eN(
            this,
            arguments,
            function (t) {
              var i = this.parentNode;
              0 > w.inArray(this, e) &&
                (w.cleanData(ev(this)), i && i.replaceChild(t, this));
            },
            e
          );
        },
      }),
      w.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          w.fn[e] = function (e) {
            for (var i, n = [], r = w(e), o = r.length - 1, s = 0; s <= o; s++)
              (i = s === o ? this : this.clone(!0)),
                w(r[s])[t](i),
                a.apply(n, i.get());
            return this.pushStack(n);
          };
        }
      );
    var eM = RegExp("^(" + et + ")(?!px)[a-z%]+$", "i"),
      eH = function (t) {
        var i = t.ownerDocument.defaultView;
        return (i && i.opener) || (i = e), i.getComputedStyle(t);
      },
      eO = function (e, t, i) {
        var n,
          r,
          o = {};
        for (r in t) (o[r] = e.style[r]), (e.style[r] = t[r]);
        for (r in ((n = i.call(e)), t)) e.style[r] = o[r];
        return n;
      },
      eV = RegExp(en.join("|"), "i");
    function eB(e, t, i) {
      var n,
        r,
        o,
        a,
        s = e.style;
      return (
        (i = i || eH(e)) &&
          ("" !== (a = i.getPropertyValue(t) || i[t]) ||
            eo(e) ||
            (a = w.style(e, t)),
          !p.pixelBoxStyles() &&
            eM.test(a) &&
            eV.test(t) &&
            ((n = s.width),
            (r = s.minWidth),
            (o = s.maxWidth),
            (s.minWidth = s.maxWidth = s.width = a),
            (a = i.width),
            (s.width = n),
            (s.minWidth = r),
            (s.maxWidth = o))),
        void 0 !== a ? a + "" : a
      );
    }
    function eR(e, t) {
      return {
        get: function () {
          if (!e()) return (this.get = t).apply(this, arguments);
          delete this.get;
        },
      };
    }
    !(function () {
      function t() {
        if (d) {
          (l.style.cssText =
            "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
            (d.style.cssText =
              "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
            er.appendChild(l).appendChild(d);
          var t = e.getComputedStyle(d);
          (n = "1%" !== t.top),
            (c = 12 === i(t.marginLeft)),
            (d.style.right = "60%"),
            (a = 36 === i(t.right)),
            (r = 36 === i(t.width)),
            (d.style.position = "absolute"),
            (o = 12 === i(d.offsetWidth / 3)),
            er.removeChild(l),
            (d = null);
        }
      }
      function i(e) {
        return Math.round(parseFloat(e));
      }
      var n,
        r,
        o,
        a,
        s,
        c,
        l = g.createElement("div"),
        d = g.createElement("div");
      d.style &&
        ((d.style.backgroundClip = "content-box"),
        (d.cloneNode(!0).style.backgroundClip = ""),
        (p.clearCloneStyle = "content-box" === d.style.backgroundClip),
        w.extend(p, {
          boxSizingReliable: function () {
            return t(), r;
          },
          pixelBoxStyles: function () {
            return t(), a;
          },
          pixelPosition: function () {
            return t(), n;
          },
          reliableMarginLeft: function () {
            return t(), c;
          },
          scrollboxSize: function () {
            return t(), o;
          },
          reliableTrDimensions: function () {
            var t, i, n, r;
            return (
              null == s &&
                ((t = g.createElement("table")),
                (i = g.createElement("tr")),
                (n = g.createElement("div")),
                (t.style.cssText = "position:absolute;left:-11111px"),
                (i.style.height = "1px"),
                (n.style.height = "9px"),
                er.appendChild(t).appendChild(i).appendChild(n),
                (s = 3 < parseInt((r = e.getComputedStyle(i)).height)),
                er.removeChild(t)),
              s
            );
          },
        }));
    })();
    var eF = ["Webkit", "Moz", "ms"],
      e0 = g.createElement("div").style,
      e9 = {};
    function eU(e) {
      return (
        w.cssProps[e] ||
        e9[e] ||
        (e in e0
          ? e
          : (e9[e] =
              (function (e) {
                for (
                  var t = e[0].toUpperCase() + e.slice(1), i = eF.length;
                  i--;

                )
                  if ((e = eF[i] + t) in e0) return e;
              })(e) || e))
      );
    }
    var eW = /^(none|table(?!-c[ea]).+)/,
      ez = /^--/,
      e1 = { position: "absolute", visibility: "hidden", display: "block" },
      e2 = { letterSpacing: "0", fontWeight: "400" };
    function e3(e, t, i) {
      var n = ei.exec(t);
      return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
    }
    function eQ(e, t, i, n, r, o) {
      var a = "width" === t ? 1 : 0,
        s = 0,
        c = 0;
      if (i === (n ? "border" : "content")) return 0;
      for (; a < 4; a += 2)
        "margin" === i && (c += w.css(e, i + en[a], !0, r)),
          n
            ? ("content" === i && (c -= w.css(e, "padding" + en[a], !0, r)),
              "margin" !== i &&
                (c -= w.css(e, "border" + en[a] + "Width", !0, r)))
            : ((c += w.css(e, "padding" + en[a], !0, r)),
              "padding" !== i
                ? (c += w.css(e, "border" + en[a] + "Width", !0, r))
                : (s += w.css(e, "border" + en[a] + "Width", !0, r)));
      return (
        !n &&
          0 <= o &&
          (c +=
            Math.max(
              0,
              Math.ceil(
                e["offset" + t[0].toUpperCase() + t.slice(1)] - o - c - s - 0.5
              )
            ) || 0),
        c
      );
    }
    function e4(e, t, i) {
      var n = eH(e),
        r =
          (!p.boxSizingReliable() || i) &&
          "border-box" === w.css(e, "boxSizing", !1, n),
        o = r,
        a = eB(e, t, n),
        s = "offset" + t[0].toUpperCase() + t.slice(1);
      if (eM.test(a)) {
        if (!i) return a;
        a = "auto";
      }
      return (
        ((!p.boxSizingReliable() && r) ||
          (!p.reliableTrDimensions() && E(e, "tr")) ||
          "auto" === a ||
          (!parseFloat(a) && "inline" === w.css(e, "display", !1, n))) &&
          e.getClientRects().length &&
          ((r = "border-box" === w.css(e, "boxSizing", !1, n)),
          (o = s in e) && (a = e[s])),
        (a = parseFloat(a) || 0) +
          eQ(e, t, i || (r ? "border" : "content"), o, n, a) +
          "px"
      );
    }
    function eG(e, t, i, n, r) {
      return new eG.prototype.init(e, t, i, n, r);
    }
    w.extend({
      cssHooks: {
        opacity: {
          get: function (e, t) {
            if (t) {
              var i = eB(e, "opacity");
              return "" === i ? "1" : i;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: {},
      style: function (e, t, i, n) {
        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
          var r,
            o,
            a,
            s = Q(t),
            c = ez.test(t),
            l = e.style;
          if (
            (c || (t = eU(s)),
            (a = w.cssHooks[t] || w.cssHooks[s]),
            void 0 === i)
          )
            return a && "get" in a && void 0 !== (r = a.get(e, !1, n))
              ? r
              : l[t];
          "string" == (o = typeof i) &&
            (r = ei.exec(i)) &&
            r[1] &&
            ((i = ec(e, t, r)), (o = "number")),
            null != i &&
              i == i &&
              ("number" !== o ||
                c ||
                (i += (r && r[3]) || (w.cssNumber[s] ? "" : "px")),
              p.clearCloneStyle ||
                "" !== i ||
                0 !== t.indexOf("background") ||
                (l[t] = "inherit"),
              (a && "set" in a && void 0 === (i = a.set(e, i, n))) ||
                (c ? l.setProperty(t, i) : (l[t] = i)));
        }
      },
      css: function (e, t, i, n) {
        var r,
          o,
          a,
          s = Q(t);
        return (
          ez.test(t) || (t = eU(s)),
          (a = w.cssHooks[t] || w.cssHooks[s]) &&
            "get" in a &&
            (r = a.get(e, !0, i)),
          void 0 === r && (r = eB(e, t, n)),
          "normal" === r && t in e2 && (r = e2[t]),
          "" === i || i
            ? ((o = parseFloat(r)), !0 === i || isFinite(o) ? o || 0 : r)
            : r
        );
      },
    }),
      w.each(["height", "width"], function (e, t) {
        w.cssHooks[t] = {
          get: function (e, i, n) {
            if (i)
              return !eW.test(w.css(e, "display")) ||
                (e.getClientRects().length && e.getBoundingClientRect().width)
                ? e4(e, t, n)
                : eO(e, e1, function () {
                    return e4(e, t, n);
                  });
          },
          set: function (e, i, n) {
            var r,
              o = eH(e),
              a = !p.scrollboxSize() && "absolute" === o.position,
              s = (a || n) && "border-box" === w.css(e, "boxSizing", !1, o),
              c = n ? eQ(e, t, n, s, o) : 0;
            return (
              s &&
                a &&
                (c -= Math.ceil(
                  e["offset" + t[0].toUpperCase() + t.slice(1)] -
                    parseFloat(o[t]) -
                    eQ(e, t, "border", !1, o) -
                    0.5
                )),
              c &&
                (r = ei.exec(i)) &&
                "px" !== (r[3] || "px") &&
                ((e.style[t] = i), (i = w.css(e, t))),
              e3(0, i, c)
            );
          },
        };
      }),
      (w.cssHooks.marginLeft = eR(p.reliableMarginLeft, function (e, t) {
        if (t)
          return (
            (parseFloat(eB(e, "marginLeft")) ||
              e.getBoundingClientRect().left -
                eO(e, { marginLeft: 0 }, function () {
                  return e.getBoundingClientRect().left;
                })) + "px"
          );
      })),
      w.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
        (w.cssHooks[e + t] = {
          expand: function (i) {
            for (
              var n = 0, r = {}, o = "string" == typeof i ? i.split(" ") : [i];
              n < 4;
              n++
            )
              r[e + en[n] + t] = o[n] || o[n - 2] || o[0];
            return r;
          },
        }),
          "margin" !== e && (w.cssHooks[e + t].set = e3);
      }),
      w.fn.extend({
        css: function (e, t) {
          return F(
            this,
            function (e, t, i) {
              var n,
                r,
                o = {},
                a = 0;
              if (Array.isArray(t)) {
                for (n = eH(e), r = t.length; a < r; a++)
                  o[t[a]] = w.css(e, t[a], !1, n);
                return o;
              }
              return void 0 !== i ? w.style(e, t, i) : w.css(e, t);
            },
            e,
            t,
            1 < arguments.length
          );
        },
      }),
      (((w.Tween = eG).prototype = {
        constructor: eG,
        init: function (e, t, i, n, r, o) {
          (this.elem = e),
            (this.prop = i),
            (this.easing = r || w.easing._default),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = o || (w.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var e = eG.propHooks[this.prop];
          return e && e.get ? e.get(this) : eG.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            i = eG.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = t =
                  w.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = t = e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : eG.propHooks._default.set(this),
            this
          );
        },
      }).init.prototype = eG.prototype),
      ((eG.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return 1 !== e.elem.nodeType ||
              (null != e.elem[e.prop] && null == e.elem.style[e.prop])
              ? e.elem[e.prop]
              : (t = w.css(e.elem, e.prop, "")) && "auto" !== t
              ? t
              : 0;
          },
          set: function (e) {
            w.fx.step[e.prop]
              ? w.fx.step[e.prop](e)
              : 1 === e.elem.nodeType &&
                (w.cssHooks[e.prop] || null != e.elem.style[eU(e.prop)])
              ? w.style(e.elem, e.prop, e.now + e.unit)
              : (e.elem[e.prop] = e.now);
          },
        },
      }).scrollTop = eG.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      (w.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (w.fx = eG.prototype.init),
      (w.fx.step = {});
    var eX,
      eY,
      e7,
      e5,
      eK = /^(?:toggle|show|hide)$/,
      e6 = /queueHooks$/;
    function eJ() {
      return (
        e.setTimeout(function () {
          eX = void 0;
        }),
        (eX = Date.now())
      );
    }
    function eZ(e, t) {
      var i,
        n = 0,
        r = { height: e };
      for (t = t ? 1 : 0; n < 4; n += 2 - t)
        r["margin" + (i = en[n])] = r["padding" + i] = e;
      return t && (r.opacity = r.width = e), r;
    }
    function te(e, t, i) {
      for (
        var n,
          r = (tt.tweeners[t] || []).concat(tt.tweeners["*"]),
          o = 0,
          a = r.length;
        o < a;
        o++
      )
        if ((n = r[o].call(i, t, e))) return n;
    }
    function tt(e, t, i) {
      var n,
        r,
        o = 0,
        a = tt.prefilters.length,
        s = w.Deferred().always(function () {
          delete c.elem;
        }),
        c = function () {
          if (r) return !1;
          for (
            var t = eX || eJ(),
              i = Math.max(0, l.startTime + l.duration - t),
              n = 1 - (i / l.duration || 0),
              o = 0,
              a = l.tweens.length;
            o < a;
            o++
          )
            l.tweens[o].run(n);
          return (
            s.notifyWith(e, [l, n, i]),
            n < 1 && a
              ? i
              : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1)
          );
        },
        l = s.promise({
          elem: e,
          props: w.extend({}, t),
          opts: w.extend(
            !0,
            { specialEasing: {}, easing: w.easing._default },
            i
          ),
          originalProperties: t,
          originalOptions: i,
          startTime: eX || eJ(),
          duration: i.duration,
          tweens: [],
          createTween: function (t, i) {
            var n = w.Tween(
              e,
              l.opts,
              t,
              i,
              l.opts.specialEasing[t] || l.opts.easing
            );
            return l.tweens.push(n), n;
          },
          stop: function (t) {
            var i = 0,
              n = t ? l.tweens.length : 0;
            if (r) return this;
            for (r = !0; i < n; i++) l.tweens[i].run(1);
            return (
              t
                ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t]))
                : s.rejectWith(e, [l, t]),
              this
            );
          },
        }),
        d = l.props;
      for (
        (function (e, t) {
          var i, n, r, o, a;
          for (i in e)
            if (
              ((r = t[(n = Q(i))]),
              Array.isArray((o = e[i])) && ((r = o[1]), (o = e[i] = o[0])),
              i !== n && ((e[n] = o), delete e[i]),
              (a = w.cssHooks[n]) && ("expand" in a))
            )
              for (i in ((o = a.expand(o)), delete e[n], o))
                (i in e) || ((e[i] = o[i]), (t[i] = r));
            else t[n] = r;
        })(d, l.opts.specialEasing);
        o < a;
        o++
      )
        if ((n = tt.prefilters[o].call(l, e, d, l.opts)))
          return (
            f(n.stop) &&
              (w._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)),
            n
          );
      return (
        w.map(d, te, l),
        f(l.opts.start) && l.opts.start.call(e, l),
        l
          .progress(l.opts.progress)
          .done(l.opts.done, l.opts.complete)
          .fail(l.opts.fail)
          .always(l.opts.always),
        w.fx.timer(w.extend(c, { elem: e, anim: l, queue: l.opts.queue })),
        l
      );
    }
    (w.Animation = w.extend(tt, {
      tweeners: {
        "*": [
          function (e, t) {
            var i = this.createTween(e, t);
            return ec(i.elem, e, ei.exec(t), i), i;
          },
        ],
      },
      tweener: function (e, t) {
        f(e) ? ((t = e), (e = ["*"])) : (e = e.match(j));
        for (var i, n = 0, r = e.length; n < r; n++)
          (i = e[n]),
            (tt.tweeners[i] = tt.tweeners[i] || []),
            tt.tweeners[i].unshift(t);
      },
      prefilters: [
        function (e, t, i) {
          var n,
            r,
            o,
            a,
            s,
            c,
            l,
            d,
            u = "width" in t || "height" in t,
            h = this,
            p = {},
            f = e.style,
            m = e.nodeType && es(e),
            g = Y.get(e, "fxshow");
          for (n in (i.queue ||
            (null == (a = w._queueHooks(e, "fx")).unqueued &&
              ((a.unqueued = 0),
              (s = a.empty.fire),
              (a.empty.fire = function () {
                a.unqueued || s();
              })),
            a.unqueued++,
            h.always(function () {
              h.always(function () {
                a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
              });
            })),
          t))
            if (((r = t[n]), eK.test(r))) {
              if (
                (delete t[n],
                (o = o || "toggle" === r),
                r === (m ? "hide" : "show"))
              ) {
                if ("show" !== r || !g || void 0 === g[n]) continue;
                m = !0;
              }
              p[n] = (g && g[n]) || w.style(e, n);
            }
          if ((c = !w.isEmptyObject(t)) || !w.isEmptyObject(p))
            for (n in (u &&
              1 === e.nodeType &&
              ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
              null == (l = g && g.display) && (l = Y.get(e, "display")),
              "none" === (d = w.css(e, "display")) &&
                (l
                  ? (d = l)
                  : (ed([e], !0),
                    (l = e.style.display || l),
                    (d = w.css(e, "display")),
                    ed([e]))),
              ("inline" === d || ("inline-block" === d && null != l)) &&
                "none" === w.css(e, "float") &&
                (c ||
                  (h.done(function () {
                    f.display = l;
                  }),
                  null == l && (l = "none" === (d = f.display) ? "" : d)),
                (f.display = "inline-block"))),
            i.overflow &&
              ((f.overflow = "hidden"),
              h.always(function () {
                (f.overflow = i.overflow[0]),
                  (f.overflowX = i.overflow[1]),
                  (f.overflowY = i.overflow[2]);
              })),
            (c = !1),
            p))
              c ||
                (g
                  ? "hidden" in g && (m = g.hidden)
                  : (g = Y.access(e, "fxshow", { display: l })),
                o && (g.hidden = !m),
                m && ed([e], !0),
                h.done(function () {
                  for (n in (m || ed([e]), Y.remove(e, "fxshow"), p))
                    w.style(e, n, p[n]);
                })),
                (c = te(m ? g[n] : 0, n, h)),
                n in g ||
                  ((g[n] = c.start), m && ((c.end = c.start), (c.start = 0)));
        },
      ],
      prefilter: function (e, t) {
        t ? tt.prefilters.unshift(e) : tt.prefilters.push(e);
      },
    })),
      (w.speed = function (e, t, i) {
        var n =
          e && "object" == typeof e
            ? w.extend({}, e)
            : {
                complete: i || (!i && t) || (f(e) && e),
                duration: e,
                easing: (i && t) || (t && !f(t) && t),
              };
        return (
          w.fx.off
            ? (n.duration = 0)
            : "number" != typeof n.duration &&
              (n.duration in w.fx.speeds
                ? (n.duration = w.fx.speeds[n.duration])
                : (n.duration = w.fx.speeds._default)),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            f(n.old) && n.old.call(this), n.queue && w.dequeue(this, n.queue);
          }),
          n
        );
      }),
      w.fn.extend({
        fadeTo: function (e, t, i, n) {
          return this.filter(es)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: t }, e, i, n);
        },
        animate: function (e, t, i, n) {
          var r = w.isEmptyObject(e),
            o = w.speed(t, i, n),
            a = function () {
              var t = tt(this, w.extend({}, e), o);
              (r || Y.get(this, "finish")) && t.stop(!0);
            };
          return (
            (a.finish = a),
            r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
          );
        },
        stop: function (e, t, i) {
          var n = function (e) {
            var t = e.stop;
            delete e.stop, t(i);
          };
          return (
            "string" != typeof e && ((i = t), (t = e), (e = void 0)),
            t && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                r = null != e && e + "queueHooks",
                o = w.timers,
                a = Y.get(this);
              if (r) a[r] && a[r].stop && n(a[r]);
              else for (r in a) a[r] && a[r].stop && e6.test(r) && n(a[r]);
              for (r = o.length; r--; )
                o[r].elem !== this ||
                  (null != e && o[r].queue !== e) ||
                  (o[r].anim.stop(i), (t = !1), o.splice(r, 1));
              (!t && i) || w.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            !1 !== e && (e = e || "fx"),
            this.each(function () {
              var t,
                i = Y.get(this),
                n = i[e + "queue"],
                r = i[e + "queueHooks"],
                o = w.timers,
                a = n ? n.length : 0;
              for (
                i.finish = !0,
                  w.queue(this, e, []),
                  r && r.stop && r.stop.call(this, !0),
                  t = o.length;
                t--;

              )
                o[t].elem === this &&
                  o[t].queue === e &&
                  (o[t].anim.stop(!0), o.splice(t, 1));
              for (t = 0; t < a; t++)
                n[t] && n[t].finish && n[t].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      w.each(["toggle", "show", "hide"], function (e, t) {
        var i = w.fn[t];
        w.fn[t] = function (e, n, r) {
          return null == e || "boolean" == typeof e
            ? i.apply(this, arguments)
            : this.animate(eZ(t, !0), e, n, r);
        };
      }),
      w.each(
        {
          slideDown: eZ("show"),
          slideUp: eZ("hide"),
          slideToggle: eZ("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (e, t) {
          w.fn[e] = function (e, i, n) {
            return this.animate(t, e, i, n);
          };
        }
      ),
      (w.timers = []),
      (w.fx.tick = function () {
        var e,
          t = 0,
          i = w.timers;
        for (eX = Date.now(); t < i.length; t++)
          (e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || w.fx.stop(), (eX = void 0);
      }),
      (w.fx.timer = function (e) {
        w.timers.push(e), w.fx.start();
      }),
      (w.fx.interval = 13),
      (w.fx.start = function () {
        eY ||
          ((eY = !0),
          (function t() {
            eY &&
              (!1 === g.hidden && e.requestAnimationFrame
                ? e.requestAnimationFrame(t)
                : e.setTimeout(t, w.fx.interval),
              w.fx.tick());
          })());
      }),
      (w.fx.stop = function () {
        eY = null;
      }),
      (w.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (w.fn.delay = function (t, i) {
        return (
          (t = (w.fx && w.fx.speeds[t]) || t),
          (i = i || "fx"),
          this.queue(i, function (i, n) {
            var r = e.setTimeout(i, t);
            n.stop = function () {
              e.clearTimeout(r);
            };
          })
        );
      }),
      (e7 = g.createElement("input")),
      (e5 = g.createElement("select").appendChild(g.createElement("option"))),
      (e7.type = "checkbox"),
      (p.checkOn = "" !== e7.value),
      (p.optSelected = e5.selected),
      ((e7 = g.createElement("input")).value = "t"),
      (e7.type = "radio"),
      (p.radioValue = "t" === e7.value);
    var ti,
      tn = w.expr.attrHandle;
    w.fn.extend({
      attr: function (e, t) {
        return F(this, w.attr, e, t, 1 < arguments.length);
      },
      removeAttr: function (e) {
        return this.each(function () {
          w.removeAttr(this, e);
        });
      },
    }),
      w.extend({
        attr: function (e, t, i) {
          var n,
            r,
            o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return void 0 === e.getAttribute
              ? w.prop(e, t, i)
              : ((1 === o && w.isXMLDoc(e)) ||
                  (r =
                    w.attrHooks[t.toLowerCase()] ||
                    (w.expr.match.bool.test(t) ? ti : void 0)),
                void 0 !== i
                  ? null === i
                    ? void w.removeAttr(e, t)
                    : r && "set" in r && void 0 !== (n = r.set(e, i, t))
                    ? n
                    : (e.setAttribute(t, i + ""), i)
                  : r && "get" in r && null !== (n = r.get(e, t))
                  ? n
                  : null == (n = w.find.attr(e, t))
                  ? void 0
                  : n);
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (!p.radioValue && "radio" === t && E(e, "input")) {
                var i = e.value;
                return e.setAttribute("type", t), i && (e.value = i), t;
              }
            },
          },
        },
        removeAttr: function (e, t) {
          var i,
            n = 0,
            r = t && t.match(j);
          if (r && 1 === e.nodeType)
            for (; (i = r[n++]); ) e.removeAttribute(i);
        },
      }),
      (ti = {
        set: function (e, t, i) {
          return !1 === t ? w.removeAttr(e, i) : e.setAttribute(i, i), i;
        },
      }),
      w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
        var i = tn[t] || w.find.attr;
        tn[t] = function (e, t, n) {
          var r,
            o,
            a = t.toLowerCase();
          return (
            n ||
              ((o = tn[a]),
              (tn[a] = r),
              (r = null != i(e, t, n) ? a : null),
              (tn[a] = o)),
            r
          );
        };
      });
    var tr = /^(?:input|select|textarea|button)$/i,
      to = /^(?:a|area)$/i;
    function ta(e) {
      return (e.match(j) || []).join(" ");
    }
    function ts(e) {
      return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function tc(e) {
      return Array.isArray(e) ? e : ("string" == typeof e && e.match(j)) || [];
    }
    w.fn.extend({
      prop: function (e, t) {
        return F(this, w.prop, e, t, 1 < arguments.length);
      },
      removeProp: function (e) {
        return this.each(function () {
          delete this[w.propFix[e] || e];
        });
      },
    }),
      w.extend({
        prop: function (e, t, i) {
          var n,
            r,
            o = e.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return (
              (1 === o && w.isXMLDoc(e)) ||
                ((t = w.propFix[t] || t), (r = w.propHooks[t])),
              void 0 !== i
                ? r && "set" in r && void 0 !== (n = r.set(e, i, t))
                  ? n
                  : (e[t] = i)
                : r && "get" in r && null !== (n = r.get(e, t))
                ? n
                : e[t]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var t = w.find.attr(e, "tabindex");
              return t
                ? parseInt(t, 10)
                : tr.test(e.nodeName) || (to.test(e.nodeName) && e.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      p.optSelected ||
        (w.propHooks.selected = {
          get: function (e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null;
          },
          set: function (e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
          },
        }),
      w.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          w.propFix[this.toLowerCase()] = this;
        }
      ),
      w.fn.extend({
        addClass: function (e) {
          var t,
            i,
            n,
            r,
            o,
            a,
            s,
            c = 0;
          if (f(e))
            return this.each(function (t) {
              w(this).addClass(e.call(this, t, ts(this)));
            });
          if ((t = tc(e)).length) {
            for (; (i = this[c++]); )
              if (((r = ts(i)), (n = 1 === i.nodeType && " " + ta(r) + " "))) {
                for (a = 0; (o = t[a++]); )
                  0 > n.indexOf(" " + o + " ") && (n += o + " ");
                r !== (s = ta(n)) && i.setAttribute("class", s);
              }
          }
          return this;
        },
        removeClass: function (e) {
          var t,
            i,
            n,
            r,
            o,
            a,
            s,
            c = 0;
          if (f(e))
            return this.each(function (t) {
              w(this).removeClass(e.call(this, t, ts(this)));
            });
          if (!arguments.length) return this.attr("class", "");
          if ((t = tc(e)).length) {
            for (; (i = this[c++]); )
              if (((r = ts(i)), (n = 1 === i.nodeType && " " + ta(r) + " "))) {
                for (a = 0; (o = t[a++]); )
                  for (; -1 < n.indexOf(" " + o + " "); )
                    n = n.replace(" " + o + " ", " ");
                r !== (s = ta(n)) && i.setAttribute("class", s);
              }
          }
          return this;
        },
        toggleClass: function (e, t) {
          var i = typeof e,
            n = "string" === i || Array.isArray(e);
          return "boolean" == typeof t && n
            ? t
              ? this.addClass(e)
              : this.removeClass(e)
            : f(e)
            ? this.each(function (i) {
                w(this).toggleClass(e.call(this, i, ts(this), t), t);
              })
            : this.each(function () {
                var t, r, o, a;
                if (n)
                  for (r = 0, o = w(this), a = tc(e); (t = a[r++]); )
                    o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                else
                  (void 0 !== e && "boolean" !== i) ||
                    ((t = ts(this)) && Y.set(this, "__className__", t),
                    this.setAttribute &&
                      this.setAttribute(
                        "class",
                        t || !1 === e ? "" : Y.get(this, "__className__") || ""
                      ));
              });
        },
        hasClass: function (e) {
          var t,
            i,
            n = 0;
          for (t = " " + e + " "; (i = this[n++]); )
            if (1 === i.nodeType && -1 < (" " + ta(ts(i)) + " ").indexOf(t))
              return !0;
          return !1;
        },
      });
    var tl = /\r/g;
    w.fn.extend({
      val: function (e) {
        var t,
          i,
          n,
          r = this[0];
        return arguments.length
          ? ((n = f(e)),
            this.each(function (i) {
              var r;
              1 === this.nodeType &&
                (null == (r = n ? e.call(this, i, w(this).val()) : e)
                  ? (r = "")
                  : "number" == typeof r
                  ? (r += "")
                  : Array.isArray(r) &&
                    (r = w.map(r, function (e) {
                      return null == e ? "" : e + "";
                    })),
                ((t =
                  w.valHooks[this.type] ||
                  w.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in t &&
                  void 0 !== t.set(this, r, "value")) ||
                  (this.value = r));
            }))
          : r
          ? (t = w.valHooks[r.type] || w.valHooks[r.nodeName.toLowerCase()]) &&
            "get" in t &&
            void 0 !== (i = t.get(r, "value"))
            ? i
            : "string" == typeof (i = r.value)
            ? i.replace(tl, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      w.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = w.find.attr(e, "value");
              return null != t ? t : ta(w.text(e));
            },
          },
          select: {
            get: function (e) {
              var t,
                i,
                n,
                r = e.options,
                o = e.selectedIndex,
                a = "select-one" === e.type,
                s = a ? null : [],
                c = a ? o + 1 : r.length;
              for (n = o < 0 ? c : a ? o : 0; n < c; n++)
                if (
                  ((i = r[n]).selected || n === o) &&
                  !i.disabled &&
                  (!i.parentNode.disabled || !E(i.parentNode, "optgroup"))
                ) {
                  if (((t = w(i).val()), a)) return t;
                  s.push(t);
                }
              return s;
            },
            set: function (e, t) {
              for (
                var i, n, r = e.options, o = w.makeArray(t), a = r.length;
                a--;

              )
                ((n = r[a]).selected =
                  -1 < w.inArray(w.valHooks.option.get(n), o)) && (i = !0);
              return i || (e.selectedIndex = -1), o;
            },
          },
        },
      }),
      w.each(["radio", "checkbox"], function () {
        (w.valHooks[this] = {
          set: function (e, t) {
            if (Array.isArray(t))
              return (e.checked = -1 < w.inArray(w(e).val(), t));
          },
        }),
          p.checkOn ||
            (w.valHooks[this].get = function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            });
      }),
      (p.focusin = "onfocusin" in e);
    var td = /^(?:focusinfocus|focusoutblur)$/,
      tu = function (e) {
        e.stopPropagation();
      };
    w.extend(w.event, {
      trigger: function (t, i, n, r) {
        var o,
          a,
          s,
          c,
          l,
          u,
          h,
          p,
          v = [n || g],
          y = d.call(t, "type") ? t.type : t,
          b = d.call(t, "namespace") ? t.namespace.split(".") : [];
        if (
          ((a = p = s = n = n || g),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !td.test(y + w.event.triggered) &&
            (-1 < y.indexOf(".") &&
              ((y = (b = y.split(".")).shift()), b.sort()),
            (l = 0 > y.indexOf(":") && "on" + y),
            ((t = t[w.expando]
              ? t
              : new w.Event(y, "object" == typeof t && t)).isTrigger = r
              ? 2
              : 3),
            (t.namespace = b.join(".")),
            (t.rnamespace = t.namespace
              ? RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (t.result = void 0),
            t.target || (t.target = n),
            (i = null == i ? [t] : w.makeArray(i, [t])),
            (h = w.event.special[y] || {}),
            r || !h.trigger || !1 !== h.trigger.apply(n, i)))
        ) {
          if (!r && !h.noBubble && !m(n)) {
            for (
              c = h.delegateType || y, td.test(c + y) || (a = a.parentNode);
              a;
              a = a.parentNode
            )
              v.push(a), (s = a);
            s === (n.ownerDocument || g) &&
              v.push(s.defaultView || s.parentWindow || e);
          }
          for (o = 0; (a = v[o++]) && !t.isPropagationStopped(); )
            (p = a),
              (t.type = 1 < o ? c : h.bindType || y),
              (u =
                (Y.get(a, "events") || Object.create(null))[t.type] &&
                Y.get(a, "handle")) && u.apply(a, i),
              (u = l && a[l]) &&
                u.apply &&
                G(a) &&
                ((t.result = u.apply(a, i)),
                !1 === t.result && t.preventDefault());
          return (
            (t.type = y),
            r ||
              t.isDefaultPrevented() ||
              (h._default && !1 !== h._default.apply(v.pop(), i)) ||
              !G(n) ||
              (l &&
                f(n[y]) &&
                !m(n) &&
                ((s = n[l]) && (n[l] = null),
                (w.event.triggered = y),
                t.isPropagationStopped() && p.addEventListener(y, tu),
                n[y](),
                t.isPropagationStopped() && p.removeEventListener(y, tu),
                (w.event.triggered = void 0),
                s && (n[l] = s))),
            t.result
          );
        }
      },
      simulate: function (e, t, i) {
        var n = w.extend(new w.Event(), i, { type: e, isSimulated: !0 });
        w.event.trigger(n, null, t);
      },
    }),
      w.fn.extend({
        trigger: function (e, t) {
          return this.each(function () {
            w.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, t) {
          var i = this[0];
          if (i) return w.event.trigger(e, t, i, !0);
        },
      }),
      p.focusin ||
        w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
          var i = function (e) {
            w.event.simulate(t, e.target, w.event.fix(e));
          };
          w.event.special[t] = {
            setup: function () {
              var n = this.ownerDocument || this.document || this,
                r = Y.access(n, t);
              r || n.addEventListener(e, i, !0), Y.access(n, t, (r || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this.document || this,
                r = Y.access(n, t) - 1;
              r
                ? Y.access(n, t, r)
                : (n.removeEventListener(e, i, !0), Y.remove(n, t));
            },
          };
        });
    var th = e.location,
      tp = { guid: Date.now() },
      tf = /\?/;
    w.parseXML = function (t) {
      var i;
      if (!t || "string" != typeof t) return null;
      try {
        i = new e.DOMParser().parseFromString(t, "text/xml");
      } catch (n) {
        i = void 0;
      }
      return (
        (i && !i.getElementsByTagName("parsererror").length) ||
          w.error("Invalid XML: " + t),
        i
      );
    };
    var tm = /\[\]$/,
      tg = /\r?\n/g,
      tv = /^(?:submit|button|image|reset|file)$/i,
      ty = /^(?:input|select|textarea|keygen)/i;
    function tb(e, t, i, n) {
      var r;
      if (Array.isArray(t))
        w.each(t, function (t, r) {
          i || tm.test(e)
            ? n(e, r)
            : tb(
                e + "[" + ("object" == typeof r && null != r ? t : "") + "]",
                r,
                i,
                n
              );
        });
      else if (i || "object" !== b(t)) n(e, t);
      else for (r in t) tb(e + "[" + r + "]", t[r], i, n);
    }
    (w.param = function (e, t) {
      var i,
        n = [],
        r = function (e, t) {
          var i = f(t) ? t() : t;
          n[n.length] =
            encodeURIComponent(e) +
            "=" +
            encodeURIComponent(null == i ? "" : i);
        };
      if (null == e) return "";
      if (Array.isArray(e) || (e.jquery && !w.isPlainObject(e)))
        w.each(e, function () {
          r(this.name, this.value);
        });
      else for (i in e) tb(i, e[i], t, r);
      return n.join("&");
    }),
      w.fn.extend({
        serialize: function () {
          return w.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var e = w.prop(this, "elements");
            return e ? w.makeArray(e) : this;
          })
            .filter(function () {
              var e = this.type;
              return (
                this.name &&
                !w(this).is(":disabled") &&
                ty.test(this.nodeName) &&
                !tv.test(e) &&
                (this.checked || !ep.test(e))
              );
            })
            .map(function (e, t) {
              var i = w(this).val();
              return null == i
                ? null
                : Array.isArray(i)
                ? w.map(i, function (e) {
                    return { name: t.name, value: e.replace(tg, "\r\n") };
                  })
                : { name: t.name, value: i.replace(tg, "\r\n") };
            })
            .get();
        },
      });
    var t$ = /%20/g,
      tS = /#.*$/,
      tw = /([?&])_=[^&]*/,
      tx = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      t_ = /^(?:GET|HEAD)$/,
      tk = /^\/\//,
      tL = {},
      t8 = {},
      tC = "*/".concat("*"),
      tE = g.createElement("a");
    function tT(e) {
      return function (t, i) {
        "string" != typeof t && ((i = t), (t = "*"));
        var n,
          r = 0,
          o = t.toLowerCase().match(j) || [];
        if (f(i))
          for (; (n = o[r++]); )
            "+" === n[0]
              ? (e[(n = n.slice(1) || "*")] = e[n] || []).unshift(i)
              : (e[n] = e[n] || []).push(i);
      };
    }
    function tq(e, t, i, n) {
      var r = {},
        o = e === t8;
      function a(s) {
        var c;
        return (
          (r[s] = !0),
          w.each(e[s] || [], function (e, s) {
            var l = s(t, i, n);
            return "string" != typeof l || o || r[l]
              ? o
                ? !(c = l)
                : void 0
              : (t.dataTypes.unshift(l), a(l), !1);
          }),
          c
        );
      }
      return a(t.dataTypes[0]) || (!r["*"] && a("*"));
    }
    function tI(e, t) {
      var i,
        n,
        r = w.ajaxSettings.flatOptions || {};
      for (i in t) void 0 !== t[i] && ((r[i] ? e : n || (n = {}))[i] = t[i]);
      return n && w.extend(!0, e, n), e;
    }
    (tE.href = th.href),
      w.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: th.href,
          type: "GET",
          isLocal:
            /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
              th.protocol
            ),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": tC,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON",
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": w.parseXML,
          },
          flatOptions: { url: !0, context: !0 },
        },
        ajaxSetup: function (e, t) {
          return t ? tI(tI(e, w.ajaxSettings), t) : tI(w.ajaxSettings, e);
        },
        ajaxPrefilter: tT(tL),
        ajaxTransport: tT(t8),
        ajax: function (t, i) {
          "object" == typeof t && ((i = t), (t = void 0)), (i = i || {});
          var n,
            r,
            o,
            a,
            s,
            c,
            l,
            d,
            u,
            h,
            p = w.ajaxSetup({}, i),
            f = p.context || p,
            m = p.context && (f.nodeType || f.jquery) ? w(f) : w.event,
            v = w.Deferred(),
            y = w.Callbacks("once memory"),
            b = p.statusCode || {},
            S = {},
            x = {},
            _ = "canceled",
            k = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (l) {
                  if (!a)
                    for (a = {}; (t = tx.exec(o)); )
                      a[t[1].toLowerCase() + " "] = (
                        a[t[1].toLowerCase() + " "] || []
                      ).concat(t[2]);
                  t = a[e.toLowerCase() + " "];
                }
                return null == t ? null : t.join(", ");
              },
              getAllResponseHeaders: function () {
                return l ? o : null;
              },
              setRequestHeader: function (e, t) {
                return (
                  null == l &&
                    (S[(e = x[e.toLowerCase()] = x[e.toLowerCase()] || e)] = t),
                  this
                );
              },
              overrideMimeType: function (e) {
                return null == l && (p.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e) {
                  if (l) k.always(e[k.status]);
                  else for (t in e) b[t] = [b[t], e[t]];
                }
                return this;
              },
              abort: function (e) {
                var t = e || _;
                return n && n.abort(t), E(0, t), this;
              },
            };
          if (
            (v.promise(k),
            (p.url = ((t || p.url || th.href) + "").replace(
              tk,
              th.protocol + "//"
            )),
            (p.type = i.method || i.type || p.method || p.type),
            (p.dataTypes = (p.dataType || "*").toLowerCase().match(j) || [""]),
            null == p.crossDomain)
          ) {
            c = g.createElement("a");
            try {
              (c.href = p.url),
                (c.href = c.href),
                (p.crossDomain =
                  tE.protocol + "//" + tE.host != c.protocol + "//" + c.host);
            } catch (L) {
              p.crossDomain = !0;
            }
          }
          if (
            (p.data &&
              p.processData &&
              "string" != typeof p.data &&
              (p.data = w.param(p.data, p.traditional)),
            tq(tL, p, i, k),
            l)
          )
            return k;
          for (u in ((d = w.event && p.global) &&
            0 == w.active++ &&
            w.event.trigger("ajaxStart"),
          (p.type = p.type.toUpperCase()),
          (p.hasContent = !t_.test(p.type)),
          (r = p.url.replace(tS, "")),
          p.hasContent
            ? p.data &&
              p.processData &&
              0 ===
                (p.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              (p.data = p.data.replace(t$, "+"))
            : ((h = p.url.slice(r.length)),
              p.data &&
                (p.processData || "string" == typeof p.data) &&
                ((r += (tf.test(r) ? "&" : "?") + p.data), delete p.data),
              !1 === p.cache &&
                ((r = r.replace(tw, "$1")),
                (h = (tf.test(r) ? "&" : "?") + "_=" + tp.guid++ + h)),
              (p.url = r + h)),
          p.ifModified &&
            (w.lastModified[r] &&
              k.setRequestHeader("If-Modified-Since", w.lastModified[r]),
            w.etag[r] && k.setRequestHeader("If-None-Match", w.etag[r])),
          ((p.data && p.hasContent && !1 !== p.contentType) || i.contentType) &&
            k.setRequestHeader("Content-Type", p.contentType),
          k.setRequestHeader(
            "Accept",
            p.dataTypes[0] && p.accepts[p.dataTypes[0]]
              ? p.accepts[p.dataTypes[0]] +
                  ("*" !== p.dataTypes[0] ? ", " + tC + "; q=0.01" : "")
              : p.accepts["*"]
          ),
          p.headers))
            k.setRequestHeader(u, p.headers[u]);
          if (p.beforeSend && (!1 === p.beforeSend.call(f, k, p) || l))
            return k.abort();
          if (
            ((_ = "abort"),
            y.add(p.complete),
            k.done(p.success),
            k.fail(p.error),
            (n = tq(t8, p, i, k)))
          ) {
            if (((k.readyState = 1), d && m.trigger("ajaxSend", [k, p]), l))
              return k;
            p.async &&
              0 < p.timeout &&
              (s = e.setTimeout(function () {
                k.abort("timeout");
              }, p.timeout));
            try {
              (l = !1), n.send(S, E);
            } catch (C) {
              if (l) throw C;
              E(-1, C);
            }
          } else E(-1, "No Transport");
          function E(t, i, a, c) {
            var u,
              h,
              g,
              S,
              x,
              _ = i;
            l ||
              ((l = !0),
              s && e.clearTimeout(s),
              (n = void 0),
              (o = c || ""),
              (k.readyState = 0 < t ? 4 : 0),
              (u = (200 <= t && t < 300) || 304 === t),
              a &&
                (S = (function (e, t, i) {
                  for (
                    var n, r, o, a, s = e.contents, c = e.dataTypes;
                    "*" === c[0];

                  )
                    c.shift(),
                      void 0 === n &&
                        (n = e.mimeType || t.getResponseHeader("Content-Type"));
                  if (n) {
                    for (r in s)
                      if (s[r] && s[r].test(n)) {
                        c.unshift(r);
                        break;
                      }
                  }
                  if (c[0] in i) o = c[0];
                  else {
                    for (r in i) {
                      if (!c[0] || e.converters[r + " " + c[0]]) {
                        o = r;
                        break;
                      }
                      a || (a = r);
                    }
                    o = o || a;
                  }
                  if (o) return o !== c[0] && c.unshift(o), i[o];
                })(p, k, a)),
              !u &&
                -1 < w.inArray("script", p.dataTypes) &&
                (p.converters["text script"] = function () {}),
              (S = (function (e, t, i, n) {
                var r,
                  o,
                  a,
                  s,
                  c,
                  l = {},
                  d = e.dataTypes.slice();
                if (d[1])
                  for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
                for (o = d.shift(); o; )
                  if (
                    (e.responseFields[o] && (i[e.responseFields[o]] = t),
                    !c &&
                      n &&
                      e.dataFilter &&
                      (t = e.dataFilter(t, e.dataType)),
                    (c = o),
                    (o = d.shift()))
                  ) {
                    if ("*" === o) o = c;
                    else if ("*" !== c && c !== o) {
                      if (!(a = l[c + " " + o] || l["* " + o])) {
                        for (r in l)
                          if (
                            (s = r.split(" "))[1] === o &&
                            (a = l[c + " " + s[0]] || l["* " + s[0]])
                          ) {
                            !0 === a
                              ? (a = l[r])
                              : !0 !== l[r] && ((o = s[0]), d.unshift(s[1]));
                            break;
                          }
                      }
                      if (!0 !== a) {
                        if (a && e.throws) t = a(t);
                        else
                          try {
                            t = a(t);
                          } catch (u) {
                            return {
                              state: "parsererror",
                              error: a
                                ? u
                                : "No conversion from " + c + " to " + o,
                            };
                          }
                      }
                    }
                  }
                return { state: "success", data: t };
              })(p, S, k, u)),
              u
                ? (p.ifModified &&
                    ((x = k.getResponseHeader("Last-Modified")) &&
                      (w.lastModified[r] = x),
                    (x = k.getResponseHeader("etag")) && (w.etag[r] = x)),
                  204 === t || "HEAD" === p.type
                    ? (_ = "nocontent")
                    : 304 === t
                    ? (_ = "notmodified")
                    : ((_ = S.state), (h = S.data), (u = !(g = S.error))))
                : ((g = _), (!t && _) || ((_ = "error"), t < 0 && (t = 0))),
              (k.status = t),
              (k.statusText = (i || _) + ""),
              u ? v.resolveWith(f, [h, _, k]) : v.rejectWith(f, [k, _, g]),
              k.statusCode(b),
              (b = void 0),
              d &&
                m.trigger(u ? "ajaxSuccess" : "ajaxError", [k, p, u ? h : g]),
              y.fireWith(f, [k, _]),
              d &&
                (m.trigger("ajaxComplete", [k, p]),
                --w.active || w.event.trigger("ajaxStop")));
          }
          return k;
        },
        getJSON: function (e, t, i) {
          return w.get(e, t, i, "json");
        },
        getScript: function (e, t) {
          return w.get(e, void 0, t, "script");
        },
      }),
      w.each(["get", "post"], function (e, t) {
        w[t] = function (e, i, n, r) {
          return (
            f(i) && ((r = r || n), (n = i), (i = void 0)),
            w.ajax(
              w.extend(
                { url: e, type: t, dataType: r, data: i, success: n },
                w.isPlainObject(e) && e
              )
            )
          );
        };
      }),
      w.ajaxPrefilter(function (e) {
        var t;
        for (t in e.headers)
          "content-type" === t.toLowerCase() &&
            (e.contentType = e.headers[t] || "");
      }),
      (w._evalUrl = function (e, t, i) {
        return w.ajax({
          url: e,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: { "text script": function () {} },
          dataFilter: function (e) {
            w.globalEval(e, t, i);
          },
        });
      }),
      w.fn.extend({
        wrapAll: function (e) {
          var t;
          return (
            this[0] &&
              (f(e) && (e = e.call(this[0])),
              (t = w(e, this[0].ownerDocument).eq(0).clone(!0)),
              this[0].parentNode && t.insertBefore(this[0]),
              t
                .map(function () {
                  for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                  return e;
                })
                .append(this)),
            this
          );
        },
        wrapInner: function (e) {
          return f(e)
            ? this.each(function (t) {
                w(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = w(this),
                  i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = f(e);
          return this.each(function (i) {
            w(this).wrapAll(t ? e.call(this, i) : e);
          });
        },
        unwrap: function (e) {
          return (
            this.parent(e)
              .not("body")
              .each(function () {
                w(this).replaceWith(this.childNodes);
              }),
            this
          );
        },
      }),
      (w.expr.pseudos.hidden = function (e) {
        return !w.expr.pseudos.visible(e);
      }),
      (w.expr.pseudos.visible = function (e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
      }),
      (w.ajaxSettings.xhr = function () {
        try {
          return new e.XMLHttpRequest();
        } catch (t) {}
      });
    var tA = { 0: 200, 1223: 204 },
      tP = w.ajaxSettings.xhr();
    (p.cors = !!tP && "withCredentials" in tP),
      (p.ajax = tP = !!tP),
      w.ajaxTransport(function (t) {
        var i, n;
        if (p.cors || (tP && !t.crossDomain))
          return {
            send: function (r, o) {
              var a,
                s = t.xhr();
              if (
                (s.open(t.type, t.url, t.async, t.username, t.password),
                t.xhrFields)
              )
                for (a in t.xhrFields) s[a] = t.xhrFields[a];
              for (a in (t.mimeType &&
                s.overrideMimeType &&
                s.overrideMimeType(t.mimeType),
              t.crossDomain ||
                r["X-Requested-With"] ||
                (r["X-Requested-With"] = "XMLHttpRequest"),
              r))
                s.setRequestHeader(a, r[a]);
              (i = function (e) {
                return function () {
                  i &&
                    ((i =
                      n =
                      s.onload =
                      s.onerror =
                      s.onabort =
                      s.ontimeout =
                      s.onreadystatechange =
                        null),
                    "abort" === e
                      ? s.abort()
                      : "error" === e
                      ? "number" != typeof s.status
                        ? o(0, "error")
                        : o(s.status, s.statusText)
                      : o(
                          tA[s.status] || s.status,
                          s.statusText,
                          "text" !== (s.responseType || "text") ||
                            "string" != typeof s.responseText
                            ? { binary: s.response }
                            : { text: s.responseText },
                          s.getAllResponseHeaders()
                        ));
                };
              }),
                (s.onload = i()),
                (n = s.onerror = s.ontimeout = i("error")),
                void 0 !== s.onabort
                  ? (s.onabort = n)
                  : (s.onreadystatechange = function () {
                      4 === s.readyState &&
                        e.setTimeout(function () {
                          i && n();
                        });
                    }),
                (i = i("abort"));
              try {
                s.send((t.hasContent && t.data) || null);
              } catch (c) {
                if (i) throw c;
              }
            },
            abort: function () {
              i && i();
            },
          };
      }),
      w.ajaxPrefilter(function (e) {
        e.crossDomain && (e.contents.script = !1);
      }),
      w.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (e) {
            return w.globalEval(e), e;
          },
        },
      }),
      w.ajaxPrefilter("script", function (e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
      }),
      w.ajaxTransport("script", function (e) {
        var t, i;
        if (e.crossDomain || e.scriptAttrs)
          return {
            send: function (n, r) {
              (t = w("<script>")
                .attr(e.scriptAttrs || {})
                .prop({ charset: e.scriptCharset, src: e.url })
                .on(
                  "load error",
                  (i = function (e) {
                    t.remove(),
                      (i = null),
                      e && r("error" === e.type ? 404 : 200, e.type);
                  })
                )),
                g.head.appendChild(t[0]);
            },
            abort: function () {
              i && i();
            },
          };
      });
    var tD,
      tN = [],
      tj = /(=)\?(?=&|$)|\?\?/;
    w.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = tN.pop() || w.expando + "_" + tp.guid++;
        return (this[e] = !0), e;
      },
    }),
      w.ajaxPrefilter("json jsonp", function (t, i, n) {
        var r,
          o,
          a,
          s =
            !1 !== t.jsonp &&
            (tj.test(t.url)
              ? "url"
              : "string" == typeof t.data &&
                0 ===
                  (t.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                tj.test(t.data) &&
                "data");
        if (s || "jsonp" === t.dataTypes[0])
          return (
            (r = t.jsonpCallback =
              f(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
            s
              ? (t[s] = t[s].replace(tj, "$1" + r))
              : !1 !== t.jsonp &&
                (t.url += (tf.test(t.url) ? "&" : "?") + t.jsonp + "=" + r),
            (t.converters["script json"] = function () {
              return a || w.error(r + " was not called"), a[0];
            }),
            (t.dataTypes[0] = "json"),
            (o = e[r]),
            (e[r] = function () {
              a = arguments;
            }),
            n.always(function () {
              void 0 === o ? w(e).removeProp(r) : (e[r] = o),
                t[r] && ((t.jsonpCallback = i.jsonpCallback), tN.push(r)),
                a && f(o) && o(a[0]),
                (a = o = void 0);
            }),
            "script"
          );
      }),
      (p.createHTMLDocument =
        (((tD = g.implementation.createHTMLDocument("").body).innerHTML =
          "<form></form><form></form>"),
        2 === tD.childNodes.length)),
      (w.parseHTML = function (e, t, i) {
        var n, r, o;
        return "string" != typeof e
          ? []
          : ("boolean" == typeof t && ((i = t), (t = !1)),
            t ||
              (p.createHTMLDocument
                ? (((n = (t =
                    g.implementation.createHTMLDocument("")).createElement(
                    "base"
                  )).href = g.location.href),
                  t.head.appendChild(n))
                : (t = g)),
            (o = !i && []),
            (r = T.exec(e))
              ? [t.createElement(r[1])]
              : ((r = e$([e], t, o)),
                o && o.length && w(o).remove(),
                w.merge([], r.childNodes)));
      }),
      (w.fn.load = function (e, t, i) {
        var n,
          r,
          o,
          a = this,
          s = e.indexOf(" ");
        return (
          -1 < s && ((n = ta(e.slice(s))), (e = e.slice(0, s))),
          f(t)
            ? ((i = t), (t = void 0))
            : t && "object" == typeof t && (r = "POST"),
          0 < a.length &&
            w
              .ajax({ url: e, type: r || "GET", dataType: "html", data: t })
              .done(function (e) {
                (o = arguments),
                  a.html(n ? w("<div>").append(w.parseHTML(e)).find(n) : e);
              })
              .always(
                i &&
                  function (e, t) {
                    a.each(function () {
                      i.apply(this, o || [e.responseText, t, e]);
                    });
                  }
              ),
          this
        );
      }),
      (w.expr.pseudos.animated = function (e) {
        return w.grep(w.timers, function (t) {
          return e === t.elem;
        }).length;
      }),
      (w.offset = {
        setOffset: function (e, t, i) {
          var n,
            r,
            o,
            a,
            s,
            c,
            l = w.css(e, "position"),
            d = w(e),
            u = {};
          "static" === l && (e.style.position = "relative"),
            (s = d.offset()),
            (o = w.css(e, "top")),
            (c = w.css(e, "left")),
            ("absolute" === l || "fixed" === l) && -1 < (o + c).indexOf("auto")
              ? ((a = (n = d.position()).top), (r = n.left))
              : ((a = parseFloat(o) || 0), (r = parseFloat(c) || 0)),
            f(t) && (t = t.call(e, i, w.extend({}, s))),
            null != t.top && (u.top = t.top - s.top + a),
            null != t.left && (u.left = t.left - s.left + r),
            "using" in t
              ? t.using.call(e, u)
              : ("number" == typeof u.top && (u.top += "px"),
                "number" == typeof u.left && (u.left += "px"),
                d.css(u));
        },
      }),
      w.fn.extend({
        offset: function (e) {
          if (arguments.length)
            return void 0 === e
              ? this
              : this.each(function (t) {
                  w.offset.setOffset(this, e, t);
                });
          var t,
            i,
            n = this[0];
          return n
            ? n.getClientRects().length
              ? ((t = n.getBoundingClientRect()),
                (i = n.ownerDocument.defaultView),
                { top: t.top + i.pageYOffset, left: t.left + i.pageXOffset })
              : { top: 0, left: 0 }
            : void 0;
        },
        position: function () {
          if (this[0]) {
            var e,
              t,
              i,
              n = this[0],
              r = { top: 0, left: 0 };
            if ("fixed" === w.css(n, "position")) t = n.getBoundingClientRect();
            else {
              for (
                t = this.offset(),
                  i = n.ownerDocument,
                  e = n.offsetParent || i.documentElement;
                e &&
                (e === i.body || e === i.documentElement) &&
                "static" === w.css(e, "position");

              )
                e = e.parentNode;
              e &&
                e !== n &&
                1 === e.nodeType &&
                (((r = w(e).offset()).top += w.css(e, "borderTopWidth", !0)),
                (r.left += w.css(e, "borderLeftWidth", !0)));
            }
            return {
              top: t.top - r.top - w.css(n, "marginTop", !0),
              left: t.left - r.left - w.css(n, "marginLeft", !0),
            };
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent;
              e && "static" === w.css(e, "position");

            )
              e = e.offsetParent;
            return e || er;
          });
        },
      }),
      w.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (e, t) {
          var i = "pageYOffset" === t;
          w.fn[e] = function (n) {
            return F(
              this,
              function (e, n, r) {
                var o;
                if (
                  (m(e) ? (o = e) : 9 === e.nodeType && (o = e.defaultView),
                  void 0 === r)
                )
                  return o ? o[t] : e[n];
                o
                  ? o.scrollTo(i ? o.pageXOffset : r, i ? r : o.pageYOffset)
                  : (e[n] = r);
              },
              e,
              n,
              arguments.length
            );
          };
        }
      ),
      w.each(["top", "left"], function (e, t) {
        w.cssHooks[t] = eR(p.pixelPosition, function (e, i) {
          if (i)
            return (i = eB(e, t)), eM.test(i) ? w(e).position()[t] + "px" : i;
        });
      }),
      w.each({ Height: "height", Width: "width" }, function (e, t) {
        w.each(
          { padding: "inner" + e, content: t, "": "outer" + e },
          function (i, n) {
            w.fn[n] = function (r, o) {
              var a = arguments.length && (i || "boolean" != typeof r),
                s = i || (!0 === r || !0 === o ? "margin" : "border");
              return F(
                this,
                function (t, i, r) {
                  var o;
                  return m(t)
                    ? 0 === n.indexOf("outer")
                      ? t["inner" + e]
                      : t.document.documentElement["client" + e]
                    : 9 === t.nodeType
                    ? ((o = t.documentElement),
                      Math.max(
                        t.body["scroll" + e],
                        o["scroll" + e],
                        t.body["offset" + e],
                        o["offset" + e],
                        o["client" + e]
                      ))
                    : void 0 === r
                    ? w.css(t, i, s)
                    : w.style(t, i, r, s);
                },
                t,
                a ? r : void 0,
                a
              );
            };
          }
        );
      }),
      w.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          w.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      w.fn.extend({
        bind: function (e, t, i) {
          return this.on(e, null, t, i);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, i, n) {
          return this.on(t, e, i, n);
        },
        undelegate: function (e, t, i) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", i);
        },
        hover: function (e, t) {
          return this.mouseenter(e).mouseleave(t || e);
        },
      }),
      w.each(
        "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
          " "
        ),
        function (e, t) {
          w.fn[t] = function (e, i) {
            return 0 < arguments.length
              ? this.on(t, null, e, i)
              : this.trigger(t);
          };
        }
      );
    var tM = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (w.proxy = function (e, t) {
      var i, n, o;
      if (("string" == typeof t && ((i = e[t]), (t = e), (e = i)), f(e)))
        return (
          (n = r.call(arguments, 2)),
          ((o = function () {
            return e.apply(t || this, n.concat(r.call(arguments)));
          }).guid = e.guid =
            e.guid || w.guid++),
          o
        );
    }),
      (w.holdReady = function (e) {
        e ? w.readyWait++ : w.ready(!0);
      }),
      (w.isArray = Array.isArray),
      (w.parseJSON = JSON.parse),
      (w.nodeName = E),
      (w.isFunction = f),
      (w.isWindow = m),
      (w.camelCase = Q),
      (w.type = b),
      (w.now = Date.now),
      (w.isNumeric = function (e) {
        var t = w.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
      }),
      (w.trim = function (e) {
        return null == e ? "" : (e + "").replace(tM, "");
      }),
      "function" == typeof define &&
        define.amd &&
        define("jquery", [], function () {
          return w;
        });
    var tH = e.jQuery,
      tO = e.$;
    return (
      (w.noConflict = function (t) {
        return (
          e.$ === w && (e.$ = tO), t && e.jQuery === w && (e.jQuery = tH), w
        );
      }),
      void 0 === t && (e.jQuery = e.$ = w),
      w
    );
  }),
  $(document).ready(function () {
    $(".apply-tag").click(function (e) {
      e.preventDefault(),
        $(".grid-product").hide(),
        $("." + $(this).attr("data-tag")).show(),
        window.AOS && AOS.refreshHard(),
        $(".apply-tag").removeClass("btn--primary").addClass("btn--secondary"),
        $(this).addClass("btn--primary").removeClass("btn--secondary");
    }),
      $(".open-bundle-popup:not(.open-quickview)").click(function (e) {
        e.preventDefault();
        let t = $(this).attr("data-title"),
          i = $(this).attr("data-image"),
          n = $(this).attr("data-target"),
          r = $(this).attr("data-variant");
        $(".bundle-title").html(t),
          $(".bundle-image").attr("src", i),
          $(".bundle-modal-wrapper").attr("data-handle", n),
          $(".bundle-add").attr("data-handle", n),
          $(".bundle-add").attr("data-variant", r),
          $("#Quantity-bundle").val(1),
          768 >= $(window).width() &&
            $(".bundle__main-header").removeClass("fixed"),
          new theme.Modals("bundlemodal", "bundlemodal-modal", {
            closeOffContentClick: !0,
          }).open();
      }),
      $("#bundlemodal").on("click", ".js-qty__adjust", function () {
        $(this).hasClass("js-qty__adjust--minus")
          ? $("#Quantity-bundle").val() > 1 &&
            $("#Quantity-bundle").val($("#Quantity-bundle").val() - 1)
          : $("#Quantity-bundle").val(
              parseInt($("#Quantity-bundle").val()) + 1
            );
      }),
      $(".add-to-bndle").click(function () {
        let e = $(this).attr("data-image"),
          t = $(this).attr("data-variant");
        for (
          var i = 0;
          i < $(".bundle__main-header .current__selection-block").length;
          i++
        )
          if (
            !$(".bundle__main-header .current__selection-block")
              .eq(i)
              .hasClass("active")
          ) {
            let n = $(".bundle__main-header .current__selection-block").eq(i);
            n
              .addClass("active")
              .attr("data-variant", t)
              .attr("data-quantity", 1),
              n.find(".current__selection-block_empety").hide(),
              n.find(".current__selection-block-image img").attr("src", e),
              n.find(".current__selection-block-image").show();
            break;
          }
      }),
      $(".bundle-page").on("click", ".bundle-add", function () {
        let e = $(this).parent(),
          t = e.find(".bundle-image").attr("src");
        if ($(this).hasClass("bundle-add-quickview"))
          var i = $(
            "#QuickShopModal-" +
              $(this).attr("data-product-id") +
              " .product__quantity input"
          ).val();
        else var i = e.find("#Quantity-bundle").val();
        let n = $(this).attr("data-variant");
        for (
          var r = 0;
          r < $(".bundle__main-header .current__selection-block").length;
          r++
        )
          if (
            !$(".bundle__main-header .current__selection-block")
              .eq(r)
              .hasClass("active")
          ) {
            let o = $(".bundle__main-header .current__selection-block").eq(r);
            o
              .addClass("active")
              .attr("data-variant", n)
              .attr("data-quantity", i),
              o.find(".current__selection-block_empety").hide(),
              o.find(".current__selection-block-image img").attr("src", t),
              o.find(".current__selection-block-image").show();
            break;
          }
        768 >= $(window).width() &&
          ($(window).scrollTop() >= $(".bundle__main-header").outerHeight()
            ? $(".bundle__main-header").addClass("fixed")
            : $(".bundle__main-header").removeClass("fixed")),
          $(".modal__close").click();
      }),
      $(".selected_mark").click(function () {
        $(this).hide(),
          $(this)
            .parent()
            .removeAttr("data-variant")
            .removeAttr("data-quantity")
            .removeClass("active"),
          $(this).parent().find(".current__selection-block_empety").show(),
          $(this).parent().find(".current__selection-block-image").hide();
      }),
      $(".bundle-checkout-btn").click(function () {
        let e = 0,
          t = "",
          i = "";
        $(".current__selection-block.active").each(function () {
          e += parseInt($(this).attr("data-quantity"));
        }),
          3 == e
            ? (t = "BUNDLE10")
            : 4 == e
            ? (t = "BUNDLE15")
            : 5 == e
            ? (t = "BUNDLE20")
            : 6 == e && (t = "BUNDLE25"),
          ("" ==
            (t = $(".current__selection-block.active")
              .eq(e - 1)
              .attr("data-discount")) ||
            void 0 == t) &&
            (i = $(".current__selection-block.active")
              .eq(e - 1)
              .attr("data-product"));
        var n = 0;
        $(".current__selection-block.active").each(function (e) {
          void 0 != $(this).attr("data-variant") && n++;
        }),
          $(".current__selection-block.active").each(function (e) {
            var r = $(this).attr("data-variant");
            void 0 != r &&
              jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !1,
                data: { quantity: 1, id: r },
                dataType: "json",
                success: function () {
                  if (0 == --n) {
                    if ("" != i && void 0 != i) {
                      var e = { quantity: 1, id: i };
                      jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !1,
                        data: e,
                        dataType: "json",
                        success: function () {
                          window.location.href = "/checkout";
                        },
                        error: function () {
                          window.location.href = "/checkout";
                        },
                      });
                    } else
                      void 0 != t && "" != t
                        ? (window.location.href = "/checkout?discount=" + t)
                        : (window.location.href = "/checkout");
                  }
                },
                error: function () {
                  if (0 == --n) {
                    if ("" != i && void 0 != i) {
                      var e = { quantity: 1, id: i };
                      jQuery.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        async: !1,
                        data: e,
                        dataType: "json",
                        success: function () {
                          window.location.href = "/checkout";
                        },
                        error: function () {
                          window.location.href = "/checkout";
                        },
                      });
                    } else
                      void 0 != t && "" != t
                        ? (window.location.href = "/checkout?discount=" + t)
                        : (window.location.href = "/checkout");
                  }
                },
              });
          });
      }),
      768 >= $(window).width() &&
        $(".bundle-main-wrap").css(
          "height",
          $(".bundle__main-header").outerHeight()
        ),
      $(window).on("scroll", function () {
        768 >= $(window).width()
          ? $(window).scrollTop() >= $(".bundle__main-header").outerHeight()
            ? $(".bundle__main-header").addClass("fixed")
            : $(".bundle__main-header").removeClass("fixed")
          : $(window).scrollTop() >=
            $(".bundle__main-header").outerHeight() + 100
          ? $(".bundle__main-header")
              .addClass("fixed")
              .parent()
              .addClass("show-div")
          : $(".bundle__main-header")
              .removeClass("fixed")
              .parent()
              .removeClass("show-div");
      }),
      $(".collection-add").click(function (e) {
        e.preventDefault();
        var t = { quantity: 1, id: $(this).attr("data-id") };
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: !1,
          data: t,
          dataType: "json",
          success: function () {
            document.dispatchEvent(
              new Event("ajaxProduct:added", { bubbles: !0 })
            ),
              setTimeout(function () {
                new theme.Drawers("CartDrawer", "cart").open();
              }, 1e3);
          },
          error: function () {},
        });
      });
  }),
  $(window).width() > 768 &&
    $(".featured-cover-image img").css(
      "height",
      $(".home-featured-collection-wrapper .display-flex").height()
    ),
  $(document).ready(function () {
    $("#description-readMore").click(function () {
      $("html, body").animate(
        {
          scrollTop:
            $("#readMoreDescription").offset().top -
            $("#SiteHeader").height() -
            $("#qab_background").height(),
        },
        1e3
      ),
        $(".Product-content-description-trigger").trigger("click");
    }),
      $(".applicationBtn").click(function () {
        $("html, body").animate(
          {
            scrollTop:
              $("#applicationSection").offset().top - $("#SiteHeader").height(),
          },
          1e3
        );
      }),
      $(".removalBtn").click(function () {
        $("html, body").animate(
          {
            scrollTop:
              $("#removalSection").offset().top - $("#SiteHeader").height(),
          },
          1e3
        );
      }),
      $(".strengthTestBtn").click(function () {
        $("html, body").animate(
          {
            scrollTop:
              $("#strengthTestSection").offset().top -
              $("#SiteHeader").height(),
          },
          1e3
        );
      });
  });
